// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/icomoon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/icomoon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/icomoon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/icomoon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/ok-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/x-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/arrow-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/home-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0-modified | 20110126
   License: none (public domain)
*/
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, img, ins, kbd, q, s, samp,
small, strike, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* make sure to set some focus styles for accessibility */
:focus {
  outline: 0;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

body {
  line-height: 1;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after,
q:before, q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  -webkit-appearance: none;
  -moz-appearance: none;
}

input[type=search] {
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: content-box;
}

textarea {
  overflow: auto;
  vertical-align: top;
  resize: vertical;
}

/**
 * Correct \`inline-block\` display not defined in IE 6/7/8/9 and Firefox 3.
 */
audio,
canvas,
video {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  max-width: 100%;
}

/**
 * Prevent modern browsers from displaying \`audio\` without controls.
 * Remove excess height in iOS 5 devices.
 */
audio:not([controls]) {
  display: none;
  height: 0;
}

/**
 * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.
 * Known issue: no IE 6 support.
 */
[hidden] {
  display: none;
}

/**
 * 1. Correct text resizing oddly in IE 6/7 when body \`font-size\` is set using
 *    \`em\` units.
 * 2. Prevent iOS text size adjust after orientation change, without disabling
 *    user zoom.
 */
html {
  font-size: 100%; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -ms-text-size-adjust: 100%; /* 2 */
}

/**
 * Address \`outline\` inconsistency between Chrome and other browsers.
 */
a:focus {
  outline: thin dotted;
}

/**
 * Improve readability when focused and also mouse hovered in all browsers.
 */
a:active,
a:hover {
  outline: 0;
}

/**
 * 1. Remove border when inside \`a\` element in IE 6/7/8/9 and Firefox 3.
 * 2. Improve image quality when scaled in IE 7.
 */
img {
  border: 0; /* 1 */
  -ms-interpolation-mode: bicubic; /* 2 */
}

/**
 * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.
 */
figure {
  margin: 0;
}

/**
 * Correct margin displayed oddly in IE 6/7.
 */
form {
  margin: 0;
}

/**
 * Define consistent border, margin, and padding.
 */
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
 * 1. Correct color not being inherited in IE 6/7/8/9.
 * 2. Correct text not wrapping in Firefox 3.
 * 3. Correct alignment displayed oddly in IE 6/7.
 */
legend {
  border: 0; /* 1 */
  padding: 0;
  white-space: normal; /* 2 */
  *margin-left: -7px; /* 3 */
}

/**
 * 1. Correct font size not being inherited in all browsers.
 * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,
 *    and Chrome.
 * 3. Improve appearance and consistency in all browsers.
 */
button,
input,
select,
textarea {
  font-size: 100%; /* 1 */
  margin: 0; /* 2 */
  vertical-align: baseline; /* 3 */
  *vertical-align: middle; /* 3 */
}

/**
 * Address Firefox 3+ setting \`line-height\` on \`input\` using \`!important\` in
 * the UA stylesheet.
 */
button,
input {
  line-height: normal;
}

/**
 * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
 * All other form control elements do not inherit \`text-transform\` values.
 * Correct \`button\` style inheritance in Chrome, Safari 5+, and IE 6+.
 * Correct \`select\` style inheritance in Firefox 4+ and Opera.
 */
button,
select {
  text-transform: none;
}

/**
 * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
 *    and \`video\` controls.
 * 2. Correct inability to style clickable \`input\` types in iOS.
 * 3. Improve usability and consistency of cursor style between image-type
 *    \`input\` and others.
 * 4. Remove inner spacing in IE 7 without affecting normal text inputs.
 *    Known issue: inner spacing remains in IE 6.
 */
button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button; /* 2 */
  cursor: pointer; /* 3 */
  *overflow: visible; /* 4 */
}

/**
 * Re-set default cursor for disabled elements.
 */
button[disabled],
html input[disabled] {
  cursor: default;
}

/**
 * 1. Address box sizing set to content-box in IE 8/9.
 * 2. Remove excess padding in IE 8/9.
 * 3. Remove excess padding in IE 7.
 *    Known issue: excess padding remains in IE 6.
 */
input[type=checkbox],
input[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
  *height: 13px; /* 3 */
  *width: 13px; /* 3 */
}

/**
 * 1. Address \`appearance\` set to \`searchfield\` in Safari 5 and Chrome.
 * 2. Address \`box-sizing\` set to \`border-box\` in Safari 5 and Chrome
 *    (include \`-moz\` to future-proof).
 */
input[type=search] {
  -webkit-appearance: textfield; /* 1 */ /* 2 */
  box-sizing: content-box;
}

/**
 * Remove inner padding and search cancel button in Safari 5 and Chrome
 * on OS X.
 */
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * Remove inner padding and border in Firefox 3+.
 */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
 * 1. Remove default vertical scrollbar in IE 6/7/8/9.
 * 2. Improve readability and alignment in all browsers.
 */
textarea {
  overflow: auto; /* 1 */
  vertical-align: top; /* 2 */
}

/**
 * Remove most spacing between table cells.
 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

html,
button,
input,
select,
textarea {
  color: #222;
}

::selection {
  background: #b3d4fc;
  text-shadow: none;
}

img {
  vertical-align: middle;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

textarea {
  resize: vertical;
}

.chromeframe {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-icon-sliders-rotate:before {
  content: "\\e91c";
}

.icon-icon-edit:before {
  content: "\\e917";
}

.icon-green-circle {
  width: 8px;
  height: 8px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
}

.icon-red-circle {
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}

.icon-icon-plus-circle:before {
  content: "\\e916";
}

.icon-icon-upload:before {
  content: "\\e915";
}

.icon-icon-home:before {
  content: "\\e914";
}

.icon-icon-info:before {
  content: "\\e913";
  color: #cbd2e0;
}

.icon-icon-more-horizontal:before {
  content: "\\e90e";
}

.icon-search:before {
  content: "\\e90f";
  color: #a0abc0;
}

.icon-icon-list:before {
  content: "\\e910";
}

.icon-icon-sliders:before {
  content: "\\e911";
}

.icon-icon-file:before {
  content: "\\e912";
}

.icon-icon-folder:before {
  content: "\\e90d";
}

.icon-star-empty:before {
  content: "\\e907";
}

.icon-star-full:before {
  content: "\\e90c";
}

.icon-icon-calendar:before {
  content: "\\e908";
}

.icon-icon-mail:before {
  content: "\\e909";
}

.icon-icon-clock:before {
  content: "\\e90a";
}

.icon-plus-svgrepo-com:before {
  content: "\\e90b";
}

.icon-icon-x:before {
  content: "\\e905";
}

.icon-file-text:before {
  content: "\\e906";
}

.icon-arrow-down:before {
  content: "\\e904";
}

.icon-settings:before {
  content: "\\e900";
}

.icon-placeholder:before {
  content: "\\e901";
}

.icon-copy:before {
  content: "\\e902";
}

.icon-remove:before {
  content: "\\e903";
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.header-wrapper {
  height: 80px;
  width: 100%;
  padding: 24px 30px;
  border-bottom: 1px solid #eaecf0;
  align-items: center;
  justify-content: space-between;
  display: flex;
  position: sticky;
  top: 0;
  z-index: 11;
  background: #fff;
}
.header-wrapper .pageBreadcrumbs {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.header-wrapper .pageBreadcrumbs span {
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  cursor: pointer;
  position: relative;
  margin-right: 8px;
}
.header-wrapper .pageBreadcrumbs span:not(:last-child)::after {
  padding-left: 8px;
  content: ">";
  cursor: auto;
}
.header-wrapper .header-logo {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.16px;
}
.header-wrapper .header-logo img {
  max-width: 280px;
  max-height: 40px;
  object-fit: contain;
}
.header-wrapper .header-left {
  display: flex;
  align-items: center;
}
.header-wrapper .form-builder-header {
  display: flex;
}
.header-wrapper .form-builder-header li {
  margin-left: 32px;
}
.header-wrapper .form-builder-header li.active a {
  color: var(--wf-base-800, #7f56d9);
}
.header-wrapper .form-builder-header li.active a svg * {
  stroke: #7f56d9;
}
.header-wrapper .form-builder-header li.disable {
  pointer-events: none;
}
.header-wrapper .form-builder-header li a {
  text-decoration: none;
  color: var(--wf-base-600, #717d96);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.16px;
  position: relative;
  transition: color 0.25s ease;
  display: flex;
  align-items: center;
}
.header-wrapper .form-builder-header li a svg {
  margin-right: 5px;
}
.header-wrapper .form-builder-header li a svg * {
  stroke: #717d96;
}
.header-wrapper .form-builder-header li a:hover {
  color: var(--wf-base-800, #2d3648);
}
.header-wrapper .form-builder-header li a:hover i:before {
  color: var(--wf-base-800, #2d3648);
}
.header-wrapper .form-builder-header li a:hover svg * {
  stroke: #2d3648;
}
.header-wrapper .form-builder-header li a::before {
  content: "";
  display: block;
  width: 0;
  height: 2px;
  background: var(--wf-base-800, #2d3648);
  position: absolute;
  left: 0;
  top: calc(100% + 12px);
  transition: width 0.25s ease;
}
.header-wrapper .form-builder-header li a i {
  margin-right: 8px;
}

.user-menu-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user-menu-wrapper .user-logo {
  margin-right: 12px;
}
.user-menu-wrapper span {
  display: block;
  color: #2D3648;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.33px;
}
.user-menu-wrapper span.text-secondary {
  color: var(--text-grey-50, #85878F);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.13px;
}
.user-menu .user-dropdown {
  position: relative;
}
.user-menu .user-dropdown-item {
  max-height: 340px;
  overflow-y: auto;
}
.user-menu .user-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  min-width: 260px;
  padding: 16px 0;
}
.user-menu .user-dropdown-menu li {
  padding: 10px 16px 10px 50px;
  position: relative;
  transition: all 0.25s ease;
  margin: 6px 0;
  color: var(--secondary-eading, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.user-menu .user-dropdown-menu li:hover {
  background: #F9F5FF;
}
.user-menu .user-dropdown-menu li::before {
  content: "";
  position: absolute;
  top: 11px;
  left: 16px;
  width: 20px;
  height: 20px;
  border: 1px solid #7F56D9;
  border-radius: 100%;
  transition: all 0.25s ease;
}
.user-menu .user-dropdown-menu li::after {
  content: "";
  position: absolute;
  top: 17px;
  left: 22px;
  width: 10px;
  height: 10px;
  background: #7F56D9;
  border-radius: 100%;
  transition: all 0.25s ease;
  opacity: 0;
}
.user-menu .user-dropdown-menu li.active::after {
  opacity: 1;
}

.sidebar-menu {
  border-right: 1px solid var(--divider, #eaecf0);
  background: var(--secondary-surface, #f9fafb);
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  left: 0;
  top: 80px;
  position: fixed;
}
.sidebar-menu-mini {
  width: 75px;
}
.sidebar-menu-mini .sidebar-menu-link {
  justify-content: center;
}
.sidebar-menu-top {
  margin-top: 24px;
}
.sidebar-menu .sidebar-menu-link {
  display: flex;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 48px;
  height: 48px;
  transition: background 0.25s ease;
}
.sidebar-menu .sidebar-menu-link i {
  color: #2d3648;
}
.sidebar-menu .sidebar-menu-link i.icon-arrow-down {
  transform: rotate(270deg);
}
.sidebar-menu .sidebar-menu-link svg:not(#fi-rs-building):not(#formbuilder) {
  stroke: #98a2b3;
}
.sidebar-menu .sidebar-menu-link #fi-rs-building,
.sidebar-menu .sidebar-menu-link #formbuilder {
  fill: #98a2b3;
}
.sidebar-menu .sidebar-menu-link.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.sidebar-menu .sidebar-menu-link-active, .sidebar-menu .sidebar-menu-link:hover {
  border-radius: var(--corner-radius-main, 8px);
  background: var(--primary-100, #f4ebff);
}
.sidebar-menu .sidebar-menu-link-active svg:not(#fi-rs-building):not(#formbuilder), .sidebar-menu .sidebar-menu-link:hover svg:not(#fi-rs-building):not(#formbuilder) {
  stroke: #7f56d9;
}
.sidebar-menu .sidebar-menu-link-active svg:not(#fi-rs-building):not(#formbuilder) path, .sidebar-menu .sidebar-menu-link:hover svg:not(#fi-rs-building):not(#formbuilder) path {
  stroke: #7f56d9;
}
.sidebar-menu .sidebar-menu-link-active #fi-rs-building,
.sidebar-menu .sidebar-menu-link-active #formbuilder, .sidebar-menu .sidebar-menu-link:hover #fi-rs-building,
.sidebar-menu .sidebar-menu-link:hover #formbuilder {
  fill: #7f56d9;
}
.sidebar-menu .sidebar-menu-bottom {
  border-top: 1px solid #eaecf0;
  padding: 12px 0;
}

.form-builder-layout-full .form-builder-wrapper main.send-page .form-control-actions {
  left: 0;
  width: 100%;
}
.form-builder-layout-full .form-builder-wrapper main.send-page {
  padding-left: 0;
}

.forbidden-page-wrapper .sidebar-menu {
  display: none;
}
.forbidden-page-wrapper .form-builder-wrapper main.default-layout {
  padding-left: 0;
}

.default-layout {
  background: #fff;
}
.default-layout .page-wrapper {
  padding: 32px 40px;
  width: 100%;
}

.forbidden-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.forbidden-page h1 {
  color: var(--secondary-eading, #101828);
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
  text-align: center;
  margin-bottom: 12px;
}
.forbidden-page p {
  color: var(--secondary-text, #667085);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  max-width: 416px;
  margin: 0 auto;
}

.required {
  color: rgb(217, 45, 32);
}

.form-builder-wrapper {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-height: calc(100vh - 80px);
  position: relative;
  background: #f7f9fc;
  overflow-x: hidden;
}
.form-builder-wrapper main.send-page {
  padding-left: 75px;
  width: 100%;
  flex: 0 0 100%;
  max-width: 100%;
  justify-content: center;
  padding-bottom: 150px;
  padding-top: 24px;
}
.form-builder-wrapper main.send-page > div {
  max-width: 1100px;
  width: 100%;
}
.form-builder-wrapper main.send-page .send-form-wrapper {
  justify-content: space-between;
  margin-bottom: 24px;
}
.form-builder-wrapper main.send-page .send-form-title {
  color: var(--secondary-eading, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.form-builder-wrapper main.send-page .send-form-title strong {
  color: var(--secondary-eading, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.form-builder-wrapper main.send-page .render-form {
  max-width: 1100px;
}
.form-builder-wrapper main.send-page .form-control-actions {
  width: calc(100% - 75px);
  left: 75px;
}
.form-builder-wrapper main.send-page .form-control-actions.submit-form-actions {
  width: calc(100% - 80px);
  display: grid;
  grid-template-columns: 1fr auto 1fr;
}
.form-builder-wrapper main.send-page .form-control-actions.submit-form-actions::before {
  display: inline-block;
  content: "";
}
.form-builder-wrapper main.form-builder-wrapper-settings {
  padding-right: 0;
}
.form-builder-wrapper main {
  flex: 1 0 auto;
  width: auto;
  max-width: 100%;
  display: flex;
  min-height: calc(100vh - 80px);
  padding-left: 395px;
  padding-right: 300px;
}
.form-builder-wrapper main.default-layout {
  padding-left: 75px;
  padding-right: 0;
}
.form-builder-wrapper .form-builder-setting-tab {
  padding: 30px 42px;
  background: #fff;
  min-height: 100%;
  display: flex;
}
.form-builder-wrapper .form-builder-setting-tab .react-tabs__tab-panel--selected {
  display: flex;
  height: auto;
  width: 100%;
}
.form-builder-wrapper .form-builder-setting-tab .react-tabs__tab-panel {
  padding: 0;
}
.form-builder-wrapper .form-control-item-settings label {
  display: block;
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.form-builder-wrapper .form-item-title span {
  color: var(--secondary-text, #667085);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 0 !important;
}
.form-builder-wrapper .form-builder-setting-tab-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 996px;
}
.form-builder-wrapper .form-builder-setting-tab-content.w-full {
  max-width: 100%;
}
.form-builder-wrapper .form-builder-setting-tab-content .d-flex {
  display: flex;
  margin-bottom: 30px;
}
.form-builder-wrapper .form-builder-setting-tab-content .d-flex .form-control-radio {
  margin-right: 44px;
}
.form-builder-wrapper .form-builder-setting-tab-content .d-flex .form-control-radio:first-child {
  width: 145px;
}
.form-builder-wrapper .form-builder-setting-tab-content .d-flex .form-control-radio:nth-child(2) {
  width: 145px;
}
.form-builder-wrapper .form-builder-setting-tab-content .select-multy-wrapper {
  position: relative;
}
.form-builder-wrapper .form-builder-setting-tab-content .select-multy-wrapper .select-placeholder {
  position: absolute;
  top: 13px;
  left: 15px;
  z-index: 2;
  pointer-events: none;
  color: #a0abc0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.16px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-control-select .react-select-multi__control {
  height: 48px;
  position: relative;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-control-select .react-select-multi__control .css-1p3m7a8-multiValue {
  display: none;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-control-radio {
  margin-bottom: 0;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings .form-control-item-settings {
  display: flex;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings .form-control-item-settings .form-label-big {
  font-size: 16px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings .form-control-item-group {
  margin-bottom: 28px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings .form-control-item-group .form-control-item-half {
  flex: 0 0 50%;
  max-width: 50%;
  width: 50%;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings.form-init-settings {
  padding-bottom: 80px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings.form-init-settings .form-settings-label {
  width: 604px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings .form-settings-label {
  width: 471px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings .form-settings-label span {
  color: var(--secondary-text, #667085);
  font-size: 14px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings .form-settings-inputs {
  width: 100%;
  padding-left: 24px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-recipient-settings .form-settings-inputs.disabled {
  opacity: 0.6;
  pointer-events: none;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-builder-access-settings {
  max-width: 600px;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-control-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #cbd2e0;
  padding: 28px 0 0;
}
.form-builder-wrapper .form-builder-setting-tab-content .form-control-actions .btn-outline:not(:last-child) {
  margin-right: 18px;
}
.form-builder-wrapper .form-builder-aside-left {
  flex: 0 0 320px;
  max-width: 320px;
  width: 320px;
  background: #fff;
  border-right: 1px solid var(--divider, #eaecf0);
  padding: 20px;
  height: calc(100vh - 80px);
  overflow-y: auto;
  position: fixed;
  top: 80px;
  left: 75px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
}
.form-builder-wrapper .form-builder-aside-left .form-control-item {
  height: 44px;
}
.form-builder-wrapper .form-builder-aside-left.p-0 {
  padding: 0;
}
.form-builder-wrapper .form-builder-aside-left .form-builder-aside-tab {
  width: 100%;
}
.form-builder-wrapper .form-builder-aside-left .form-builder-aside-tab .react-tabs__tab {
  text-align: left;
  justify-content: flex-start;
  padding: 24px;
  color: var(--secondary-eading, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  transition: all 0.25s ease;
  cursor: pointer;
  border-right: 2px solid transparent;
}
.form-builder-wrapper .form-builder-aside-left .form-builder-aside-tab .react-tabs__tab.react-tabs__tab--disabled {
  color: var(--secondary-base, #cbd2e0);
}
.form-builder-wrapper .form-builder-aside-left .form-builder-aside-tab .react-tabs__tab.react-tabs__tab--selected {
  color: var(--wf-base-800, #7f56d9);
  background: var(--wf-base-300, #f4ebff);
  border-right: 2px solid #7f56d9;
}
.form-builder-wrapper .form-builder-aside-left .form-builder-aside-tab .react-tabs__tab::after {
  display: none;
}
.form-builder-wrapper .form-builder-aside-property {
  flex: 0 0 286px;
  max-width: 286px;
  width: 286px;
  background: #fff;
  border-left: 1px solid var(--divider, #eaecf0);
  padding: 20px;
  height: calc(100vh - 80px);
  overflow-y: auto;
  position: fixed;
  top: 80px;
  right: 0;
  transition: all 0.25s ease;
  transform: translateX(100%);
}
.form-builder-wrapper .form-builder-aside-property .form-control-item {
  display: flex;
}
.form-builder-wrapper .form-builder-aside-property .form-control-item .settings-actions {
  padding-left: 16px;
}
.form-builder-wrapper .form-builder-aside-property .form-control-item .btn-remove i {
  position: relative;
  top: auto;
  transform: translate(0, 0);
  right: auto;
}
.form-builder-wrapper .form-builder-aside-property .form-control-item .btn-remove i::before {
  color: #b42318;
}
.form-builder-wrapper .form-builder-aside-property .settings-actions {
  display: flex;
  justify-content: space-between;
}
.form-builder-wrapper .form-builder-aside-property .settings-actions .btn {
  margin-bottom: 0;
}
.form-builder-wrapper .form-builder-aside-property.form-builder-aside-property-open {
  transform: translateX(0);
}
.form-builder-wrapper .form-builder-aside-property .property-item {
  margin-bottom: 24px;
}
.form-builder-wrapper .form-builder-aside-property .property-item .form-control-item.automatic--addition--rows--date .react-datepicker-wrapper {
  display: inline-flex;
}
.form-builder-wrapper .form-builder-aside-property .btn-outline {
  margin-bottom: 8px;
}
.form-builder-wrapper .form-builder-aside-property .text-secondary {
  color: #cbd2e0;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.12px;
  display: block;
}
.form-builder-wrapper .form-builder-aside-property-title {
  color: var(--secondary-eading, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.form-builder-wrapper .form-builder-aside-property-sub-title {
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-builder-wrapper .form-builder-aside-property .tabs-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.form-builder-wrapper .form-builder-aside-property .tabs-nav-item {
  color: var(--wf-base-600, #717d96);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.16px;
  padding: 12px;
  width: 100px;
  position: relative;
}
.form-builder-wrapper .form-builder-aside-property .tabs-nav-item::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) scale(0);
  width: 100%;
  height: 2px;
  background: var(--wf-base-800, #2d3648);
  transition: all 0.25s ease;
}
.form-builder-wrapper .form-builder-aside-property .tabs-nav-item-active {
  color: var(--wf-base-800, #2d3648);
}
.form-builder-wrapper .form-builder-aside-property .tabs-nav-item-active::before {
  transform: translateX(-50%) scale(1);
}
.form-builder-wrapper .form-builder-content {
  flex: 0 0 100%;
  width: 100%;
  max-width: 100%;
  padding: 42px 40px;
}
.form-builder-wrapper .form-builder-drop-area {
  min-height: 550px;
  width: 100%;
  background: #fff;
  box-shadow: 0 8px 25px 0 rgba(45, 54, 72, 0.05);
  border-radius: 8px;
}

.form-builder-element {
  margin-bottom: 14px;
  padding: 12px 5px 12px 12px;
  color: var(--wf-base-800, #2d3648);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.16px;
  border-radius: 6px;
  border: 1px solid var(--wf-base-400, #cbd2e0);
  background: var(--wf-base-white, #fff);
  width: calc(50% - 8px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.form-builder-element-title {
  color: #cbd2e0;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  margin-bottom: 16px;
}

.drop-area {
  width: 100%;
  min-height: 550px;
  border: 2px dashed transparent;
}
.drop-area-active {
  border: 2px dashed var(--wf-base-400, #cbd2e0);
}
.drop-area .form-builder-item {
  display: block;
  width: 100%;
}

.form-builder-element-preview {
  max-width: 100%;
  border-radius: 8px;
  border: 1px dashed transparent;
  padding: 24px;
  transition: border 0.25s ease;
  position: relative;
}
.form-builder-element-preview:not(.from-builder-title) {
  min-height: 134px;
}
.form-builder-element-preview-drag {
  opacity: 0;
}
.form-builder-element-preview:hover {
  border: 1px dashed var(--primary-500, #9e77ed);
}
.form-builder-element-preview:hover .form-builder-element-preview-action .btn.btn-icon {
  opacity: 1;
}
.form-builder-element-preview-action {
  position: absolute;
  left: 100%;
  padding-left: 6px;
  top: 50%;
  transform: translateY(-50%);
}
.form-builder-element-preview-action .btn.btn-icon {
  border-radius: 6px;
  opacity: 0;
  transition: all 0.25s ease;
}
.form-builder-element-preview-action .btn.btn-icon.btn-settings {
  border: 1px solid var(--secondary-input-outline, #dadee4);
  background: #fff;
  padding: 8px;
  margin-bottom: 6px;
}
.form-builder-element-preview-action .btn.btn-icon.btn-settings i {
  font-size: 20px;
}
.form-builder-element-preview-action .btn.btn-icon.btn-settings i:before {
  color: #667085;
}
.form-builder-element-preview-action .btn.btn-icon.btn-remove {
  border: 1px solid var(--secondary-input-outline, #fda29b);
  background: #fff;
  padding: 8px;
}
.form-builder-element-preview-action .btn.btn-icon.btn-remove i {
  font-size: 20px;
}
.form-builder-element-preview-action .btn.btn-icon.btn-remove i:before {
  color: #b42318;
}
.form-builder-element-preview-action-active .btn.btn-icon {
  opacity: 1;
}

.from-builder-title {
  padding: 30px;
}
.from-builder-title h1 {
  margin-bottom: 0;
  color: var(--wf-base-800, #2d3648);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
}
.from-builder-title h1 i {
  margin-right: 14px;
}

.additional-dropdown {
  margin-bottom: 20px;
}

.info-text {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  color: var(--wf-base-800, #2d3648);
  display: flex;
  align-items: center;
  margin-bottom: 28px;
  max-width: 600px;
}
.info-text i {
  font-size: 24px;
  margin-right: 12px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: var(--primary-50, #f9f5ff);
  border-bottom: 1px solid var(--divider, #eaecf0);
  color: #7f56d9;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 127.273% */
  letter-spacing: 0.03px;
}

.avatar-group {
  display: flex;
  align-items: center;
  margin-left: 8px;
  margin-right: 8px;
}
.avatar-group .avatar {
  margin-right: 0 !important;
  margin-left: -8px;
}

.react-tabs__tab.react-tabs__tab--disabled {
  color: var(--secondary-base, #cbd2e0);
}

.instructions {
  color: var(--secondary-text, #667085);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 10px;
  display: block;
}

.init-page .form-builder-setting-tab.bg-transparent {
  background: transparent;
  padding: 0;
}
.init-page .react-tabs__tab-panel {
  width: 100%;
}
.init-page .init-form-tab {
  width: 100%;
  height: 100%;
}
.init-page .init-form-action {
  max-width: 1100px;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
}
.init-page .init-form-tab-content {
  width: 100%;
  padding: 24px 15px 150px;
}
.init-page .form-control-actions {
  border-top: 1px solid var(--divider, #eaecf0);
  width: calc(100% - 395px);
  display: flex;
  justify-content: flex-end;
  padding: 32px 40px;
  background: #fff;
  position: fixed;
  bottom: 0;
  z-index: 9;
}
.init-page .form-control-actions .btn {
  display: inline-flex;
  align-items: center;
}
.init-page .form-control-actions .btn-outline:not(:last-child) {
  margin-right: 18px;
}
.init-page .render-form {
  border-radius: 8px;
  border: 1px solid var(--divider, #eaecf0);
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  max-width: 1100px;
  margin: 0 auto;
}
.init-page .render-form .form-builder-element-preview:hover {
  border-color: transparent;
}
.init-page .render-form .form-builder-element-preview-table {
  pointer-events: auto !important;
}
.init-page .render-form .form-builder-element-preview-wrapper .form-grid-item,
.init-page .render-form .form-builder-element-preview-wrapper .react-ios-time-picker-main,
.init-page .render-form .form-builder-element-preview-wrapper select,
.init-page .render-form .form-builder-element-preview-wrapper .form-control,
.init-page .render-form .form-builder-element-preview-wrapper .form-control-checkbox,
.init-page .render-form .form-builder-element-preview-wrapper .form-control-radio,
.init-page .render-form .form-builder-element-preview-wrapper .sigCanvas,
.init-page .render-form .form-builder-element-preview-wrapper .btn-signature {
  pointer-events: auto;
}
.init-page .render-form__copy-group {
  margin-bottom: 24px;
  position: relative;
  outline: 1px dashed #cbd2e0;
}
.init-page .render-form__copy-group__remove-btn {
  top: 50%;
  right: -44px;
  width: 38px;
  height: 38px;
  justify-content: center;
  background: #fff !important;
  position: absolute;
  transform: translateY(-50%);
  border: 1px solid var(--secondary-input-outline, #fda29b) !important;
  z-index: 1;
}
.init-page .render-form__copy-group__remove-btn .label {
  display: none;
}

.init-page .form-view-wrapper {
  position: relative;
  max-width: 1100px;
  margin: 0 auto;
}
.init-page .form-view-wrapper .form-view-actions {
  border-top: var(--outline, 1px) solid var(--Secondary-Input-Outline, #dadee4);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 24px;
}
.init-page .form-view-wrapper .form-view-actions .btn {
  min-width: 137px;
}
.init-page .form-view-wrapper .render-form {
  padding-bottom: 100px;
}

.general-form-tab-content .form-builder-element-preview-wrapper {
  pointer-events: auto !important;
}

.ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-wrapper {
  pointer-events: none !important;
}
.ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-login .add-facility {
  display: none;
}
.ReactModal__Overlay .modal-default.print-modal .table-form-builder-element-preview .form-builder-element-preview-wrapper {
  pointer-events: auto !important;
}

.from-builder-title-setting {
  padding: 0;
  margin-bottom: 32px;
}

.form-readonlyy .sigCanvas {
  pointer-events: none !important;
}

.form-readonlyy.form-builder-element-preview-file-upload {
  pointer-events: auto !important;
}
.form-readonlyy.form-builder-element-preview-file-upload .btn.btn-icon {
  display: none;
}

.share-with-company .from-builder-title-setting {
  max-width: 696px;
  margin: 40px auto -24px;
}

.init-page .form-control-actions.form-init-content {
  width: calc(100% - 395px);
  padding: 32px 42px;
  transform: translateX(-42px);
  justify-content: flex-start;
}
.init-page .form-control-actions.form-init-content > div {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.init-page .form-control-actions.form-init-content > div .btn-outline-secondary {
  margin-right: 0;
}

.print {
  border: 6px;
  background: #fff;
}
.print .html-area {
  padding: 34px;
}
.print .html-area img {
  max-width: 100%;
}
.print .form-builder-element-preview {
  border: 0 solid transparent;
  padding: 12px 24px;
}
.print .form-builder-element-preview .required {
  display: none;
}
.print .sigCanvas-clear {
  display: none;
}

.form-builder-recipient-settings-init {
  padding: 30px;
}

.form-builder-wrapper .form-builder-setting-tab.p-0 {
  padding: 0;
}

.file-upload.library-item {
  min-width: 250px;
  margin: 0;
}

.btn-attach {
  margin: 10px 0;
  display: inline-block;
  cursor: pointer;
}

.modal-tabs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
}
.modal-tabs .btn-tab {
  height: 73px;
  width: 50%;
  border: 0;
  background: #ffffff;
  color: var(--Secondary-eading, #101828);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-radius: 8px 8px 0 0;
  position: relative;
}
.modal-tabs .btn-tab::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--Primary-700, #6941c6);
  transform: scale(0);
  transition: all 0.25s ease;
}
.modal-tabs .btn-tab.btn-tab-active {
  color: var(--Primary-700, #6941c6);
}
.modal-tabs .btn-tab.btn-tab-active::before {
  transform: scale(1);
}

.ReactModal__Overlay .modal-default.modal-with-tabs {
  padding-top: 105px;
}
.ReactModal__Overlay .modal-default.modal-with-tabs .library {
  padding: 0;
  background: transparent;
}
.ReactModal__Overlay .modal-default.modal-with-tabs .library .breadcrumbs-item {
  font-size: 13px;
  line-height: 13px;
}
.ReactModal__Overlay .modal-default.modal-with-tabs .library .breadcrumbs-item::after {
  top: -4px;
}
.ReactModal__Overlay .modal-default.modal-with-tabs .library .library-item {
  max-width: calc(33.333% - 16px);
}
.ReactModal__Overlay .modal-default.modal-with-tabs .library .library-item.library-item-active {
  background: linear-gradient(0deg, rgba(127, 86, 217, 0.12) 0%, rgba(127, 86, 217, 0.12) 100%), var(--on-primary, #fff);
}

.btn-signature {
  width: 100%;
  height: 40px !important;
}

.ReactModal__Overlay .modal-default.print-modal {
  padding-bottom: 32px;
  max-width: 800px;
}
.ReactModal__Overlay .modal-default.print-modal .form-control-table-wrapper-print td,
.ReactModal__Overlay .modal-default.print-modal .form-control-table-wrapper-print th {
  border: 1px solid #eaecf0;
  padding: 5px;
  word-break: break-word;
}
.ReactModal__Overlay .modal-default.print-modal .form-control-table-wrapper-print .form-control {
  padding: 0;
  border-radius: 0;
  border: 0;
}
.ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-file-attach,
.ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-file-attach .form-builder-element-preview-wrapper,
.ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-file-upload,
.ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-file-upload .form-builder-element-preview-wrapper {
  pointer-events: auto !important;
}
.ReactModal__Overlay .modal-default.print-modal .form-control-file {
  pointer-events: none;
}
.ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-wrapper .btn {
  display: none;
}
.ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview:not(.from-builder-title) {
  min-height: auto;
}
@media print {
  .ReactModal__Overlay .modal-default.print-modal {
    width: 100%;
    max-width: 100%;
    padding: 0;
  }
  .ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-file-attach,
  .ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview-file-upload {
    display: none !important;
  }
  .ReactModal__Overlay .modal-default.print-modal .form-control-select .react-select__control {
    border: 0;
  }
  .ReactModal__Overlay .modal-default.print-modal .react-select__indicators,
  .ReactModal__Overlay .modal-default.print-modal .react-select__placeholder {
    display: none !important;
  }
  .ReactModal__Overlay .modal-default.print-modal .form-builder-element-preview {
    min-height: auto;
    padding: 6px;
  }
  .ReactModal__Overlay .modal-default.print-modal .optional {
    display: none;
  }
  .ReactModal__Overlay .modal-default.print-modal .form-control {
    padding: 0;
    border: 0;
    height: auto;
  }
  .ReactModal__Overlay .modal-default.print-modal .modal-header {
    display: none !important;
  }
  .ReactModal__Overlay .modal-default.print-modal .from-builder-title {
    padding: 15px;
  }
}

@media print {
  #root {
    display: none;
  }
  .ReactModal__Overlay {
    padding: 0 !important;
    position: relative !important;
  }
}
.success-page {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 40px;
  width: 100%;
}
.success-page img {
  margin-bottom: 14px;
}
.success-page h2 {
  color: var(--Secondary-eading, #101828);
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 12px;
}
.success-page p {
  color: var(--Secondary-Text, #667085);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  max-width: 375px;
}

.library-filter .btn.btn-file {
  padding: 10px 12px 8px;
}

.init-page .form-builder-element-preview:not(.from-builder-title) {
  min-height: auto;
}
.init-page .form-builder-element-preview-login .add-facility {
  display: none;
}
.init-page .form-builder-element-preview-login.show-button .add-facility {
  display: block;
  pointer-events: auto;
}
.init-page .share-with-company {
  background: #f7f9fc;
  padding: 0 24px;
}
.init-page .share-with-company .init-form-tab-content {
  padding: 0;
  max-width: 696px;
  margin: 40px auto;
  background: #fff;
  border-radius: 8px;
  border: 1px solid var(--divider, #eaecf0);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
}
.init-page .share-with-company .init-form-tab-content .share-with-company-header {
  padding: 16px 24px;
  border-bottom: 1px solid var(--divider, #eaecf0);
}
.init-page .share-with-company .init-form-tab-content .share-with-company-footer {
  padding: 16px 24px;
  border-top: 1px solid var(--divider, #eaecf0);
  display: flex;
  justify-content: space-between;
}
.init-page .share-with-company .init-form-tab-content .share-with-company-body {
  padding: 16px 24px;
}

.report-builder {
  display: flex;
  width: 100%;
  background: var(--Secondary-surface, #f9fafb);
}
.report-builder .report-builder-aside {
  flex: 0 0 435px;
  max-width: 435px;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 24px;
}
.report-builder .report-builder-aside .result .result-title {
  color: var(--Primary-600, #7f56d9);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin-top: 14px;
  margin-bottom: 4px;
}
.report-builder .report-builder-aside .result .result-item {
  display: flex;
  align-items: center;
  color: var(--Secondary-eading, #101828);
  font-feature-settings: "calt" off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 8px;
}
.report-builder .report-builder-aside .result .result-list {
  max-height: 200px;
  overflow-y: auto;
}
.report-builder .report-builder-aside .result .result-list svg {
  cursor: pointer;
}
.report-builder .report-builder-aside .title {
  color: var(--Secondary-eading, #101828);
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 23px;
}
.report-builder .report-builder-aside .btn {
  display: flex;
  align-items: center;
  margin: 0 auto;
}
.report-builder .report-builder-aside .form-item-wrapper {
  position: relative;
}
.report-builder .report-builder-aside .form-item-wrapper .form-control {
  padding-right: 45px;
}
.report-builder .report-builder-aside .form-item-wrapper .icon-search {
  position: absolute;
  top: 10px;
  right: 12px;
}
.report-builder .ql-container {
  border: 1px solid var(--Secondary-Input-Outline, #dadee4);
  background: var(--On-Primary, #fff);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  border-radius: var(--Corner-radius-main, 8px);
  padding: 32px;
}
.report-builder .ql-container .ql-editor {
  padding: 0;
}
.report-builder .ql-toolbar {
  border: 1px solid var(--Secondary-Input-Outline, #dadee4);
  background: var(--On-Primary, #fff);
}
.report-builder .report-builder-editor {
  max-width: 797px;
  margin: 0 auto;
}
.report-builder .report-builder-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.report-builder .report-builder-header .actions {
  display: flex;
}
.report-builder .report-builder-header .btn-outline {
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.report-builder .report-builder-header h3 {
  color: var(--Secondary-eading, #101828);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.report-builder .report-builder-empty {
  border-radius: 8px;
  border: 1px solid var(--divider, #eaecf0);
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  padding: 40px 32px;
  max-width: 797px;
  margin: 0 auto;
}
.report-builder .report-builder-empty h3 {
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 24px;
  text-align: center;
}
.report-builder .report-builder-empty p {
  color: var(--Secondary-Text, #667085);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  max-width: 352px;
  margin: 0 auto;
}
.report-builder .report-builder-content {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% - 435px);
  max-width: calc(100% - 435px);
  width: calc(100% - 435px);
  padding: 40px;
}

.btn-preview {
  display: inline-flex;
  align-items: center;
  margin-right: 24px;
}

.modal-open {
  overflow: hidden;
  max-height: calc(100vh - 80px);
}

.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f7f9fc;
  z-index: 9999;
  overflow-y: auto;
}
.preview-modal.init-page .render-form .form-builder-element-preview-wrapper .form-control {
  pointer-events: none !important;
}
.preview-modal .preview-modal-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0;
  color: var(--Secondary-eading, #101828);
  /* Input Label */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.preview-modal .preview-modal-actions .btn-orientation {
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 6px;
  border: 1px solid var(--Primary-300, #d6bbfb);
  opacity: var(--outline, 1);
  width: 32px;
  height: 32px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), var(--On-Primary, #fff);
}
.preview-modal .preview-modal-actions .btn-orientation.active {
  border-radius: 6px;
  border: 1px solid var(--Primary-300, #d6bbfb);
  opacity: var(--outline, 1);
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), var(--Primary-100, #f4ebff);
}
.preview-modal .send-form {
  position: relative;
}
.preview-modal .render-form {
  box-shadow: none;
  border: 0;
}
.preview-modal .form-control-actions {
  position: absolute;
  width: 100%;
  justify-content: space-between;
  padding: 24px;
}
.preview-modal .form-view-wrapper-desktop .preview-modal-actions {
  display: none;
}
.preview-modal .form-view-wrapper-phone .send-form-wrapper {
  border-radius: 30px;
  border: 20px solid var(--divider, #eaecf0);
  opacity: var(--outline, 1);
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  height: 600px;
  overflow-y: auto;
  width: 360px;
  margin: 0 auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.06) rgba(0, 0, 0, 0.01);
}
.preview-modal .form-view-wrapper-phone .send-form-wrapper .form-control,
.preview-modal .form-view-wrapper-phone .send-form-wrapper .form-control-select {
  width: 100%;
}
.preview-modal .form-view-wrapper-phone .send-form-wrapper .form-control-checkbox-wrapper {
  flex-wrap: wrap;
  flex-direction: column;
  max-height: 100%;
}
.preview-modal .form-view-wrapper-phone .send-form-wrapper .form-control-checkbox-wrapper .form-control-checkbox {
  width: 100%;
}
.preview-modal .form-view-wrapper-phone .send-form-wrapper.send-form-wrapper-horizontal {
  width: 600px;
  height: 360px;
}
.preview-modal .form-view-wrapper-phone .send-form-wrapper::-webkit-scrollbar {
  width: 7px;
}
.preview-modal .form-view-wrapper-phone .send-form-wrapper::-webkit-scrollbar-track {
  border-radius: 40px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.01);
}
.preview-modal .form-view-wrapper-phone .send-form-wrapper::-webkit-scrollbar-thumb {
  border-radius: 40px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.06);
}
.preview-modal .form-view-wrapper-phone .from-builder-title {
  border-bottom: var(--outline, 1px) solid var(--divider, #eaecf0);
}
.preview-modal .form-view-wrapper-tablet .send-form-wrapper-vertical .send-form {
  min-height: 100%;
}
.preview-modal .form-view-wrapper-tablet .send-form-wrapper-horizontal .send-form {
  min-height: calc(100% + 50px);
}
.preview-modal .form-view-wrapper-tablet .send-form-wrapper {
  border-radius: 30px;
  border: 20px solid var(--divider, #eaecf0);
  opacity: var(--outline, 1);
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  height: 1133px;
  overflow-y: auto;
  width: 744px;
  margin: 0 auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.06) rgba(0, 0, 0, 0.01);
}
.preview-modal .form-view-wrapper-tablet .send-form-wrapper.send-form-wrapper-horizontal {
  width: 1133px;
  height: 744px;
  background: #f7f9fc;
}
.preview-modal .form-view-wrapper-tablet .send-form-wrapper.send-form-wrapper-horizontal .send-form {
  max-width: 744px;
  margin: 40px auto;
}
.preview-modal .form-view-wrapper-tablet .send-form-wrapper::-webkit-scrollbar {
  width: 7px;
}
.preview-modal .form-view-wrapper-tablet .send-form-wrapper::-webkit-scrollbar-track {
  border-radius: 40px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.01);
}
.preview-modal .form-view-wrapper-tablet .send-form-wrapper::-webkit-scrollbar-thumb {
  border-radius: 40px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.06);
}
.preview-modal .form-view-wrapper-tablet .from-builder-title {
  border-bottom: var(--outline, 1px) solid var(--divider, #eaecf0);
}
.preview-modal .form-view-wrapper {
  margin: 40px auto;
}
.preview-modal .header-center {
  display: flex;
}
.preview-modal .tabs-nav-item {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--Secondary-Text, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  position: relative;
  padding: 0 24px;
  cursor: pointer;
  margin: 0 16px;
}
.preview-modal .tabs-nav-item::before {
  content: "";
  position: absolute;
  top: 48px;
  left: 0;
  width: 100%;
  background: var(--Primary-700, #6941c6);
  height: 1px;
  opacity: 0;
}
.preview-modal .tabs-nav-item.tabs-nav-item-active {
  color: var(--Primary-700, #6941c6);
}
.preview-modal .tabs-nav-item.tabs-nav-item-active::before {
  opacity: 1;
}
.preview-modal .tabs-nav-item.tabs-nav-item-active svg path {
  stroke: rgb(127, 86, 217);
}
.preview-modal .tabs-nav-item svg {
  margin-right: 8px;
}
.preview-modal .tabs-nav-item svg path {
  stroke: rgb(102, 112, 133);
}

.ReactModal__Overlay .modal-default.modal-reset {
  max-width: 441px;
}
.ReactModal__Overlay .modal-default.modal-reset .login-page {
  margin: 0;
}
.ReactModal__Overlay .modal-default.modal-reset .form-control-item {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
}
.ReactModal__Overlay .modal-default.modal-reset .form-control-item:last-child {
  margin-bottom: 0;
}

.dropdown-menu .btn {
  text-align: left;
}

.company-profile-header-action .btn {
  line-height: 1.2;
}

.btn {
  padding: 10px 18px;
  font-size: 16px;
  color: #fff;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.16px;
  border-radius: 6px;
  background: #7F56D9;
  border: 2px solid var(--wf-base-800, #7F56D9);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  text-decoration: none;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}
.btn:hover, .btn:active {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0.21) 100%), var(--primary-600, #7F56D9);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  border: 2px solid var(--primary-600, #9A7AE1);
}
.btn:active {
  box-shadow: none !important;
}
.btn[disabled] {
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36)) !important;
  background: var(--secondary-outline, rgba(152, 162, 179, 0.36)) !important;
  box-shadow: none !important;
  color: #101828 !important;
}
.btn[disabled] i:before {
  color: #101828 !important;
}
.btn i:before {
  color: #fff;
}
.btn.btn-white {
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  border: 1px solid var(--gray-300, #D0D5DD);
  color: var(--secondary-eading, #101828);
}
.btn.btn-white i::before {
  color: var(--secondary-eading, #101828);
}
.btn.btn-danger {
  border: 1px solid var(--tertiary-100, #D92D20);
  background: var(--on-primary, #D92D20);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  color: #fff;
  display: flex;
  align-items: center;
}
.btn.btn-danger i:before {
  color: #fff;
}
.btn.btn-danger svg * {
  stroke: #fff !important;
}
.btn.btn-danger:hover {
  background: #fff;
  color: #D92D20;
}
.btn.btn-danger:hover i:before {
  color: #D92D20;
}
.btn.btn-danger:hover svg * {
  stroke: #D92D20 !important;
}
.btn.btn-text {
  background: var(--on-primary, #FFF);
  border: 0;
  color: #101828;
  height: 41px;
  box-shadow: none;
  transition: all 0.25s ease;
}
.btn.btn-text.btn-text-primary {
  color: #7F56D9;
  font-weight: 600;
}
.btn.btn-text.btn-text-primary i:before {
  color: #7F56D9;
  transition: all 0.25s ease;
}
.btn.btn-text:hover {
  box-shadow: none;
  background: linear-gradient(0deg, rgba(127, 86, 217, 0.12) 0%, rgba(127, 86, 217, 0.12) 100%), var(--on-primary, #FFF);
}
.btn.btn-text i:before {
  color: #2D3648;
  transition: all 0.25s ease;
}
.btn.btn-text.btn-success {
  border: 1px solid #12B76A;
  background: var(--on-primary, #FFF);
  box-shadow: none;
  color: #12B76A;
}
.btn.btn-text.btn-success i:before {
  color: #12B76A;
}
.btn.btn-text.btn-success:hover {
  background: #12B76A;
  color: #fff;
}
.btn.btn-text.btn-success:hover i:before {
  color: #fff;
}
.btn.btn-text.btn-success:hover svg * {
  stroke: #fff !important;
}
.btn.btn-text.btn-danger {
  border: 0;
  background: var(--on-primary, #FFF);
  box-shadow: none;
  color: #D92D20;
}
.btn.btn-text.btn-danger i:before {
  color: #D92D20;
}
.btn.btn-text.btn-danger svg * {
  stroke: #D92D20 !important;
}
.btn.btn-text.btn-danger:hover {
  background: #D92D20;
  color: #fff;
}
.btn.btn-text.btn-danger:hover i:before {
  color: #fff;
}
.btn.btn-text.btn-danger:hover svg * {
  stroke: #fff !important;
}
.btn.btn-text[disabled] {
  border: 0;
  background: var(--secondary-outline, rgba(152, 162, 179, 0.36));
}
.btn.btn-outline {
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
  background: var(--on-primary, #FFF);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  transition: all 0.25s ease;
  color: #101828;
  height: 41px;
}
.btn.btn-outline.btn-down {
  transform: translateY(2px);
}
.btn.btn-outline.btn-down svg {
  transform: translateY(2px);
}
.btn.btn-outline.btn-outline-secondary {
  border: 1px solid #9E77ED;
  color: #7F56D9;
}
.btn.btn-outline.btn-filter i::before {
  color: #101828;
}
.btn.btn-outline.btn-active {
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
  background: linear-gradient(0deg, rgba(127, 86, 217, 0.12) 0%, rgba(127, 86, 217, 0.12) 100%), var(--on-primary, #FFF);
  box-shadow: 0 2px 5px 0 rgba(16, 24, 40, 0.2);
}
.btn.btn-outline.btn-active i:before {
  color: var(--primary-600, #7F56D9);
}
.btn.btn-outline.btn-active svg * {
  fill: var(--primary-600, #7F56D9);
}
.btn.btn-outline.btn-edit {
  padding: 8px 20px;
}
.btn.btn-outline.btn-edit i:before {
  font-size: 24px;
}
.btn.btn-outline.btn-success {
  border: 1px solid var(--secondary-outline, #12B76A);
  background: var(--on-primary, #FFF);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  color: #12B76A;
  display: flex;
  align-items: center;
}
.btn.btn-outline.btn-success i:before {
  color: #12B76A;
}
.btn.btn-outline.btn-success:hover {
  background: #12B76A;
  color: #fff;
}
.btn.btn-outline.btn-success:hover i:before {
  color: #fff;
}
.btn.btn-outline.btn-success:hover svg * {
  stroke: #fff !important;
}
.btn.btn-outline.btn-danger {
  border: 1px solid var(--tertiary-100, #D92D20);
  background: var(--on-primary, #FFF);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  color: #D92D20;
  display: flex;
  align-items: center;
}
.btn.btn-outline.btn-danger i:before {
  color: #D92D20;
}
.btn.btn-outline.btn-danger svg * {
  stroke: #D92D20 !important;
}
.btn.btn-outline.btn-danger:hover {
  background: #D92D20;
  color: #fff;
}
.btn.btn-outline.btn-danger:hover i:before {
  color: #fff;
}
.btn.btn-outline.btn-danger:hover svg * {
  stroke: #fff !important;
}
.btn.btn-outline i:before {
  color: #2D3648;
  transition: all 0.25s ease;
}
.btn.btn-outline:hover, .btn.btn-outline:active {
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
  background: linear-gradient(0deg, rgba(127, 86, 217, 0.12) 0%, rgba(127, 86, 217, 0.12) 100%), var(--on-primary, #FFF);
  box-shadow: 0 2px 5px 0 rgba(16, 24, 40, 0.2);
}
.btn.btn-outline[disabled] {
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
  background: var(--secondary-outline, rgba(152, 162, 179, 0.36));
}
.btn.btn-icon {
  padding: 0;
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  box-shadow: none !important;
}
.btn.btn-icon i:before {
  color: #2D3648;
}
.btn.btn-icon.btn-remove i {
  position: relative;
  top: auto;
  transform: translate(0, 0);
  right: auto;
}
.btn.btn-icon.btn-remove i::before {
  color: #B42318;
}
.btn.btn-wide {
  padding-left: 32px;
  padding-right: 32px;
}
.btn.btn-remove {
  display: inline-flex;
  border: 0;
  align-items: center;
  color: var(--tertiary-600, #B42318);
  background-color: transparent;
}
.btn.btn-remove i::before {
  color: var(--tertiary-600, #B42318);
}

.btn-link {
  background: transparent;
  border: 0;
  padding: 0;
  color: var(--primary-600, #7F56D9);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.btn-link i {
  margin-right: 10px;
}

.btn-left {
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.btn-full {
  width: 100%;
}

.btn.btn-outline.btn-save {
  display: flex;
  align-items: center;
  color: #7F56D9;
  border: 1px solid #7F56D9;
}
.btn.btn-outline.btn-save svg {
  margin-right: 5px;
  margin-top: -1px;
}

.form-radio-button {
  position: relative;
  display: inline-block;
}
.form-radio-button input {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
.form-radio-button input:checked + span {
  background: var(--primary-100, #f4ebff);
  color: var(--primary-700, #6941c6);
  border: 1px solid var(--primary-300, #d6bbfb);
}
.form-radio-button span {
  display: inline-block;
  padding: 8px 11px;
  color: var(--primary-700, #6941c6);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.16px;
  border-radius: 8px;
  border: 1px solid var(--primary-500, #9e77ed);
  z-index: -1;
  cursor: pointer;
}

.form-group {
  display: flex;
  justify-content: space-between;
}

.form-grid-full-name {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}
.form-grid-full-name-small {
  width: 50%;
}
.form-grid-full-name-medium {
  width: 75%;
}
.form-grid-full-name-large {
  width: 100%;
}

.form-switcher {
  position: relative;
}
.form-switcher input {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
.form-switcher input:checked + span {
  color: var(--wf-base-800, #2d3648);
}
.form-switcher input:checked + span::before {
  background: var(--primary-600, #7f56d9);
  border: 1px solid var(--wf-base-800, #7f56d9);
}
.form-switcher input:checked + span::after {
  background: var(--primary-600, #fff);
  left: 19px;
}
.form-switcher span {
  color: var(--wf-base-800, #717d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
  position: relative;
  padding-left: 52px;
  transition: all 0.25s ease;
}
.form-switcher span::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 40px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid var(--wf-base-800, #717d96);
  transition: all 0.25s ease;
}
.form-switcher span::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 6px;
  width: 19px;
  height: 19px;
  background: #717d96;
  border-radius: 100%;
  transition: all 0.25s ease;
}

textarea.form-control {
  height: auto;
  min-height: 130px;
}

.form-control,
.react-ios-time-picker-input {
  border-radius: 6px;
  border: 1px solid var(--wf-base-400, #cbd2e0);
  background: var(--wf-base-white, #fff);
  height: 44px;
  padding: 12px 12px 12px 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
  color: #2d3648;
  width: 100%;
}
.form-control::placeholder,
.react-ios-time-picker-input::placeholder {
  color: #98a2b3;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
  opacity: 0.5;
}
.form-control:disabled,
.react-ios-time-picker-input:disabled {
  background-color: hsl(0, 0%, 95%);
}
.form-control-small,
.react-ios-time-picker-input-small {
  width: 50%;
}
.form-control.form-control-clicks-small,
.react-ios-time-picker-input.form-control-clicks-small {
  width: 200px;
  margin-top: 5px;
}
.form-control-medium,
.react-ios-time-picker-input-medium {
  width: 75%;
}
.form-control-large,
.react-ios-time-picker-input-large {
  width: 100%;
}
.form-control-item,
.react-ios-time-picker-input-item {
  margin-bottom: 24px;
  position: relative;
}
.form-control-item.form-control-item-login,
.react-ios-time-picker-input-item.form-control-item-login {
  display: flex;
  flex-direction: column;
}
.form-control-item.form-control-item-login.alignment-left,
.react-ios-time-picker-input-item.form-control-item-login.alignment-left {
  align-items: flex-start;
}
.form-control-item.form-control-item-login.alignment-right,
.react-ios-time-picker-input-item.form-control-item-login.alignment-right {
  align-items: flex-end;
}
.form-control-item.form-control-item-login.alignment-center,
.react-ios-time-picker-input-item.form-control-item-login.alignment-center {
  align-items: center;
}
.form-control-item i,
.react-ios-time-picker-input-item i {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.form-control-item i.icon-search,
.react-ios-time-picker-input-item i.icon-search {
  font-size: 24px;
}
.form-control-item.form-control-item-with-type-dropdown .btn-dropdown i,
.react-ios-time-picker-input-item.form-control-item-with-type-dropdown .btn-dropdown i {
  right: 40px;
}
.form-control::placeholder,
.react-ios-time-picker-input::placeholder {
  color: #717d96;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
}

.form-label {
  color: var(--wf-base-800, #2d3648);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.14px;
  margin-bottom: 8px;
  display: block;
  justify-content: space-between;
  white-space: break-spaces;
}
.form-label-big {
  font-size: 18px;
  margin-bottom: 16px;
}
.form-label .optional {
  color: var(--secondary-dark, #101828);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  float: right;
  padding-left: 15px;
}

.form-builder-element-preview-wrapper .form-grid-item,
.form-builder-element-preview-wrapper .react-ios-time-picker-main,
.form-builder-element-preview-wrapper select,
.form-builder-element-preview-wrapper .form-control-checkbox,
.form-builder-element-preview-wrapper .form-control-radio,
.form-builder-element-preview-wrapper .sigCanvas {
  pointer-events: none;
}

.form-control-radio-wrapper,
.form-control-checkbox-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.form-control-radio-wrapper.center,
.form-control-checkbox-wrapper.center {
  justify-content: center;
}

.form-control-radio {
  position: relative;
  margin-bottom: 15px;
}
.form-control-radio.center, .form-control-radio.right {
  display: flex;
  align-items: center;
}
.form-control-radio.center {
  justify-content: center;
}
.form-control-radio.right {
  justify-content: flex-end;
}
.form-control-radio:not(.element) input {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
.form-control-radio:not(.element) input:checked + span {
  color: var(--wf-base-800, #2d3648);
}
.form-control-radio:not(.element) input:checked + span::before {
  border: 1px solid var(--wf-base-800, #7f56d9);
}
.form-control-radio:not(.element) input:checked + span::after {
  background: #7f56d9;
}
.form-control-radio:not(.element) input:disabled {
  cursor: default;
}
.form-control-radio:not(.element) input:disabled + span {
  opacity: 0.6 !important;
  pointer-events: none;
}
.form-control-radio:not(.element) span {
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  position: relative;
  padding-left: 30px;
  transition: all 0.25s ease;
}
.form-control-radio:not(.element) span::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 999px;
  border: 1px solid var(--wf-base-800, #cbd2e0);
  transition: all 0.25s ease;
}
.form-control-radio:not(.element) span::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 6px;
  width: 10px;
  height: 10px;
  background: transparent;
  border-radius: 100%;
  transition: all 0.25s ease;
}
.form-control-radio.element .radiobutton-label {
  display: inline-flex;
  align-items: center;
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}
.form-control-radio.element input {
  width: 22px;
  height: 22px;
  position: absolute;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}
.form-control-radio.element .radiobutton-button {
  width: 22px;
  height: 22px;
  display: inline-flex;
  margin-right: 8px;
  align-items: center;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  justify-content: center;
  border: 1px solid var(--primary-600, #7f56d9);
}
.form-control-radio.element .radiobutton-button.checked {
  background: var(--primary-50, #f9f5ff);
}
@media screen {
  .form-control-radio.element .radiobutton-button.checked::before {
    width: 10px;
    height: 10px;
    display: inline-flex;
    content: "";
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    position: absolute;
    background-color: var(--primary-600, #7f56d9);
  }
}
@media print {
  .form-control-radio.element .radiobutton-button.checked::before {
    top: -3px;
    left: -1px;
    width: 22px;
    height: 22px;
    display: inline-flex;
    content: "•";
    border-radius: 50%;
    font-size: 30px;
    color: var(--primary-600, #7f56d9);
    align-items: center;
    justify-content: center;
    position: absolute;
  }
}
.form-control-radio .icon-icon-info {
  z-index: 9;
  position: relative;
}
.form-control-radio-small span::after {
  width: 10px;
  height: 10px;
  left: 4px;
}
.form-control-radio-small span::before {
  width: 16px;
  height: 16px;
}
.form-control-radio-medium span::after {
  width: 14px;
  height: 14px;
  left: 4px;
}
.form-control-radio-medium span::before {
  width: 20px;
  height: 20px;
}
.form-control-radio-large span::after {
  width: 16px;
  height: 16px;
  left: 4px;
}
.form-control-radio-large span::before {
  width: 22px;
  height: 22px;
}

.form-control-checkbox {
  display: block;
  position: relative;
  margin-bottom: 15px;
}
.form-control-checkbox.center, .form-control-checkbox.right {
  display: flex;
  align-items: center;
}
.form-control-checkbox.center {
  justify-content: center;
}
.form-control-checkbox.right {
  justify-content: flex-end;
}
.form-control-checkbox:not(.element) input {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
.form-control-checkbox:not(.element) input:checked + span {
  color: var(--wf-base-800, #2d3648);
}
.form-control-checkbox:not(.element) input:checked + span::before {
  border-radius: 4px;
  border: 1px solid var(--primary-600, #7f56d9);
  background: var(--primary-50, #f9f5ff);
}
.form-control-checkbox:not(.element) input:checked + span::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
}
.form-control-checkbox:not(.element) span {
  display: inline-block;
  color: var(--wf-base-800, #717d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
  position: relative;
  padding-left: 30px;
  transition: all 0.25s ease;
  min-width: 20px;
  min-height: 20px;
}
.form-control-checkbox:not(.element) span::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid var(--wf-base-800, #717d96);
  transition: all 0.25s ease;
}
.form-control-checkbox:not(.element) span::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 4px;
  width: 14px;
  height: 14px;
  background: transparent;
  border-radius: 3px;
}
.form-control-checkbox.element input {
  position: absolute;
  z-index: -1;
  opacity: 0;
  cursor: pointer;
  pointer-events: none;
}
.form-control-checkbox.element .checkbox-label {
  display: inline-flex;
  align-items: center;
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}
.form-control-checkbox.element .checkbox-button {
  width: 22px;
  height: 22px;
  display: inline-flex;
  margin-right: 8px;
  align-items: center;
  border-radius: 4px;
  -webkit-user-select: none;
          user-select: none;
  justify-content: center;
  border: 1px solid var(--primary-600, #7f56d9);
}
.form-control-checkbox.element .checkbox-button.checked {
  background: var(--primary-50, #f9f5ff);
}
@media screen {
  .form-control-checkbox.element .checkbox-button.checked::before {
    content: "";
    width: 14px;
    height: 14px;
    background: transparent;
    border-radius: 3px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
  }
}
@media print {
  .form-control-checkbox.element .checkbox-button.checked::before {
    width: auto;
    height: auto;
    display: inline-block;
    content: "✔";
    font-size: 14px;
    color: var(--primary-600, #7f56d9);
  }
}
.form-control-checkbox-small span::after {
  width: 10px;
  height: 10px;
  left: 5px;
}
.form-control-checkbox-small span::before {
  width: 16px;
  height: 16px;
}
.form-control-checkbox-medium span::after {
  width: 14px;
  height: 14px;
  left: 5px;
}
.form-control-checkbox-medium span::before {
  width: 20px;
  height: 20px;
}
.form-control-checkbox-large span::after {
  width: 16px;
  height: 16px;
  left: 5px;
}
.form-control-checkbox-large span::before {
  width: 22px;
  height: 22px;
}

.form-control-checkbox-span {
  position: relative;
}
.form-control-checkbox-span input {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
.form-control-checkbox-span input:checked + span {
  color: var(--wf-base-800, #fff);
  background: var(--wf-base-800, #7f56d9);
}
.form-control-checkbox-span span {
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.14px;
  position: relative;
  transition: all 0.25s ease;
  border-radius: 30px;
  border: 1px solid var(--secondary-input-outline, #dadee4);
  background: var(--On-Primary, #fff);
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

.week-grid {
  display: flex;
  margin: 10px 0;
}
.week-grid .form-control-checkbox-span {
  margin-right: 10px;
}

.month-grid {
  flex-wrap: wrap;
  width: 421px;
}
.month-grid .form-control-checkbox-span {
  flex: 0 0 100px;
  max-width: 100px;
  width: 100px;
  margin-bottom: 15px;
}
.month-grid .form-control-checkbox-span span {
  width: 100px;
}

.form-control-star > span {
  margin-right: 3px;
}
.form-control-star .icon-star-empty,
.form-control-star .icon-star-full {
  font-size: 20px;
}
.form-control-star.form-control-star-small .icon-star-empty,
.form-control-star.form-control-star-small .icon-star-full {
  font-size: 16px;
}
.form-control-star.form-control-star-large .icon-star-empty,
.form-control-star.form-control-star-large .icon-star-full {
  font-size: 26px;
}

.sigCanvas {
  border: 1px solid #cbd2e0;
  display: block;
  margin-bottom: 5px;
  border-radius: 8px;
}
.sigCanvas-small {
  width: 50%;
}
.sigCanvas-medium {
  width: 75%;
}
.sigCanvas-large {
  width: 100%;
}

.form-control.textarea {
  height: auto;
  white-space: pre-wrap;
  word-break: break-all;
}

.sigCanvas-clear {
  cursor: pointer;
}

.form-label-small .form-label {
  width: 50%;
}
.form-label-medium .form-label {
  width: 75%;
}
.form-label-large .form-label {
  width: 100%;
}
.form-label-small .form-grid-full-name .form-label, .form-label-medium .form-grid-full-name .form-label, .form-label-large .form-grid-full-name .form-label, .form-label-small .w-full.form-label, .form-label-medium .w-full.form-label, .form-label-large .w-full.form-label {
  width: 100%;
}

.form-label-small .instructions {
  width: 50%;
}

.form-label-medium .instructions {
  width: 75%;
}

.form-label-large .instructions {
  width: 100%;
}

.form-builder-element-preview .optional {
  display: none;
}

.form-control-select {
  width: 100%;
}
.form-control-select.form-control-small {
  width: 50%;
}
.form-control-select.form-control-medium {
  width: 75%;
}
.form-control-select.form-control-large {
  width: 100%;
}
.form-control-select .react-select-multi__control .react-select-multi__value-container {
  flex-wrap: nowrap;
}
.form-control-select .react-select-multi__control .react-select-multi__multi-value {
  border: 0;
  background: transparent;
}
.form-control-select .react-select-multi__control .react-select-multi__clear-indicator {
  display: none;
}
.form-control-select .react-select-multi__control .react-select-multi__multi-value__remove {
  width: 20px;
  min-width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center;
}
.form-control-select .react-select-multi__control .react-select-multi__multi-value__remove svg {
  display: none;
}
.form-control-select .react-select-multi__menu {
  z-index: 99;
  margin: 0;
  border-radius: 0 0 6px 6px;
  width: max-content;
  min-width: 100%;
}
.form-control-select .react-select-multi__menu .react-select__option,
.form-control-select .react-select-multi__menu .react-select-multi__option {
  position: relative;
  background: var(--primary-50, #fff);
  color: var(--secondary-dark, #101828);
  font-feature-settings: "calt" off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding-left: 50px;
}
.form-control-select .react-select-multi__menu .react-select__option::before,
.form-control-select .react-select-multi__menu .react-select-multi__option::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 9px;
  width: 20px;
  height: 20px;
  border: 1px solid var(--secondary-base, #cbd2e0);
  background: var(--On-Primary, #fff);
  border-radius: 4px;
}
.form-control-select .react-select-multi__menu .react-select__option.react-select__option--is-selected, .form-control-select .react-select-multi__menu .react-select__option.react-select-multi__option--is-selected,
.form-control-select .react-select-multi__menu .react-select-multi__option.react-select__option--is-selected,
.form-control-select .react-select-multi__menu .react-select-multi__option.react-select-multi__option--is-selected {
  color: var(--secondary-dark, #101828);
}
.form-control-select .react-select-multi__menu .react-select__option.react-select__option--is-selected::before, .form-control-select .react-select-multi__menu .react-select__option.react-select-multi__option--is-selected::before,
.form-control-select .react-select-multi__menu .react-select-multi__option.react-select__option--is-selected::before,
.form-control-select .react-select-multi__menu .react-select-multi__option.react-select-multi__option--is-selected::before {
  border: 1px solid var(--primary-600, #7f56d9);
  background: var(--primary-50, #f9f5ff) url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
}
.form-control-select .react-select-multi__menu .react-select__option:hover,
.form-control-select .react-select-multi__menu .react-select-multi__option:hover {
  background: var(--primary-50, #f9f5ff);
}
.form-control-select .react-select__indicator-separator,
.form-control-select .react-select-multi__indicator-separator {
  display: none;
}
.form-control-select .react-select-control,
.form-control-select .react-select-multi,
.form-control-select .react-select__control,
.form-control-select .react-select-multi__control {
  min-height: 40px;
  border: 1px solid var(--wf-base-400, #cbd2e0);
  border-radius: 6px;
}
.form-control-select .react-select-control .react-select__placeholder,
.form-control-select .react-select-control .react-select-multi__placeholder,
.form-control-select .react-select-multi .react-select__placeholder,
.form-control-select .react-select-multi .react-select-multi__placeholder,
.form-control-select .react-select__control .react-select__placeholder,
.form-control-select .react-select__control .react-select-multi__placeholder,
.form-control-select .react-select-multi__control .react-select__placeholder,
.form-control-select .react-select-multi__control .react-select-multi__placeholder {
  opacity: 0.5;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
  color: var(--secondary-on-surface, #98a2b3);
}
.form-control-select .react-select-control:hover,
.form-control-select .react-select__control:hover,
.form-control-select .react-select-multi-control:hover,
.form-control-select .react-select-multi__control:hover {
  border: 1px solid var(--wf-base-400, #cbd2e0);
  box-shadow: none;
}
.form-control-select .react-select__control.react-select__control-menu-is-open,
.form-control-select .react-select-multi__control.react-select-multi__control-menu-is-open {
  border-radius: 6px 6px 0 0;
  border: 1px solid var(--wf-base-400, #cbd2e0);
  box-shadow: none;
}

.react-select__menu {
  margin: 0;
  border-radius: 0 0 6px 6px;
  min-width: max-content;
  width: 100%;
  z-index: 99 !important;
}
.react-select__menu .react-select__option {
  position: relative;
  background: var(--primary-50, #fff);
  color: var(--secondary-dark, #101828);
  font-feature-settings: "calt" off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding-left: 50px;
}
.react-select__menu .react-select__option::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 9px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 1px solid var(--secondary-base, #cbd2e0);
  background: var(--On-Primary, #fff);
}
.react-select__menu .react-select__option.react-select__option--is-selected {
  color: var(--secondary-dark, #101828);
}
.react-select__menu .react-select__option.react-select__option--is-selected::before {
  border: 1px solid var(--primary-600, #7f56d9);
}
.react-select__menu .react-select__option.react-select__option--is-selected::after {
  content: "";
  border-radius: 100%;
  width: 14px;
  height: 14px;
  position: absolute;
  left: 19px;
  top: 13px;
  background: #7f56d9;
}
.react-select__menu .react-select__option:hover {
  background: var(--primary-50, #f9f5ff);
}

.table_container {
  width: max-content;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}
.table_container:not(.sticky-table-clone) {
  min-width: 100%;
}

.readOnly-td,
.readOnly-td2 {
  pointer-events: none !important;
}

.form-control-table {
  overflow: visible !important;
  border-radius: 8px;
  background: var(--White, #fff);
  border-collapse: separate;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  width: max-content;
}
.form-control-table thead th {
  text-align: center;
  white-space: pre;
}
.form-control-table .th-disabled {
  pointer-events: none;
}
.form-control-table th {
  background: var(--gray-50, #f9fafb);
  color: var(--secondary-text, #667085);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  border-top: 1px solid #eaecf0;
  border-bottom: 1px solid #eaecf0;
  padding: 10px 4px;
  white-space: nowrap;
}
.form-control-table th:first-child {
  border-top-left-radius: 8px;
  border-left: 1px solid #eaecf0;
  padding-left: 10px;
}
.form-control-table th:last-child {
  border-top-right-radius: 8px;
  border-right: 1px solid #eaecf0;
}
.form-control-table td {
  padding: 4px;
  white-space: break-spaces;
  vertical-align: middle;
}
.form-control-table td.current-user {
  text-align: center;
}
.form-control-table td.current-user .btn {
  margin: 0 auto;
}
.form-control-table td:first-child {
  border-left: 1px solid #eaecf0;
  padding-left: 10px;
}
.form-control-table td:last-child {
  border-right: 1px solid #eaecf0;
}
.form-control-table tr:last-child:first-child {
  border-top-left-radius: 8px;
}
.form-control-table tr:last-child:last-child {
  border-top-right-radius: 8px;
}
.form-control-table td,
.form-control-table th {
  min-width: 10px;
  color: var(--gray-900, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  will-change: width, max-width;
}
.form-control-table td.first-section,
.form-control-table th.first-section {
  text-align: left;
  min-width: 130px;
  vertical-align: middle;
}
.form-control-table .form-control {
  height: 40px;
  padding: 7px 7px 7px 12px;
}
.form-control-table tbody tr.asAddNewRowButton {
  position: relative;
}
.form-control-table tbody tr.asAddNewRowButton td {
  height: 10px;
  overflow-x: visible;
  border-top: 1px solid #eaecf0;
  border-bottom: 1px solid #eaecf0;
  background-color: var(--gray-50, #f9fafb);
}

.form-control-table-wrapper {
  padding-bottom: 15px;
  overflow-x: auto;
}
.form-control-table-wrapper.alignment--center {
  text-align: center;
}
.form-control-table-wrapper.alignment--center .form-label {
  text-align: center;
}
.form-control-table-wrapper.alignment--center .form-control-table {
  margin-left: auto;
  margin-right: auto;
}
.form-control-table-wrapper.alignment--right {
  text-align: right;
}
.form-control-table-wrapper.alignment--right .form-label {
  text-align: right;
}
.form-control-table-wrapper.alignment--right .form-control-table {
  margin-left: auto;
}

.form-control-table-alignment-wrapper {
  width: 100%;
}
.form-control-table-alignment-wrapper.center {
  text-align: center;
}
.form-control-table-alignment-wrapper.right {
  text-align: right;
}

.form-readonly,
.form-readonlyy,
.readonly {
  pointer-events: none !important;
}

.form-list {
  color: var(--wf-base-800, #717d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
  position: relative;
  padding-left: 10px;
  transition: all 0.25s ease;
  list-style: inherit;
  margin-left: 10px;
}

.form-control-file {
  border: 1px solid var(--wf-base-400, #dadee4);
  border-radius: 8px;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: var(--wf-base-800, #2d3648);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.14px;
}
.form-control-file.form-control-file-default {
  border-radius: var(--corner-radius-main, 8px);
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
  background: var(--on-primary, #fff);
  min-height: 131px;
}
.form-control-file.form-control-file-default .icon-icon-upload {
  text-align: center;
  margin: 0 auto;
  display: block;
  font-size: 24px;
}
.form-control-file.form-control-file-default span {
  display: block;
  text-align: center;
  color: #7f56d9;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.14px;
}
.form-control-file.form-control-file-default span.sub-text {
  color: var(--secondary-dark, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
}
.form-control-file input {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.form-control-file-attach {
  border-radius: 6px;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: var(--wf-base-800, #2d3648);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.14px;
}
.form-control-file-attach input {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
}

.form-label-alignment-left .form-label {
  text-align: left;
}
.form-label-alignment-center .form-label,
.form-label-alignment-center .instructions,
.form-label-alignment-center .sigCanvas-wrapper,
.form-label-alignment-center .text-secondary,
.form-label-alignment-center .form-submitters {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.form-label-alignment-center .form-control-star {
  display: table !important;
}
.form-label-alignment-center .form-control,
.form-label-alignment-center .form-control-star,
.form-label-alignment-center .form-control-select,
.form-label-alignment-center .form-control-file {
  margin-left: auto;
  margin-right: auto;
  display: block;
  text-align: center;
}
.form-label-alignment-center .dropdown-input {
  margin-left: auto;
  margin-right: auto;
  padding-left: 36px;
}
.form-label-alignment-right .form-control,
.form-label-alignment-right .sigCanvas-wrapper,
.form-label-alignment-right .form-control-file,
.form-label-alignment-right .form-control-star,
.form-label-alignment-right .form-control-select {
  margin-left: auto;
  display: block;
}
.form-label-alignment-right .form-control-star {
  display: table !important;
}
.form-label-alignment-right .form-label,
.form-label-alignment-right .instructions,
.form-label-alignment-right .text-secondary {
  text-align: right;
  margin-left: auto;
}
.form-label-alignment-right .dropdown-input {
  margin-left: auto;
}

.form-control-table-responsive {
  min-width: 100%;
}

.form-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px 16px;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
  border-radius: var(--corner-radius-main, 8px);
  border-left: 4px solid var(--primary-100, #f4ebff);
  background: var(--on-primary, #fff);
  padding: 16px 10px;
}
.form-wrapper .form-wrapper-title {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
  color: var(--secondary-text, #667085);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  margin-bottom: 16px;
}
.form-wrapper .form-wrapper-title img {
  margin-right: 10px;
}
.form-wrapper .form-item {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
  padding: 0 10px;
  margin-bottom: 24px;
  position: relative;
}
.form-wrapper .form-item.form-item-select .danger-icon {
  right: 43px;
}
.form-wrapper .form-item.form-item-mail .mail-icon {
  position: absolute;
  top: 36px;
  left: 23px;
}
.form-wrapper .form-item.form-item-mail .form-control {
  padding: 12px 12px 12px 43px;
}
.form-wrapper .form-item .remove-icon {
  position: absolute;
  top: 38px;
  right: 23px;
  z-index: 2;
  cursor: pointer;
}
.form-wrapper .form-item .danger-icon {
  position: absolute;
  top: 35px;
  right: 23px;
  opacity: 0;
  z-index: 2;
}
.form-wrapper .form-item-error .form-control {
  border-color: #b42318;
  padding: 12px 43px 12px 16px;
}
.form-wrapper .form-item-error.form-item-select .form-control-select .react-select__control,
.form-wrapper .form-item-error.form-item-select .form-control-select .react-select-multi__control {
  border-color: #b42318;
}
.form-wrapper .form-item-error.form-item-mail .form-control {
  padding: 12px 43px 12px 43px;
}
.form-wrapper .form-item-error .danger-icon {
  opacity: 1;
}
.form-wrapper .form-item-error .form-error {
  color: #b42318;
}
.form-wrapper .form-item-half {
  flex: 0 0 50%;
  max-width: 50%;
  width: 50%;
}
.form-wrapper .form-item.form-item-75 {
  flex: 0 0 75%;
  max-width: 75%;
  width: 75%;
}
.form-wrapper .form-item.form-item-25 {
  flex: 0 0 25%;
  max-width: 25%;
  width: 25%;
}

.add-facility {
  color: var(--primary-600, #7f56d9);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  display: table;
  cursor: pointer;
  padding: 10px 0;
}
.add-facility i:before {
  font-weight: 700;
  font-size: 16px;
}

.react-datepicker-wrapper {
  width: 100%;
}

.date-piker-wrapper {
  position: relative;
}
.date-piker-wrapper .date-piker-icon {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  font-size: 24px;
  color: #a0abc0;
}

.file-tab .file-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  column-gap: 20px;
}
.file-tab .file-list li {
  max-width: calc(25% - 15px);
  width: calc(25% - 15px);
}

.file-list li {
  display: flex;
  color: var(--gray-700, #344054);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border-radius: 8px;
  border: 1px solid var(--gray-200, #eaecf0);
  background: var(--white, #fff);
  padding: 16px;
  margin-bottom: 16px;
  justify-content: space-between;
}
.file-list li .d-flex,
.file-list li p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.file-list li img {
  margin-right: 10px;
}
.file-list .btn.btn-icon {
  box-shadow: none;
}
.file-list .btn.btn-icon i {
  font-size: 20px;
}
.file-list .btn.btn-icon i::before {
  color: var(--gray-700, #344054);
}
.file-list .icon-remove {
  margin-left: 10px;
}
.file-list .icon-icon-file {
  margin-right: 10px;
}

.form-error {
  color: #b42318;
  font-size: 12px;
}

.select-placeholder {
  display: none;
}

.form-control-item-settings {
  margin-bottom: 28px;
}
.form-control-item-settings .select-multy-wrapper {
  position: relative;
}
.form-control-item-settings .select-multy-wrapper .select-placeholder {
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 2;
  pointer-events: none;
  color: #a0abc0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.16px;
  display: none;
}
.form-control-item-settings .css-3w2yfm-ValueContainer {
  height: 44px;
  position: relative;
}
.form-control-item-settings .css-3w2yfm-ValueContainer .css-1p3m7a8-multiValue {
  display: none;
}
.form-control-item-settings p {
  color: var(--wf-base-800, #2d3648);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
  margin: 20px 0 16px 0;
}
.form-control-item-settings ul {
  display: block;
  margin-top: 20px;
}
.form-control-item-settings ul.individual-users-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 200px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.1);
}
.form-control-item-settings ul.individual-users-list::-webkit-scrollbar {
  width: 7px;
}
.form-control-item-settings ul.individual-users-list::-webkit-scrollbar-track {
  border-radius: 40px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.1);
}
.form-control-item-settings ul.individual-users-list::-webkit-scrollbar-thumb {
  border-radius: 40px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.1);
}
.form-control-item-settings ul.individual-users-list li {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 5px);
  max-width: calc(50% - 5px);
  width: calc(50% - 5px);
}
.form-control-item-settings ul li {
  display: inline-flex;
  align-items: center;
  color: var(--secondary-dark, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 10px;
}
.form-control-item-settings ul li .avatar {
  margin-right: 8px;
}
.form-control-item-settings ul li img {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}
.form-control-item-settings ul li .btn-icon {
  margin-left: 10px;
}
.form-control-item-settings ul li .btn-icon i::before {
  color: #ffb8b8;
}
.form-control-item-settings ul li:last-child {
  margin-bottom: 0;
}

.form-control-monthly_fee {
  position: relative;
  z-index: 1;
}
.form-control-monthly_fee::before {
  position: absolute;
  z-index: 2;
  content: "\$";
  top: 3px;
  left: 15px;
  color: rgba(45, 54, 72, 0.5);
}
.form-control-monthly_fee .form-control {
  padding-left: 30px;
}

.folder-select {
  position: relative;
}
.folder-select.folder-select-disable {
  pointer-events: none;
}
.folder-select.folder-select-disable .folder-select-input {
  background-color: hsl(0, 0%, 95%);
}
.folder-select .folder-select-input {
  border-radius: 6px;
  border: 1px solid var(--wf-base-400, #cbd2e0);
  background: var(--wf-base-white, #fff);
  height: 44px;
  padding: 12px 12px 12px 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: -0.14px;
  color: #2d3648;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.folder-select .folder-select-input-placeholder {
  color: #717d96;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 24px */
  letter-spacing: -0.16px;
}
.folder-select .folder-select-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 440px;
  overflow-y: auto;
  border-radius: 8px;
  background: #fff;
  overscroll-behavior: contain;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  padding: 16px 0;
  z-index: 9;
}
.folder-select .folder-select-ul {
  margin-top: 0;
}
.folder-select .folder-select-ul li {
  display: block;
  position: relative;
}
.folder-select .folder-select-ul li:last-child > span {
  margin-bottom: 0;
}
.folder-select .folder-select-ul li ul {
  padding-left: 35px;
}
.folder-select .folder-select-ul li > span {
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 50px;
  margin-bottom: 8px;
}
.folder-select .folder-select-ul li > span:hover {
  background: #f9f5ff;
}
.folder-select .folder-select-ul li > span::before {
  content: "";
  border-radius: 100%;
  position: absolute;
  left: 16px;
  top: 10px;
  width: 20px;
  height: 20px;
  border: 1px solid var(--secondary-base, #cbd2e0);
}
.folder-select .folder-select-ul li > span::after {
  content: "";
  border-radius: 100%;
  position: absolute;
  left: 22px;
  top: 16px;
  width: 10px;
  height: 10px;
  background: #7f56d9;
  transform: scale(0);
  transition: all 0.25s ease;
}
.folder-select .folder-select-ul li > span svg {
  margin-right: 8px;
}
.folder-select .folder-select-ul li.active-folder > span::after {
  transform: scale(1);
}
.folder-select .folder-select-ul li.active-folder > span::before {
  border: 1px solid var(--secondary-base, #7f56d9);
}
.folder-select .folder-select-ul-inner {
  margin-top: 0;
}

.form-item .text-secondary {
  display: block;
}

.input-clear {
  position: relative;
}
.input-clear .form-control {
  padding-right: 50px;
}
.input-clear .btn.btn-icon {
  position: absolute;
  top: 12px;
  right: 15px;
  z-index: 2;
}

.number-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 10px;
}
.number-wrapper .btn-outline svg {
  width: 21px;
  height: 21px;
}
.number-wrapper .btn {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.333333% - 7px);
  max-width: calc(33.333333% - 7px);
  width: calc(33.333333% - 7px);
}

.number-wrapper-action {
  display: flex;
  gap: 10px;
  padding-top: 10px;
}
.number-wrapper-action .btn {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 5px);
  max-width: calc(50% - 5px);
  width: calc(50% - 5px);
}

.form-control.multiline {
  min-height: 40px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  font-family: Arial, sans-serif;
  pointer-events: initial !important;
}
.form-control.multiline::placeholder {
  font-size: 16px;
}

.mr-2 {
  margin-right: 8px;
}

.mr-4 {
  margin-right: 16px;
}

.mb-4 {
  margin-bottom: 15px;
}

.mt-4 {
  margin-top: 28px;
}

.d-none {
  display: none !important;
}

.mb-6 {
  margin-bottom: 28px;
}

.fw-bolder {
  font-weight: bolder;
}

.fw-bold {
  font-weight: bold;
}

.scrollbar::-webkit-scrollbar {
  width: 7px;
  height: 12px;
}
.scrollbar::-webkit-scrollbar-track {
  border-radius: 40px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.1);
}
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 40px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.1);
}

.m-0 {
  margin: 0 !important;
}

.pt-6 {
  padding-top: 32px !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mt-1 {
  margin-top: 6px;
}

.w-full {
  width: 100%;
}

.w-half {
  width: 50%;
}

.ml-auto {
  margin-left: auto;
}

.mr-auto {
  margin-right: auto;
}

.text-center {
  text-align: center;
}

.mr-a {
  margin-left: auto;
}

.text-right {
  text-align: right;
}

.d-flex {
  display: flex;
  align-items: center;
}

.gap-1 {
  gap: 4px;
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.gap-4 {
  gap: 16px;
}

.justify-content-space-between {
  justify-content: space-between;
}

.d-block {
  display: block !important;
}

.disabled-link {
  pointer-events: none;
}
.disabled-link * {
  pointer-events: none;
}

.bt-1 {
  background: #cbd2e0;
  width: 100%;
  display: block;
  height: 1px;
  margin-bottom: 24px;
}

.flex-column {
  flex-direction: column;
  align-items: flex-start;
}

.text-secondary {
  color: var(--secondary-text, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
}

.align-center {
  align-items: center;
}

.mt-2 {
  margin-top: 16px;
}

.mt-4 {
  margin-top: 30px;
}

.mb-2 {
  margin-bottom: 16px !important;
}

.mb-1 {
  margin-bottom: 8px;
}

.pt-5 {
  padding-top: 26px !important;
}

.ml-2 {
  margin-left: 6px;
}

.ml-3 {
  margin-left: 8px;
}

.react-tooltip {
  max-width: 350px;
  z-index: 99;
  border-radius: 6px;
  background: var(--on-primary, #fff) !important;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1) !important;
  color: var(--secondary-dark, #101828) !important;
  opacity: 0;
  padding: 16px !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  word-break: break-word;
  white-space: normal;
}

.z-index {
  z-index: 2;
}

.z-index-10 {
  position: relative;
  z-index: 10;
}

.react-tooltip-arrow {
  display: none !important;
}

.justify-space-between {
  justify-content: space-between;
}

.flex-start {
  align-items: flex-start;
}

.flex-center {
  align-items: center;
}

.no-wrap {
  white-space: nowrap;
}

.ml-4 {
  margin-left: 16px;
}

.flex-wrap {
  flex-wrap: wrap;
}

.ml-0 {
  margin-left: 0 !important;
}

.opacity-0 {
  opacity: 0;
}

.cursor-pointer {
  cursor: pointer;
}

.breadcrumbs-item-last {
  pointer-events: none;
}

.pointer-none {
  pointer-events: none;
}

.opacity-50 {
  opacity: 0.5;
}

.pt-4 {
  padding-top: 6px !important;
}

.ql-font-arial {
  font-family: "Arial";
}

.ql-font-times-new-roman {
  font-family: "Times New Roman";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=arial]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=arial]::before {
  content: "Arial";
  font-family: "Arial";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=times-new-roman]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=times-new-roman]::before {
  content: "Times New Roman";
  font-family: "Times New Roman";
}

.ql-picker-label.ql-active {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quill .ql-snow .ql-picker.ql-font {
  width: 138px;
}

.ql-container.ql-snow {
  min-height: 150px;
  border: 1px solid var(--wf-base-400, #CBD2E0);
  border-radius: 0 0 6px 6px;
}

.ql-editor.ql-blank {
  min-height: 150px;
}

.ql-toolbar.ql-snow {
  border: 1px solid var(--wf-base-400, #CBD2E0);
  border-radius: 6px 6px 0 0;
}

.quill .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.quill .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: "10px";
}

.quill .ql-snow .ql-picker.ql-size .ql-picker-label::before,
.quill .ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.quill .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.quill .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: "20px";
}

.quill .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.quill .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: "32px";
}

.html-area {
  font-size: 14px;
}
.html-area ul {
  list-style: inherit;
  margin-block-end: 16px;
  margin-block-start: 16px;
  padding-inline-start: 40px;
}
.html-area ol {
  list-style: decimal;
  margin-block-end: 16px;
  margin-block-start: 16px;
  padding-inline-start: 40px;
}
.html-area .ql-size-huge {
  font-size: 32px;
}
.html-area .ql-size-large {
  font-size: 20px;
}
.html-area .ql-size-small {
  font-size: 10px;
}
.html-area .ql-align-right {
  text-align: right;
}
.html-area .ql-align-center {
  text-align: center;
}
.html-area .ql-align-justify {
  text-align: justify;
}

.quill.hidden .ql-toolbar {
  display: none;
}
.quill.hidden .ql-container {
  border: 0;
}

.library {
  padding: 40px 30px;
  width: 100%;
  background: #fff;
}
.library.library-available-to-me {
  padding-bottom: 100px;
}
.library .library--header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.library.library-attach .library-item-button {
  display: none;
}
.library-wrapper {
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
  margin: 0 -8px;
}
.library-title {
  color: var(--secondary-eading, #101828);
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
.library .breadcrumbs-item {
  color: var(--secondary-text, #667085);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.library-subtitle {
  color: var(--secondary-text, #667085);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 16px;
}
.library .total {
  color: var(--primary-600, #7F56D9);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.library .library-item-button {
  margin-right: 16px;
  position: relative;
}
.library .library-item-button.library-item-button-open {
  z-index: 9;
}
.library .library-item-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: min-content;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
}
.library .library-item-menu.file {
  width: 144px;
}
.library .library-item-menu .btn {
  color: var(--secondary-eading, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding: 10px 16px;
  height: auto;
  text-align: left;
  background: transparent;
  border: 0;
  box-shadow: none;
  display: flex;
  align-items: center;
}
.library .library-item-menu .btn.btn-remove {
  color: var(--tertiary-600, #B42318);
}
.library .library-item-menu .btn.btn-remove i::before {
  color: var(--tertiary-600, #B42318);
}
.library .library-item-menu .btn.btn-active {
  color: rgb(18, 183, 106);
}
.library .library-item-menu .btn.btn-active i::before {
  color: rgb(18, 183, 106);
}
.library .library-item-menu .btn i {
  margin-right: 8px;
}
.library .library-item-menu .btn i::before {
  color: var(--secondary-eading, #101828);
}
.library-item {
  max-width: calc(20% - 16px);
  width: 100%;
  flex: 0 0 100%;
  display: flex;
  margin: 0 8px;
  color: var(--secondary-eading, #101828);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  border-radius: 8px;
  position: relative;
  border: 1px solid var(--secondary-input-outline, #DADEE4);
  background: var(--On-Primary, #FFF);
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.library-item.list-item {
  width: 100%;
  max-width: initial;
  margin: 0;
  padding: 6px 20px;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid var(--Secondary-Input-Outline, #DADEE4);
}
.library-item.list-item .library-item-text {
  display: flex;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  align-items: center;
}
.library-item.list-item .library-item__name {
  width: 100%;
}
.library-item.list-item .library-item-button {
  margin: 0;
}
.library-item.list-item .library-item-button .library-item-menu-button {
  width: 32px;
  height: 32px;
}
.library-item.list-item .library-item-date {
  width: auto;
  border: none;
  margin-top: 0;
  padding-top: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #667085;
}
.library-item:nth-child(5n) .library-item-menu {
  left: auto;
  right: 0;
}
.library-item-disabled {
  cursor: not-allowed;
}
.library-item .forms-count {
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  display: inline-flex;
  position: absolute;
  border-radius: 50%;
  color: #ffffff;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  background: var(--Tertiary-500, #d92d20);
  z-index: 9;
}
.library-item .library-item-date {
  width: 100%;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--secondary-input-outline, #DADEE4);
}
.library-item .library-item-date .value {
  margin-left: 4px;
}
.library-item .library-item-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 16px;
  width: 100%;
}
.library-item .btn i {
  margin-right: 0;
}
.library-item .btn.btn-small {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.library-item i {
  margin-right: 10px;
}
.library-filters {
  display: flex;
  align-items: flex-end;
  margin-bottom: 29px;
  justify-content: space-between;
}
.library-filters .form-item {
  max-width: 237px;
  width: 100%;
}
.library-filters-wrapper {
  display: flex;
  align-items: center;
  column-gap: 16px;
  width: 100%;
  padding-right: 16px;
}
.library-filter {
  display: flex;
  align-items: center;
  margin-bottom: 29px;
  margin-top: 29px;
}
.library-filter-search {
  flex: 1 0;
  margin-bottom: 0;
}
.library-filter .btn {
  margin-left: 16px;
}
.library-filter .btn-outline {
  padding: 8px 12px 6px;
  border: 1px solid #CBD2E0;
  color: var(--primary-600, #7F56D9);
  font-size: 16px;
}
.library-filter .btn-outline i::before {
  color: var(--primary-600, #7F56D9);
}

.is-disabled {
  color: #B42318;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  display: block;
  padding: 16px 28px 0;
  margin-bottom: -10px;
}

.render-form-disabled .from-builder-title,
.render-form-disabled .form-builder-element-preview {
  filter: grayscale(100%);
  pointer-events: none !important;
}

.breadcrumbs {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.breadcrumbs-item {
  color: #2D3648;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  position: relative;
  margin-right: 48px;
}
.breadcrumbs-item:last-child::after {
  display: none;
}
.breadcrumbs-item::after {
  content: "";
  display: block;
  width: 24px;
  height: 24px;
  position: absolute;
  left: calc(100% + 12px);
  top: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: center center;
}

.react-tabs {
  width: 100%;
}
.react-tabs__tab-panel {
  padding: 24px 0;
  display: none;
}
.react-tabs__tab-panel--selected {
  display: block;
}
.react-tabs__tab {
  padding: 16px 0;
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
  color: var(--secondary-eading, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  flex: 1 0 auto;
  position: relative;
  cursor: pointer;
}
.react-tabs__tab-list {
  display: flex;
  align-items: center;
}
.react-tabs__tab::after {
  content: "";
  width: 100%;
  height: 2px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) scale(0);
  background: var(--wf-base-800, #6941C6);
  transition: all 0.25s ease;
}
.react-tabs__tab--selected {
  color: var(--primary-700, #6941C6);
  background: transparent;
}
.react-tabs__tab--selected::after {
  transform: translateX(-50%) scale(1);
}

.tab__error:before {
  font-size: 20px;
  margin-left: 10px;
  color: var(--tertiary-500, #ef5350) !important;
}

.no-result {
  text-align: center;
  font-size: 18px;
  padding: 28px 0;
}

.folder-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 15px;
}

.notifications {
  width: 100%;
  padding: 40px;
}
.notifications .notifications-title {
  color: var(--Secondary-eading, #101828);
  /* H2 */
  font-family: Inter;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 40px;
}
.notifications .notifications-title span {
  color: var(--Tertiary-500, #D92D20);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.notifications .form-control-checkbox {
  margin-bottom: 0;
}
.notifications .table-default .th-checkbox {
  width: 49px;
}
.notifications .table-default .th {
  vertical-align: middle;
}
.notifications .td:last-child {
  text-align: right;
}
.notifications .table-default .tr:hover .td a {
  opacity: 1;
}
.notifications .table-default .tr.tr-disabled .th {
  border-bottom: var(--outline, 1px) solid var(--Gray-200, #EAECF0);
  background: var(--Gray-50, #F9FAFB);
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(100%);
}
.notifications .table-default .tr.tr-is-read .td {
  border-bottom: var(--outline, 1px) solid var(--Gray-200, #EAECF0);
  opacity: var(--outline, 1);
  background: var(--Secondary-surface, #F9FAFB);
  color: var(--Secondary-Text, #667085);
  /* Input Label */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.notifications .table-default .th {
  color: var(--Secondary-eading, #101828);
  /* Input Label */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.notifications .table-default .td {
  color: var(--Secondary-eading, #101828);
  /* Input Label */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.notifications .table-default .td a {
  color: var(--Primary-600, #7F56D9);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 171.429% */
  text-decoration-line: underline;
  opacity: 0;
  white-space: nowrap;
}
.notifications .th-actions {
  width: 253px;
  padding: 12px !important;
}
.notifications .th-actions .btn {
  display: inline-flex;
  align-items: center;
}

.header-right {
  display: flex;
}
.header-right__main {
  display: inline-flex;
  align-items: center;
}

.btn.btn-notification {
  padding: 10px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
  position: relative;
}
.btn.btn-notification .counter {
  position: absolute;
  top: 2px;
  left: 20px;
  background: var(--Tertiary-500, #D92D20);
  border-radius: 50px;
  color: #FFF;
  font-family: Inter;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  line-height: 10px;
  min-width: 17px;
  min-height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn.btn-notification.btn-notification-active {
  border-radius: 8px;
  border: 1px solid var(--Primary-300, #D6BBFB);
  background: var(--Primary-100, #F4EBFF);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
}
.btn.btn-notification.btn-notification-active svg path {
  stroke: #7F56D9;
}
.btn.btn-notification svg path {
  stroke: #98A2B3;
}

.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.login-page-wrapper {
  max-width: 450px;
  width: 100%;
  padding-top: 40px;
}
.login-page .login-padding {
  padding-top: 143px;
}
.login-page .form-title {
  margin-bottom: 32px;
}
.login-page .form-title h2 {
  color: var(--secondary-eading, #101828);
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 12px;
  text-align: center;
}
.login-page .form-title p {
  color: var(--secondary-text, #667085);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 0;
}
.login-page .btn.btn-full {
  padding: 17px;
}
.login-page .info {
  color: var(--secondary-on-surface, #98A2B3);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
.login-page .login-bottom {
  border-top: 1px solid #EAECF0;
  margin-top: 32px;
  padding-top: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-page .login-bottom.login-bottom-center {
  justify-content: center;
}
.login-page .login-bottom p {
  color: var(--secondary-text, #667085);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 0;
}
.login-page .login-bottom a {
  color: var(--primary-700, #6941C6);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
}
.login-page a {
  color: var(--primary-700, #6941C6);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
}
.login-page .link-forgot {
  text-align: right;
  margin-left: auto;
  display: table;
  margin-bottom: 24px;
}
.login-page .form-control-item-login {
  position: relative;
}
.login-page .back-to {
  display: flex;
  align-items: center;
}
.login-page .back-to svg {
  margin-right: 10px;
}
.login-page .show-password {
  position: absolute;
  top: 10px;
  right: 15px;
}
.login-page .icon-login {
  position: absolute;
  top: 10px;
  left: 15px;
}
.login-page .form-control {
  padding: 12px 45px;
}
.login-page .form-control-default {
  padding: 12px 16px;
}

.table-default .th {
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  background: #F9FAFB;
  padding: 12px;
  display: table-cell;
  border-bottom: 1px solid var(--divider, #EAECF0);
}
.table-default .th.th-center {
  text-align: center;
}
.table-default .th.th-big {
  width: 100%;
}
.table-default .th .th-total {
  margin-left: 7px;
  color: var(--primary-600, #7F56D9);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.table-default .th:first-child {
  border-radius: 8px 0 0 0;
}
.table-default .th:last-child {
  border-radius: 0 8px 0 0;
}
.table-default .td {
  padding: 16px 24px;
  border-bottom: 1px solid var(--divider, #EAECF0);
  display: table-cell;
  color: var(--secondary-text, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
  vertical-align: middle;
}
@media screen and (min-width: 1300px) {
  .table-default .td.td-action {
    min-width: 500px;
  }
  .table-default .td.td-name {
    width: 270px;
  }
  .table-default .td.td-facility {
    width: 270px;
  }
}
@media screen and (max-width: 1300px) {
  .table-default .td.td-action {
    min-width: 250px;
  }
  .table-default .td.td-name {
    min-width: 150px;
  }
  .table-default .td.td-facility {
    min-width: 150px;
  }
}
.table-default .td.td-center {
  text-align: center;
}
.table-default .td.td-actions .d-flex {
  justify-content: flex-end;
}
.table-default .td.td-actions .btn-icon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  justify-content: center;
  align-content: center;
  transition: all 0.25s ease;
  opacity: 0;
}
.table-default .td.td-actions .btn-icon i::before {
  color: #667085;
}
.table-default .td.td-center {
  text-align: center;
}
.table-default .td.td-big {
  width: 30%;
}
.table-default .td strong {
  color: var(--secondary-dark, #101828);
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table-default .tr-deactivated .td {
  background: var(--secondary-surface, #F9FAFB);
  color: var(--secondary-base, #CBD2E0);
}
.table-default .tr-deactivated .td strong {
  color: var(--secondary-text, #667085);
}
.table-default .tr-full {
  display: block;
}
.table-default .table {
  display: table;
}
.table-default .table-wrapper {
  border: 1px solid var(--divider, #EAECF0);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  border-radius: 8px;
  background: #FFF;
}
.table-default .thead {
  display: table-header-group;
}
.table-default .tbody {
  display: table-row-group;
}
.table-default .tr {
  display: table-row;
}
.table-default .tr.tr-active .td {
  background: var(--primary-50, #F9F5FF);
}
.table-default .tr:hover .td {
  background: var(--primary-50, #F9F5FF);
}
.table-default .tr:hover .td.td-actions .btn {
  opacity: 1;
}
.table-default .th-checkbox,
.table-default .td-checkbox {
  width: 60px;
  position: relative;
}
.table-default .th-checkbox .form-control-checkbox,
.table-default .td-checkbox .form-control-checkbox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.table-default .th-checkbox .form-control-checkbox span,
.table-default .td-checkbox .form-control-checkbox span {
  width: 20px;
  height: 20px;
  padding: 0;
}
.table-default .form-control-checkbox span {
  display: block;
}
.table-default .form-control-checkbox span::before {
  border: 1px solid var(--wf-base-800, #CBD2E0);
  background: #fff;
}
.table-default .form-control-checkbox input:checked + span::before {
  border: 1px solid var(--wf-base-800, #2D3648);
}
.table-default .form-control-checkbox input:checked + span::after {
  left: 4px;
}

.table-border .table {
  border: 1px solid #CBD2E0;
  border-radius: 10px;
}
.table-border .th {
  padding: 14px 20px;
}
.table-border .th:first-child {
  border-radius: 10px 0 0 0;
}
.table-border .th:last-child {
  border-radius: 0 10px 0 0;
}
.table-border .tr:last-child .td {
  border: 0;
}

.table-responsive {
  overflow-x: auto;
  overflow-y: visible;
  max-width: 100%;
  padding: 0 0 15px;
  width: 100%;
}

.table-full .table {
  width: 100%;
}

.ReactModal__Overlay {
  z-index: 999;
  position: fixed;
  inset: 0px;
  padding-top: 90px;
  padding-bottom: 40px;
  background: rgba(0, 0, 0, 0.3) !important;
  overflow-y: auto;
}
.ReactModal__Overlay .modal-default {
  width: 100%;
  max-width: 640px;
  padding: 32px 32px 0;
  margin: 0 auto;
  border-radius: 8px;
  background: var(--secondary-surface, #f9fafb);
  position: relative;
}
.ReactModal__Overlay .modal-default.modal-no-footer {
  padding-bottom: 32px;
}
.ReactModal__Overlay .modal-default .group {
  padding: 18px;
  border-radius: 8px;
  border-left: 4px solid #f4ebff;
  background-color: #ffffff;
  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1019607843);
}
.ReactModal__Overlay .modal-default .group__title {
  display: inline-flex;
  gap: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  align-items: center;
  color: var(--Secondary-Text, #667085);
}
.ReactModal__Overlay .modal-default .group__body {
  margin-top: 16px;
}
.ReactModal__Overlay .modal-sms {
  max-width: 740px;
}
.ReactModal__Overlay .modal-sms .w-full {
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
}
.ReactModal__Overlay .modal-sms .form-control-item {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
}
@media screen and (min-width: 740px) {
  .ReactModal__Overlay .modal-sms .form-control-item.w-50 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 10px);
    max-width: calc(50% - 10px);
    width: calc(50% - 10px);
  }
}
.ReactModal__Overlay .modal-alert {
  max-width: 462px;
  padding: 32px 32px 0;
  border-radius: var(--Corner-radius-main, 8px);
  background: var(--On-Primary, #fff);
  box-shadow: 0 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.ReactModal__Overlay .modal-alert.without-footer {
  padding: 32px;
}
.ReactModal__Overlay .modal-alert h3 {
  color: var(--secondary-dark, #101828);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 8px;
}
.ReactModal__Overlay .modal-alert p {
  color: var(--secondary-text, #667085);
  font-feature-settings: "calt" off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
}
.ReactModal__Overlay .modal-alert .modal-footer {
  border-top: 0;
}
.ReactModal__Overlay .modal-subheader {
  color: var(--secondary-dark, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  margin-bottom: 29px;
  margin-top: -28px;
}
.ReactModal__Overlay .modal-header {
  color: #2d3648;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
.ReactModal__Overlay .modal-header .btn.btn-icon {
  box-shadow: none;
}
.ReactModal__Overlay .modal-footer {
  display: flex;
  margin-top: 32px;
  margin-left: -32px;
  margin-right: -32px;
  align-items: center;
  justify-content: space-between;
  background: var(--on-primary, #fff);
  border-top: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
  padding: 32px;
}
.ReactModal__Overlay .icon-icon-x {
  font-size: 24px;
}

.modal-export .library-wrapper {
  max-height: 450px;
  overflow-y: auto;
}
.modal-export .table-wrapper {
  max-height: 450px;
  overflow-y: auto;
}

.company-profile-header {
  display: flex;
  margin-bottom: 32px;
  justify-content: space-between;
}
.company-profile-header-action {
  display: flex;
  align-items: center;
}
.company-profile-header-action .btn {
  margin-left: 16px;
}
.company-profile-title {
  color: var(--wf-base-800, #2d3648);
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.company-profile-title .facility-title {
  color: var(--gray-900, #101828);
  margin-left: 14px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.company-profile .date-add {
  color: rgba(45, 54, 72, 0.5);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
}
.company-profile-subtitle {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.16px;
}
.company-profile-subtitle .text-secondary {
  color: rgba(45, 54, 72, 0.5);
}
.company-profile-secondary-text {
  color: var(--secondary-text, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 8px;
}
.company-profile-content {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 32px;
}
.company-profile .empty-page {
  margin-top: 0;
}
.company-profile-facilities-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}
.company-profile-facilities-grid.company-profile-user-group-grid {
  grid-row-gap: 0;
  grid-column-gap: 20px;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(10, min-content);
  grid-auto-flow: column;
}
.company-profile-facilities-grid.company-profile-user-group-grid .company-profile-facilities-item {
  margin-bottom: 20px;
}
@media screen and (min-width: 1600px) {
  .company-profile-facilities-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media screen and (max-width: 992px) {
  .company-profile-facilities-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .company-profile-facilities-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
.company-profile-tab .company-profile-title {
  color: var(--wf-base-800, #2d3648);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  margin-bottom: 24px;
}
.company-profile-facilities-item {
  border-radius: 10px;
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
  background: var(--on-primary, #fff);
  padding: 20px;
}
.company-profile-facilities-item .btn {
  padding: 10px;
}
.company-profile-facilities-item .title {
  color: var(--primary-600, #7f56d9);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.company-profile-facilities-item .sub-title {
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}
.company-profile-facilities-item .subtitle {
  color: var(--secondary-on-surface, #98a2b3);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.25px;
  margin-bottom: 24px;
}
.company-profile-facilities-item table td {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
  padding: 5px 0;
}
.company-profile-facilities-item table td:first-child {
  color: rgba(45, 54, 72, 0.5);
  padding-right: 20px;
}
.company-profile-facilities-item table td:last-child {
  color: var(--wf-base-800, #2d3648);
}
.company-profile-facilities-item-disabled {
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  background: var(--secondary-surface, #f9fafb);
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
}
.company-profile-facilities-item-disabled .subtitle-deactivated {
  color: var(--tertiary-600, #b42318);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.25px;
  margin-bottom: 24px;
}
.company-profile-facilities-item-disabled .title {
  color: var(--secondary-on-surface, #98a2b3);
}
.company-profile-facilities-item-disabled table td:first-child {
  color: var(--secondary-on-surface, #98a2b3);
}
.company-profile-facilities-item-disabled table td:last-child {
  color: var(--secondary-dark, #101828);
}
.company-profile-person {
  flex: 0 0 25%;
  max-width: 25%;
  width: 25%;
}
.company-profile-person ul li {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  color: var(--secondary-text, #667085);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  word-break: break-all;
}
.company-profile-person ul li strong {
  color: var(--secondary-dark, #101828);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}
.company-profile-person ul li a {
  color: var(--primary-700, #6941c6);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
}
.company-profile-person ul li i {
  opacity: 0.25;
  font-size: 20px;
}
.company-profile-person ul li img {
  width: 20px;
  opacity: 0.25;
}
.company-profile-person ul li:first-child {
  color: var(--text-black-100, #202024);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.25px;
}
.company-profile-file {
  flex: 0 0 50%;
  max-width: 50%;
  width: 50%;
}
.company-profile-file li {
  margin-right: 16px;
}
.company-profile-file .company-profile-file-add {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;
  border: 1px dashed #cbd2e0;
  padding: 10px;
  color: #2d3648;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.14px;
  word-wrap: break-word;
  width: 115px;
  height: 115px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}
.company-profile-file .company-profile-file-add input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
}
.company-profile-file .company-profile-file-add i {
  font-size: 24px;
  margin-bottom: 10px;
}
.company-profile-file .company-profile-file-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid #cbd2e0;
  padding: 10px 25px;
  color: #2d3648;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.14px;
  word-break: break-all;
  width: 115px;
  height: 115px;
}
.company-profile-file .company-profile-file-item i {
  font-size: 24px;
  margin-bottom: 10px;
}

.select-action-form-control .react-select__menu {
  min-width: unset !important;
}

.user-group-profile-content {
  display: flex;
}
.user-group-profile-content .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--secondary-text, #667085);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 24px;
}
.user-group-profile-content .title span {
  display: flex;
  align-items: center;
}
.user-group-profile-content .table-responsive {
  padding-top: 0;
}
.user-group-profile-content .table-responsive .icon-remove:before {
  color: #ffb8b8;
  cursor: pointer;
}
.user-group-profile-content .user-group-content-users {
  flex: 0 0 50%;
  max-width: 50%;
  width: 50%;
  padding-right: 20px;
}
.user-group-profile-content .user-group-content-permissions {
  flex: 0 0 50%;
  max-width: 50%;
  width: 50%;
  padding-left: 20px;
}
.user-group-profile-content .user-group-content-permissions .item {
  border-radius: 10px;
  border: 1px solid var(--divider, #eaecf0);
  background: var(--On-Primary, #fff);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  margin-bottom: 20px;
  padding: 20px;
}
.user-group-profile-content .user-group-content-permissions .item .item-title {
  color: var(--primary-600, #7f56d9);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  padding-right: 80px;
}
.user-group-profile-content .user-group-content-permissions .item .item-title .dropdown {
  position: absolute;
  top: 0;
  right: 0;
}
.user-group-profile-content .user-group-content-permissions .item p {
  color: var(--secondary-text, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 10px;
}
.user-group-profile-content .user-group-content-permissions .item ul {
  column-gap: 10px;
  row-gap: 10px;
}
.user-group-profile-content .user-group-content-permissions .item li {
  color: var(--secondary-dark, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
}

.user-profile-header {
  display: flex;
  align-items: center;
}
.user-profile-header .avatar {
  width: 48px;
  height: 48px;
  font-size: 18px;
  margin-right: 12px;
}
.user-profile-header .company-profile-title {
  margin-bottom: 0;
  font-size: 24px;
}
.user-profile-header .company-profile-subtitle {
  color: var(--text-grey-50, #85878f);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
  letter-spacing: -0.13px;
}

.export-pdf {
  padding-left: 178px;
  padding-top: 26px;
}
.export-pdf .export-pdf-action {
  display: flex;
  padding-top: 16px;
}
.export-pdf .export-pdf-item {
  display: flex;
  margin-bottom: 16px;
}
.export-pdf .export-pdf-item .form-item {
  margin-bottom: 16px;
}
.export-pdf .export-pdf-item .form-item .d-flex {
  width: 100%;
}
.export-pdf .export-pdf-item .form-item .form-item-mail {
  max-width: calc(100% - 34px);
  width: 100%;
}
.export-pdf .export-pdf-item .form-item .btn-icon {
  margin-left: 18px;
}
.export-pdf .export-pdf-item .form-item .btn-icon i:before {
  color: rgb(180, 35, 24);
}
.export-pdf .export-pdf-item .export-pdf-item-inputs {
  max-width: 380px;
  width: 100%;
  position: relative;
}
.export-pdf .export-pdf-item .export-pdf-item-inputs.export-pdf-item-inputs-checkbox {
  display: flex;
  align-items: center;
}
.export-pdf .export-pdf-item .export-pdf-item-inputs.export-pdf-item-inputs-checkbox .form-error {
  position: absolute;
  top: calc(100% - 24px);
  left: 0;
}
.export-pdf .export-pdf-item .export-pdf-item-inputs.export-pdf-item-inputs-checkbox .form-control-checkbox {
  margin-right: 76px;
}
.export-pdf .export-pdf-item .export-pdf-item-inputs.export-pdf-item-inputs-checkbox .form-control-checkbox:last-child {
  margin-right: 0;
}
.export-pdf .export-pdf-item .export-pdf-item-label {
  max-width: 471px;
  width: 100%;
  margin-right: 24px;
}
.export-pdf .export-pdf-item .export-pdf-item-label h3 {
  color: var(--Secondary-eading, #101828);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 12px;
}
.export-pdf .export-pdf-item .export-pdf-item-label p {
  color: var(--Secondary-Text, #667085);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
}

.user-profile-tab .react-tabs__tab-panel {
  padding: 30px 0;
}
.user-profile-tab .library {
  padding: 0;
}
.user-profile-tab .company-profile-title {
  color: var(--secondary-text, #667085);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
}
.user-profile-tab .user-profile-tab-content {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #cbd2e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.user-profile-tab .user-profile-tab-content-auto {
  column-gap: 80px;
}
.user-profile-tab .user-profile-tab-content:last-child {
  border-bottom: 0;
  margin-bottom: 0;
}
.user-profile-tab .user-profile-tab-user-group {
  flex: 0 0 50%;
  max-width: 50%;
  width: 50%;
  display: flex;
}
.user-profile-tab .user-profile-tab-user-group > div {
  padding-right: 20px;
}
.user-profile-tab .user-profile-tab-user-group > div:first-child {
  min-width: 120px;
}
.user-profile-tab .user-profile-tab-user-group .title {
  color: rgba(45, 54, 72, 0.5);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  margin-bottom: 8px;
}
.user-profile-tab .user-profile-tab-user-group p {
  margin-bottom: 8px;
}
.user-profile-tab .user-profile-tab-user-group .show-more {
  color: var(--primary-600, #7f56d9);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.user-profile-tab .user-profile-tab-item {
  flex: 0 0 25%;
  max-width: 25%;
  width: 25%;
  padding-right: 15px;
}
.user-profile-tab .user-profile-tab-item.user-profile-tab-item-auto {
  flex: 0 0 auto;
  max-width: 100%;
  width: auto;
}
.user-profile-tab .user-profile-tab-item .title {
  color: rgba(45, 54, 72, 0.5);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  margin-bottom: 8px;
}
.user-profile-tab .user-profile-tab-item p {
  color: var(--secondary-dark, #101828);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 8px;
  min-height: 20px;
  word-break: break-word;
}
.user-profile-tab .user-profile-tab-item p:last-child {
  margin-bottom: 0;
}

.empty-page {
  text-align: center;
  margin-top: 60px;
}
.empty-page-title {
  color: var(--secondary-dark, #101828);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 8px;
}
.empty-page-subtitle {
  color: var(--secondary-text, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  max-width: 538px;
  margin: 0 auto 60px;
}

.page-wrapper.page-wrapper-deactivated {
  background: var(--secondary-surface, #f9fafb);
}
.page-wrapper.page-wrapper-deactivated .company-profile-title {
  color: var(--secondary-on-surface, #98a2b3);
}
.page-wrapper.page-wrapper-deactivated .date-add-deactivated {
  color: var(--tertiary-600, #b42318);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  margin-left: 15px;
}
.page-wrapper.page-wrapper-deactivated .form-control,
.page-wrapper.page-wrapper-deactivated .form-control-file,
.page-wrapper.page-wrapper-deactivated .company-profile-tab .btn {
  pointer-events: none !important;
}

.empty-table {
  text-align: center;
  height: 138px;
  display: table-row;
  position: relative;
}
.empty-table > div {
  position: absolute;
  top: 0;
  left: 0;
  height: 138px;
  width: 100%;
  padding: 40px;
}
.empty-table p {
  margin-bottom: 8px;
  color: var(--secondary-text, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  text-align: center;
}
.empty-table p strong {
  color: var(--secondary-dark, #101828);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.empty-action {
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  border: 1px solid var(--divider, #eaecf0);
  border-radius: 8px;
  height: 186px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}
.empty-action p {
  margin-bottom: 8px;
  color: var(--secondary-text, #667085);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.14px;
  text-align: center;
}
.empty-action p strong {
  color: var(--secondary-dark, #101828);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.special {
  color: var(--primary-600, #7f56d9);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-left: 20px;
  line-height: 150%;
  border-radius: 56px;
  background: var(--primary-50, #f9f5ff);
  padding: 4px 12px;
}

.company-profile-empty {
  border-radius: 10px;
  border: 1px solid var(--divider, #eaecf0);
  background: var(--On-Primary, #fff);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1);
  padding: 45px 20px;
}
.company-profile-empty h3 {
  color: var(--secondary-eading, #101828);
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  max-width: 350px;
  margin: 0 auto 12px;
}
.company-profile-empty p {
  color: var(--secondary-text, #667085);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin: 0 auto;
  max-width: 350px;
}

.react-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 12px 164px;
}
.react-pagination .previous,
.react-pagination .next {
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
}
.react-pagination .previous a,
.react-pagination .next a {
  border-radius: 8px;
  border: 1px solid var(--divider, #EAECF0);
  background: var(--on-primary, #FFF);
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  padding: 9px 14px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #101828;
  cursor: pointer;
}
.react-pagination .previous.disabled a,
.react-pagination .next.disabled a {
  pointer-events: none;
  opacity: 0.5;
}
.react-pagination .next {
  right: 24px;
  left: auto;
}
.react-pagination li:not(.previous):not(.next) a {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border-radius: 8px;
  cursor: pointer;
}
.react-pagination li:not(.previous):not(.next).selected a {
  color: #7F56D9;
  background: var(--primary-50, #F9F5FF);
}
.react-pagination li:not(.previous):not(.next).active a {
  color: #7F56D9;
  background: var(--primary-50, #F9F5FF);
}

.dropdown {
  position: relative;
}
.dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  border-radius: var(--corner-radius-main, 8px);
  background: var(--on-primary, #FFF);
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  padding: 16px;
  min-width: 116px;
  z-index: 99;
}
.dropdown li {
  margin-bottom: 10px;
}
.dropdown li:last-child {
  margin-bottom: 0;
}

.react-datepicker-popper .react-datepicker {
  border-radius: var(--Corner-radius-main, 8px);
  background: var(--On-Primary, #fff);
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  border: 0;
  padding: 12px;
}
.react-datepicker-popper .react-datepicker .react-datepicker__navigation--previous {
  right: 56px;
  left: auto;
}
.react-datepicker-popper .react-datepicker .react-datepicker__navigation--next {
  right: 20px;
}
.react-datepicker-popper .react-datepicker .react-datepicker__header {
  padding: 0;
  background-color: #fff;
  border-bottom: 0;
  margin: 0;
}
.react-datepicker-popper .react-datepicker .react-datepicker__header .react-datepicker__current-month {
  text-align: left;
  padding: 14px 16px;
  color: var(--secondary-eading, #101828);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
}
.react-datepicker-popper .react-datepicker .react-datepicker__triangle {
  display: none;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day--today,
.react-datepicker-popper .react-datepicker .react-datepicker__day--keyboard-selected.react-datepicker__day--today {
  background: var(--Primary-100, #f4ebff);
}
.react-datepicker-popper .react-datepicker .react-datepicker__day--keyboard-selected {
  background: transparent;
}
.react-datepicker-popper .react-datepicker .react-datepicker__year-read-view--down-arrow,
.react-datepicker-popper .react-datepicker .react-datepicker__month-read-view--down-arrow,
.react-datepicker-popper .react-datepicker .react-datepicker__month-year-read-view--down-arrow,
.react-datepicker-popper .react-datepicker .react-datepicker__navigation-icon::before {
  border-color: #101828;
  border-width: 2px 2px 0 0;
  top: 10px;
  border-radius: 0 0 0 2px;
}
.react-datepicker-popper .react-datepicker .react-datepicker__navigation {
  top: 15px;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day-name {
  width: 48px;
  height: 48px;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day {
  width: 48px;
  height: 48px;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  color: var(--secondary-eading, #101828);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.5px;
  border: 1px solid transparent;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day.react-datepicker__day--disabled {
  pointer-events: none;
  opacity: 0.5;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day.react-datepicker__day--selected, .react-datepicker-popper .react-datepicker .react-datepicker__day.react-datepicker__day--in-range {
  color: #7f56d9;
  border: 1px solid #7f56d9;
  background: transparent;
}
.react-datepicker-popper .react-datepicker .react-datepicker__day:hover, .react-datepicker-popper .react-datepicker .react-datepicker__day.react-datepicker__day--in-selecting-range {
  color: var(--On-Primary, #fff);
  background: var(--primary-600, #7f56d9);
}
.react-datepicker-popper .react-datepicker .react-datepicker__month {
  margin: 10px 0 0;
}

.react-datepicker-wrapper .react-datepicker__close-icon {
  width: 20px;
  height: 20px;
  background: #fff;
  right: 12px;
  top: 10px;
  z-index: 3;
}
.react-datepicker-wrapper .react-datepicker__close-icon::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center;
  z-index: -1;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
}

.react-datepicker-popper {
  z-index: 99 !important;
}

.time-select {
  margin: 0 -15px;
}
.time-select .form-item {
  width: 50%;
  padding: 0 15px;
}

.form-item-time .react-datepicker__tab-loop {
  position: relative;
}
.form-item-time .react-datepicker-popper {
  width: 100%;
}
.form-item-time .react-datepicker-popper .react-datepicker {
  width: 100%;
  padding: 0;
}
.form-item-time .react-datepicker-popper .react-datepicker__time-container {
  width: 100%;
}
.form-item-time .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 100%;
  border-radius: 0 0 6px 6px;
  padding: 5px 0;
}
.form-item-time .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  width: 100%;
  position: relative;
  background: var(--primary-50, #fff);
  color: var(--secondary-dark, #101828);
  font-feature-settings: "calt" off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding-left: 50px;
  height: 44px;
  margin-bottom: 0;
}
.form-item-time .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  background: var(--primary-50, #f9f5ff);
}
.form-item-time .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 9px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 1px solid var(--secondary-base, #cbd2e0);
  background: var(--On-Primary, #fff);
}
.form-item-time .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item.react-datepicker__time-list-item--selected {
  color: var(--secondary-dark, #101828);
}
.form-item-time .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item.react-datepicker__time-list-item--selected::before {
  border: 1px solid var(--primary-600, #7f56d9);
}
.form-item-time .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item.react-datepicker__time-list-item--selected::after {
  content: "";
  border-radius: 100%;
  width: 14px;
  height: 14px;
  position: absolute;
  left: 19px;
  top: 13px;
  background: #7f56d9;
}

.multi-date-picker .rmdp-container {
  width: 100%;
  position: relative;
}
.multi-date-picker .rmdp-ep-arrow {
  display: none;
}
.multi-date-picker .rmdp-day,
.multi-date-picker .rmdp-week-day {
  width: 48px;
  height: 48px;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  color: var(--secondary-eading, #101828);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.5px;
  border: 1px solid transparent;
}
.multi-date-picker .rmdp-arrow {
  border: solid #7f56d9;
  border-width: 0 2px 2px 0;
  width: 10px;
  height: 10px;
  margin-top: -3px;
}
.multi-date-picker .rmdp-header-values span {
  color: var(--secondary-eading, #101828);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
}
.multi-date-picker .rmdp-arrow-container:hover .rmdp-arrow {
  border: solid #7f56d9;
  border-width: 0 2px 2px 0;
}
.multi-date-picker .rmdp-left i {
  margin-top: 7px;
  margin-left: 1px;
}
.multi-date-picker .rmdp-right i {
  margin-top: 7px;
  margin-right: 2px;
}
.multi-date-picker .rmdp-arrow-container:hover {
  background-color: transparent;
  box-shadow: none;
}
.multi-date-picker .rmdp-day.rmdp-selected span:not(.highlight) {
  color: #fff;
  border: 1px solid #7f56d9;
  background: #7f56d9;
}
.multi-date-picker .rmdp-day:not(.rmdp-disabled, .rmdp-day-hidden) span:hover {
  border: 1px solid #7f56d9;
  background: #7f56d9;
}
.multi-date-picker .rmdp-day.rmdp-today span {
  color: var(--secondary-eading, #101828);
  background: var(--Primary-100, #f4ebff);
}
.multi-date-picker .rmdp-header-value {
  margin: 0;
}
.multi-date-picker .rmdp-input {
  border-radius: 6px;
  border: 1px solid var(--wf-base-400, #cbd2e0);
  background: var(--wf-base-white, #fff);
  height: 44px;
  padding: 12px 12px 12px 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.14px;
  color: #2d3648;
  width: 100%;
}
.multi-date-picker .rmdp-input::placeholder {
  color: #98a2b3;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
  opacity: 0.5;
}
.multi-date-picker.disabled-change-month .rmdp-header {
  display: none;
}
.multi-date-picker.disabled-change-month .rmdp-day-picker .rmdp-week:first-child {
  display: none !important;
}

.form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(1), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(2), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(3), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(4), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(5), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(6), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(8), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(10), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(12), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(14), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(16), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(18), .form-item-time.form-item-time-short .react-datepicker-popper .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:nth-child(20) {
  display: none !important;
}

.multi-date-picker .clear-datepicker {
  position: relative;
}
.multi-date-picker .clear-datepicker .rmdp-input {
  padding: 12px 53px 12px 16px;
}
.multi-date-picker .clear-datepicker .clear {
  position: absolute;
  top: 11px;
  right: 3px;
  background: transparent;
  border: 0;
  z-index: 2;
  opacity: 0.5;
}

.loader {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999;
}
.loader__content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loader__item {
  width: 140px;
  height: 12px;
  display: flex;
  background-color: white;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  box-shadow: inset 0 0 0 2px #7F56D9, 0 3px 9px -2px rgba(0, 48, 135, 0.4);
  z-index: 1;
}
.loader__item:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #7F56D9;
  border-radius: inherit;
  animation: loading 3s cubic-bezier(0.57, 0.48, 0.21, 1.23) infinite;
}
@keyframes loading {
  0% {
    width: 16px;
    left: 0;
  }
  25% {
    width: 100%;
    left: 0;
  }
  50% {
    width: 16px;
    left: calc(100% - 16px);
  }
  75% {
    width: 100%;
    left: 0;
  }
  100% {
    width: 16px;
    left: 0;
  }
}
.loader__text {
  margin-top: 24px;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0.2px;
  color: #666a76;
  animation: text 3s cubic-bezier(0.57, 0.48, 0.21, 1.23) infinite;
}
@keyframes text {
  0% {
    opacity: 0.1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.1;
  }
}

.old-home-page {
  min-height: 100vh;
  padding: 25px 16px;
}
@media screen and (min-width: 992px) {
  .old-home-page {
    padding: 17px 65px 65px;
  }
}
.old-home-page .home-wrapper {
  margin: 0 auto;
  max-width: 1789px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media screen and (max-width: 700px) {
  .old-home-page .home-wrapper {
    justify-content: center;
  }
}
.old-home-page .home-contact {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 57px;
}
@media screen and (max-width: 700px) {
  .old-home-page .home-contact {
    order: 2;
    display: block;
  }
  .old-home-page .home-contact a {
    display: block;
    margin-bottom: 12px;
  }
  .old-home-page .home-contact a:last-child {
    margin-bottom: 0;
  }
}
.old-home-page .home-contact a {
  color: #01051f;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
}
.old-home-page .home-logo {
  display: flex;
  align-items: center;
}
.old-home-page .home-logo img {
  max-height: 40px;
}
.old-home-page .home-content {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
  margin-top: 12px;
  border-radius: 45px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat bottom center;
  text-align: center;
  min-height: calc(100vh - 200px);
  display: flex;
  align-items: center;
  flex-direction: column;
  background-size: cover;
}
@media screen and (max-width: 700px) {
  .old-home-page .home-content {
    margin-top: 25px;
    margin-bottom: 25px;
    padding: 116px 0;
  }
}
@media screen and (min-width: 768px) {
  .old-home-page .home-content {
    min-height: calc(100vh - 103px);
    padding: 116px 0;
  }
}
@media screen and (min-width: 992px) {
  .old-home-page .home-content {
    padding-top: 225px;
    display: block;
    min-height: calc(100vh - 130px);
  }
}
.old-home-page .home-content h1 {
  color: #fff;
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 800;
  line-height: 110%; /* 41.8px */
  text-transform: capitalize;
  margin: 0;
}
@media screen and (max-width: 700px) {
  .old-home-page .home-content h1 {
    font-size: 24px;
    max-width: 300px;
  }
}
@media screen and (min-width: 992px) {
  .old-home-page .home-content h1 {
    font-size: 38px;
  }
}
.old-home-page .home-content p {
  color: #fff;
  font-family: Inter;
  font-size: 27px;
  font-style: italic;
  font-weight: 200;
  line-height: 120%; /* 38.4px */
  letter-spacing: -0.32px;
  text-transform: uppercase;
  margin: 8px 0;
}
@media screen and (max-width: 700px) {
  .old-home-page .home-content p {
    font-size: 18px;
  }
}
@media screen and (min-width: 992px) {
  .old-home-page .home-content p {
    font-size: 32px;
  }
}
.old-home-page .home-content h2 {
  color: #fff;
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 45.6px */
  letter-spacing: -0.38px;
  text-transform: capitalize;
  margin-bottom: 40px;
}
@media screen and (max-width: 700px) {
  .old-home-page .home-content h2 {
    font-size: 16px;
    max-width: 201px;
  }
}
@media screen and (min-width: 992px) {
  .old-home-page .home-content h2 {
    font-size: 38px;
  }
}
.old-home-page .home-content .btn {
  color: #16038f;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  border-radius: var(--Corner-radius-main, 8px);
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  min-width: 201px;
  border: 0;
  display: inline-block;
}

.init-form-tab-content .form-builder-element-preview.with-aside-settings {
  width: calc(100% + 80px);
  max-width: initial;
}
.init-form-tab-content .form-builder-element-preview.with-aside-settings:hover .init-form-aside-buttons {
  display: flex;
}
.init-form-tab-content .form-builder-element-preview.with-aside-settings .element-wrapper,
.init-form-tab-content .form-builder-element-preview.with-aside-settings .link-element-wrapper {
  position: relative;
}
.init-form-tab-content .form-builder-element-preview.with-aside-settings .element-wrapper .element-inner,
.init-form-tab-content .form-builder-element-preview.with-aside-settings .link-element-wrapper .element-inner {
  width: calc(100% - 80px);
}

.checkbox-element-settings-modal .form-control-item {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  align-items: center;
}

.init-form-aside-buttons {
  top: 50%;
  left: calc(100% - 48px);
  display: none;
  gap: 8px;
  flex-direction: column;
  position: absolute;
  transform: translateY(-50%);
  z-index: 1;
}
.init-form-aside-buttons .btn-settings {
  width: 38px;
  height: 38px;
  display: inline-flex;
  font-size: 20px;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid var(--secondary-input-outline, #DADEE4);
  cursor: pointer;
}
.init-form-aside-buttons .btn-settings .icon-settings {
  font-size: 20px;
  color: var(--wf-base-600, #717D96);
}
.init-form-aside-buttons .btn-settings.btn-remove {
  border: 1px solid var(--secondary-input-outline, #FDA29B);
}

.tasks-wrapper {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 20px;
  max-width: 100%;
}
@media screen and (min-width: 1600px) {
  .tasks-wrapper {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media screen and (max-width: 992px) {
  .tasks-wrapper {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media screen and (max-width: 768px) {
  .tasks-wrapper {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

body,
html,
*::placeholder {
  margin: 0;
  font-family: "Inter", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body.ReactModal__Body--open {
  overflow: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

* {
  box-sizing: border-box;
}

.library-sub-title-index-mobile,
.library-title-index-mobile,
.btn-mobile,
.mobile-button,
.tabs-mobile,
.library-title-mobile {
  display: none;
}

.sigCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sigCanvas-wrapper {
  position: relative;
  height: 150px;
}

.btn-mobile {
  display: none !important;
}

.send-form-wrapper-mobile {
  display: none;
}

@media (max-width: 650px) {
  .ReactModal__Overlay .modal-default.modal-number {
    max-width: 300px;
  }
}
.mobile .send-form-wrapper-mobile {
  margin-top: 35px;
  padding: 0 24px;
  display: flex;
  justify-content: flex-end;
}
.mobile .library-item .library-item-text {
  font-size: 16px;
}
.mobile .btn-notification {
  display: none;
}
.mobile .mobile-button {
  display: block;
}
.mobile .sidebar-menu {
  display: none;
}
.mobile .form-builder-wrapper main.send-page {
  padding: 0;
  background: #fff;
}
.mobile .send-form-wrapper {
  display: none;
}
.mobile .render-form {
  border-radius: 0;
  border: 0;
  padding-bottom: 80px;
  box-shadow: none;
}
.mobile .render-form__copy-group {
  padding-bottom: 24px;
}
.mobile .render-form__copy-group__actions {
  display: flex;
  justify-content: flex-end;
}
.mobile .render-form__copy-group__remove-btn {
  width: auto;
  margin-top: 24px;
  margin-left: 24px;
  margin-right: 24px;
  padding-left: 8px;
  padding-right: 8px;
  transform: none;
  position: static;
}
.mobile .render-form__copy-group__remove-btn .label {
  display: initial;
  margin-left: 6px;
}
.mobile .btn-mobile {
  display: block !important;
}
.mobile .send-page .form-control-actions .btn:not(.btn-mobile) {
  display: none;
}
.mobile .library {
  padding: 0 24px 24px;
}
.mobile .form-builder-wrapper main.send-page .render-form,
.mobile .form-builder-wrapper main.send-page > div {
  max-width: 100%;
}
.mobile .form-builder-wrapper main.send-page .form-control-actions {
  position: fixed;
  left: 0;
  width: 100%;
  padding: 16px 24px;
  justify-content: space-between;
}
.mobile .from-builder-title {
  padding: 16px 24px;
}
.mobile .form-builder-wrapper main.form-builder-wrapper-settings {
  padding-left: 0;
}
.mobile .form-builder-wrapper main.form-builder-wrapper-settings .mobile-init .render-form {
  min-height: calc(100vh - 146px);
  padding-top: 24px;
}
.mobile .form-builder-wrapper main.form-builder-wrapper-settings .mobile-init .form-view-actions {
  display: flex;
  justify-content: space-between;
}
.mobile .form-builder-wrapper main.form-builder-wrapper-settings .mobile-init .form-view-actions .btn.btn-outline {
  display: inline-flex !important;
  align-items: center;
}
.mobile .form-builder-wrapper main.form-builder-wrapper-settings .mobile-init .form-builder-aside-left {
  display: none;
}
.mobile .form-builder-wrapper main.form-builder-wrapper-settings .mobile-init .init-form-tab-content {
  padding: 0;
}
.mobile .form-builder-wrapper main.form-builder-wrapper-settings .mobile-init .form-control-actions {
  display: none;
}
.mobile .form-builder-wrapper main.form-builder-wrapper-settings .mobile-init .form-view-wrapper {
  width: 100%;
}
.mobile .library-item-disabled-mobile {
  filter: grayscale(100%);
  pointer-events: none;
}
.mobile .tabs-mobile {
  display: flex;
}
.mobile .form-builder-wrapper main.default-layout {
  padding-left: 0;
}
.mobile .react-tabs__tab-list {
  display: none;
}
.mobile .header-left {
  display: none;
}
.mobile .header-right {
  width: 100%;
  justify-content: flex-end;
}
.mobile .user-menu-wrapper {
  pointer-events: none;
}
.mobile .breadcrumbs {
  display: none;
}
.mobile .library-title {
  display: none;
}
.mobile .library-filter {
  margin-top: 0;
}
.mobile .library-filter .btn.btn-outline {
  height: 44px;
}
.mobile .library-filter .btn.btn-outline.btn-down {
  transform: translateY(0px);
}
.mobile .library-item:not(.list-item) {
  margin: 0;
}
@media screen and (min-width: 540px) {
  .mobile .library-item:not(.list-item) {
    max-width: calc(50% - 8px);
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 8px);
  }
}
@media screen and (min-width: 1000px) {
  .mobile .library-item:not(.list-item) {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.3333% - 11px);
    max-width: calc(33.3333% - 11px);
  }
}
.mobile .library-item img {
  -webkit-touch-callout: none; /* Safari iOS */
  -webkit-user-select: none;
          user-select: none;
}
.mobile .library-item.submissions {
  display: none;
}
.mobile .library-item.drafts {
  display: none;
}
.mobile .library-item .library-item-button {
  display: none;
}
.mobile .library-filter .btn:not(.btn-down) {
  display: none;
}
.mobile .library-wrapper {
  gap: 16px;
  margin: 0;
}
.mobile .library-title-index-mobile {
  color: var(--Secondary-eading, #101828);
  font-family: Inter;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 16px;
  margin-top: 16px;
  display: block;
}
.mobile .library-sub-title-index-mobile {
  display: block;
  color: var(--Secondary-Text, #667085);
  /* button text */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-top: 16px;
}
.mobile .library-title-mobile {
  color: var(--Secondary-eading, #101828);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mobile .tabs-mobile-item {
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--Secondary-eading, #101828);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding: 16px 0;
  position: relative;
  margin-bottom: 24px;
}
.mobile .tabs-mobile-item::before {
  content: "";
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #6941c6;
  transform: scale(0);
}
.mobile .tabs-mobile-item.active {
  color: var(--Primary-700, #6941c6);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.mobile .tabs-mobile-item.active::before {
  transform: scale(1);
}
.mobile .login-page {
  padding: 100px 24px;
}
.mobile .modal-default .login-page {
  padding: 0;
}
.mobile .modal-default .login-page-wrapper {
  padding-top: 40px;
}
.mobile .login-page-wrapper {
  padding-top: 0;
}
.mobile .sigCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.mobile .sigCanvas-wrapper {
  position: relative;
  width: 270px;
  height: 150px;
}
.mobile .header-wrapper-login {
  display: none;
}
@media (max-width: 750px) {
  .mobile .form-control-radio-wrapper,
  .mobile .form-control-checkbox-wrapper {
    display: block;
  }
  .mobile .form-grid-item {
    margin-bottom: 32px;
  }
  .mobile .form-grid-item:last-child {
    margin-bottom: 0;
  }
  .mobile .form-builder-element-preview {
    padding: 16px 24px;
  }
  .mobile .form-grid-full-name {
    display: block;
  }
  .mobile .form-control-medium,
  .mobile .react-ios-time-picker-input-medium,
  .mobile .form-label-medium .form-label,
  .mobile .init-page .render-form .form-builder-element-preview-wrapper .form-control-radio {
    width: 100% !important;
  }
}
.mobile .from-builder-title {
  padding-right: 60px;
  border-bottom: 1px solid #eaecf0;
  border-radius: 0;
  position: relative;
  top: 0;
  width: 100%;
  background: #fff;
  z-index: 9;
}
.mobile .from-builder-title .btn-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 24px;
}
@media screen and (max-width: 575px) {
  .mobile .library-item {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }
}
.mobile .init-form-action {
  display: none;
}

.tablet .form-builder-wrapper,
.mobile .form-builder-wrapper {
  overflow: unset;
}
.tablet .header-container,
.mobile .header-container {
  justify-content: space-between !important;
}
.tablet .react-tabs,
.mobile .react-tabs {
  display: block !important;
}
.tablet .react-tabs__tab-list,
.mobile .react-tabs__tab-list {
  display: flex !important;
}
.tablet .page-wrapper.cna-assignments,
.tablet .page-wrapper.default-tasks,
.mobile .page-wrapper.cna-assignments,
.mobile .page-wrapper.default-tasks {
  padding-top: 0;
}
.tablet .page-wrapper.default-tasks .library-filter,
.mobile .page-wrapper.default-tasks .library-filter {
  margin-top: 29px;
}
.tablet .page-wrapper.default-tasks .open-add-task-modal-btn,
.mobile .page-wrapper.default-tasks .open-add-task-modal-btn {
  display: inline-flex;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/index.scss","webpack://./src/assets/style/reset.scss","webpack://./src/assets/style/icons.scss","webpack://./src/assets/style/app.scss","webpack://./src/assets/style/layout/header.scss","webpack://./src/assets/style/layout/user-menu.scss","webpack://./src/assets/style/layout/sidebar.scss","webpack://./src/assets/style/layout/main.scss","webpack://./src/assets/style/form-builder/layout.scss","webpack://./src/assets/style/generic/button.scss","webpack://./src/assets/style/generic/form-control.scss","webpack://./src/assets/style/generic/utility.scss","webpack://./src/assets/style/editor.scss","webpack://./src/assets/style/library/library.scss","webpack://./src/assets/style/auth/index.scss","webpack://./src/assets/style/generic/table.scss","webpack://./src/assets/style/generic/modal.scss","webpack://./src/assets/style/company/company.scss","webpack://./src/assets/style/generic/pagination.scss","webpack://./src/assets/style/generic/dropdown.scss","webpack://./src/assets/style/generic/datepicker.scss","webpack://./src/assets/style/generic/loader.scss","webpack://./src/assets/style/home/index.scss","webpack://./src/assets/style/init-form/index.scss","webpack://./src/assets/style/tasks/tasks.scss","webpack://./src/assets/style/responsive.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;CAAA;AAKA;;;;;;;;;;;;;EAaE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;ADEF;;ACCA,yDAAA;AACA;EACE,UAAA;ADEF;;ACCA,gDAAA;AACA;;EAEE,cAAA;ADEF;;ACCA;EACE,cAAA;ADEF;;ACCA;EACE,gBAAA;ADEF;;ACCA;EACE,YAAA;ADEF;;ACCA;;EAEE,WAAA;EACA,aAAA;ADEF;;ACCA;EACE,yBAAA;EACA,iBAAA;ADEF;;ACCA;;;;EAIE,wBAAA;EACA,qBAAA;ADEF;;ACCA;EACE,wBAAA;EACA,qBAAA;EAGA,uBAAA;ADEF;;ACCA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;ADEF;;ACCA;;EAAA;AAIA;;;EAGE,qBAAA;GDCA,eCAA;GDCA,OCAA;EACA,eAAA;ADCF;;ACEA;;;EAAA;AAKA;EACE,aAAA;EACA,SAAA;ADAF;;ACGA;;;EAAA;AAKA;EACE,aAAA;ADDF;;ACIA;;;;;EAAA;AAOA;EACE,eAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;ADFF;;ACKA;;EAAA;AAIA;EACE,oBAAA;ADHF;;ACMA;;EAAA;AAIA;;EAEE,UAAA;ADJF;;ACOA;;;EAAA;AAKA;EACE,SAAA,EAAA,MAAA;EACA,+BAAA,EAAA,MAAA;ADLF;;ACQA;;EAAA;AAIA;EACE,SAAA;ADNF;;ACSA;;EAAA;AAIA;EACE,SAAA;ADPF;;ACUA;;EAAA;AAIA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;ADRF;;ACWA;;;;EAAA;AAMA;EACE,SAAA,EAAA,MAAA;EACA,UAAA;EACA,mBAAA,EAAA,MAAA;GDTA,iBCUA,EAAA,MAAA;ADTF;;ACYA;;;;;EAAA;AAOA;;;;EAIE,eAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,wBAAA,EAAA,MAAA;GDVA,sBCWA,EAAA,MAAA;ADVF;;ACaA;;;EAAA;AAKA;;EAEE,mBAAA;ADXF;;ACcA;;;;;EAAA;AAOA;;EAEE,oBAAA;ADZF;;ACeA;;;;;;;;EAAA;AAUA;;;;EAIE,0BAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;GDbA,iBCcA,EAAA,MAAA;ADbF;;ACgBA;;EAAA;AAIA;;EAEE,eAAA;ADdF;;ACiBA;;;;;EAAA;AAOA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;GDfA,YCgBA,EAAA,MAAA;GDfA,WCgBA,EAAA,MAAA;ADfF;;ACkBA;;;;EAAA;AAMA;EACE,6BAAA,EAAA,MAAA,EAEA,MAAA;EACA,uBAAA;ADhBF;;ACmBA;;;EAAA;AAKA;;EAEE,wBAAA;ADjBF;;ACoBA;;EAAA;AAIA;;EAEE,SAAA;EACA,UAAA;ADlBF;;ACqBA;;;EAAA;AAKA;EACE,cAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;ADnBF;;ACsBA;;EAAA;AAIA;EACE,yBAAA;EACA,iBAAA;ADpBF;;ACuBA;;;;;EAKE,WAAA;ADpBF;;AC6BA;EACE,mBAAA;EACA,iBAAA;ADrBF;;ACwBA;EACE,sBAAA;ADrBF;;ACwBA;EACE,SAAA;EACA,SAAA;EACA,UAAA;ADrBF;;ACwBA;EACE,gBAAA;ADrBF;;ACwBA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;ADrBF;;AEvVA;EACE,sBAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AFuVF;AEpVA;EACE,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AFqVF;;AEnVA;EACE,gBAAA;AFsVF;;AEpVA;EACE,gBAAA;AFuVF;;AErVA;EACE,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AFwVF;;AEtVA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AFyVF;;AEvVA;EACE,gBAAA;AF0VF;;AExVA;EACE,gBAAA;AF2VF;;AEzVA;EACE,gBAAA;AF4VF;;AE1VA;EACE,gBAAA;EACA,cAAA;AF6VF;;AE3VA;EACE,gBAAA;AF8VF;;AE5VA;EACE,gBAAA;EACA,cAAA;AF+VF;;AE7VA;EACE,gBAAA;AFgWF;;AE9VA;EACE,gBAAA;AFiWF;;AE/VA;EACE,gBAAA;AFkWF;;AEhWA;EACE,gBAAA;AFmWF;;AEjWA;EACE,gBAAA;AFoWF;;AElWA;EACE,gBAAA;AFqWF;;AEnWA;EACE,gBAAA;AFsWF;;AEpWA;EACE,gBAAA;AFuWF;;AErWA;EACE,gBAAA;AFwWF;;AEtWA;EACE,gBAAA;AFyWF;;AEvWA;EACE,gBAAA;AF0WF;;AExWA;EACE,gBAAA;AF2WF;;AEzWA;EACE,gBAAA;AF4WF;;AE1WA;EACE,gBAAA;AF6WF;;AE3WA;EACE,gBAAA;AF8WF;;AE5WA;EACE,gBAAA;AF+WF;;AE7WA;EACE,gBAAA;AFgXF;;AGneA;EACE,kBAAA;AHseF;;AGleA;EACE,cAAA;EACA,oBAAA;AHqeF;;AGleA;EACE;IACE,4CAAA;EHqeF;AACF;AGleA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AHoeF;;AGjeA;EACE,cAAA;AHoeF;;AGjeA;EACE;IACE,uBAAA;EHoeF;EGleA;IACE,yBAAA;EHoeF;AACF;AIzgBA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;AJ2gBF;AIzgBE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AJ2gBJ;AIzgBI;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;AJ0gBN;AIxgBM;EACE,iBAAA;EACA,YAAA;EACA,YAAA;AJ0gBR;AIrgBE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AJugBJ;AIrgBI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AJugBN;AIngBE;EACE,aAAA;EACA,mBAAA;AJqgBJ;AIlgBE;EACE,aAAA;AJogBJ;AIlgBI;EACE,iBAAA;AJogBN;AIjgBQ;EACE,kCAAA;AJmgBV;AIhgBY;EACE,eAAA;AJkgBd;AI5fM;EACE,oBAAA;AJ8fR;AI3fM;EACE,qBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;AJ6fR;AI3fQ;EACE,iBAAA;AJ6fV;AI3fU;EACE,eAAA;AJ6fZ;AIzfQ;EACE,kCAAA;AJ2fV;AIzfU;EACE,kCAAA;AJ2fZ;AIvfY;EACE,eAAA;AJyfd;AIpfQ;EACE,WAAA;EACA,cAAA;EACA,QAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;EACA,OAAA;EACA,sBAAA;EACA,4BAAA;AJsfV;AInfQ;EACE,iBAAA;AJqfV;;AKnnBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;ALsnBJ;AKpnBI;EACE,kBAAA;ALsnBN;AKnnBI;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ALqnBN;AKnnBM;EACE,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ALqnBR;AKhnBE;EACE,kBAAA;ALknBJ;AKhnBI;EACE,iBAAA;EACA,gBAAA;ALknBN;AK/mBI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,gBAAA;EACA,eAAA;ALinBN;AK/mBM;EACE,4BAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ALinBR;AK/mBQ;EACE,mBAAA;ALinBV;AK9mBQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;ALgnBV;AK7mBQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;AL+mBV;AK5mBQ;EACE,UAAA;AL8mBV;;AMvsBA;EACE,+CAAA;EACA,6CAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,OAAA;EACA,SAAA;EACA,eAAA;AN0sBF;AMxsBE;EACE,WAAA;AN0sBJ;AMxsBI;EACE,uBAAA;AN0sBN;AMtsBE;EACE,gBAAA;ANwsBJ;AMrsBE;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;ANusBJ;AMrsBI;EACE,cAAA;ANusBN;AMrsBM;EACE,yBAAA;ANusBR;AMnsBI;EACE,eAAA;ANqsBN;AMlsBI;;EAEE,aAAA;ANosBN;AMjsBI;EACE,YAAA;EACA,oBAAA;ANmsBN;AMhsBI;EAEE,6CAAA;EACA,uCAAA;ANisBN;AM/rBM;EACE,eAAA;ANisBR;AM/rBQ;EACE,eAAA;ANisBV;AM7rBM;;;EAEE,aAAA;ANgsBR;AM3rBE;EACE,6BAAA;EACA,eAAA;AN6rBJ;;AOzwBE;EACE,OAAA;EACA,WAAA;AP4wBJ;AOzwBE;EACE,eAAA;AP2wBJ;;AOtwBE;EACE,aAAA;APywBJ;AOtwBE;EACE,eAAA;APwwBJ;;AOpwBA;EACE,gBAAA;APuwBF;AOrwBE;EACE,kBAAA;EACA,WAAA;APuwBJ;;AOnwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;APswBF;AOpwBE;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;APswBJ;AOnwBE;EACE,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;APqwBJ;;AQ3zBA;EACE,uBAAA;AR8zBF;;AQ3zBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AR8zBF;AQ5zBE;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;AR8zBJ;AQ5zBI;EACE,iBAAA;EACA,WAAA;AR8zBN;AQ3zBI;EACE,8BAAA;EACA,mBAAA;AR6zBN;AQ1zBI;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AR4zBN;AQ1zBM;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AR4zBR;AQxzBI;EACE,iBAAA;AR0zBN;AQvzBI;EACE,wBAAA;EACA,UAAA;ARyzBN;AQvzBM;EACE,wBAAA;EACA,aAAA;EACA,mCAAA;ARyzBR;AQvzBQ;EACE,qBAAA;EACA,WAAA;ARyzBV;AQnzBE;EACE,gBAAA;ARqzBJ;AQlzBE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;ARozBJ;AQlzBI;EACE,kBAAA;EACA,gBAAA;ARozBN;AQhzBE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;ARkzBJ;AQhzBI;EACE,aAAA;EACA,YAAA;EACA,WAAA;ARkzBN;AQ/yBI;EACE,UAAA;ARizBN;AQ7yBE;EACE,cAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AR+yBJ;AQ3yBI;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AR6yBN;AQzyBE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AR2yBJ;AQzyBI;EACE,eAAA;AR2yBN;AQxyBI;EACE,aAAA;EACA,mBAAA;AR0yBN;AQxyBM;EACE,kBAAA;AR0yBR;AQxyBQ;EACE,YAAA;AR0yBV;AQvyBQ;EACE,YAAA;ARyyBV;AQpyBI;EACE,kBAAA;ARsyBN;AQpyBM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ARsyBR;AQlyBI;EACE,YAAA;EACA,kBAAA;ARoyBN;AQlyBM;EACE,aAAA;ARoyBR;AQhyBI;EACE,gBAAA;ARkyBN;AQ9xBM;EACE,aAAA;ARgyBR;AQ9xBQ;EACE,eAAA;ARgyBV;AQ5xBM;EACE,mBAAA;AR8xBR;AQ5xBQ;EACE,aAAA;EACA,cAAA;EACA,UAAA;AR8xBV;AQ1xBM;EACE,oBAAA;AR4xBR;AQ1xBQ;EACE,YAAA;AR4xBV;AQxxBM;EACE,YAAA;AR0xBR;AQxxBQ;EACE,qCAAA;EACA,eAAA;AR0xBV;AQtxBM;EACE,WAAA;EACA,kBAAA;ARwxBR;AQtxBQ;EACE,YAAA;EACA,oBAAA;ARwxBV;AQnxBI;EACE,gBAAA;ARqxBN;AQlxBI;EACE,aAAA;EACA,yBAAA;EACA,6BAAA;EACA,iBAAA;ARoxBN;AQlxBM;EACE,kBAAA;ARoxBR;AQ/wBE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,+CAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;ARixBJ;AQ/wBI;EACE,YAAA;ARixBN;AQ9wBI;EACE,UAAA;ARgxBN;AQ7wBI;EACE,WAAA;AR+wBN;AQ7wBM;EACE,gBAAA;EACA,2BAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,mCAAA;AR+wBR;AQ7wBQ;EACE,qCAAA;AR+wBV;AQ5wBQ;EACE,kCAAA;EACA,uCAAA;EACA,+BAAA;AR8wBV;AQ3wBQ;EACE,aAAA;AR6wBV;AQvwBE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,8CAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,0BAAA;EACA,2BAAA;ARywBJ;AQvwBI;EACE,aAAA;ARywBN;AQvwBM;EACE,kBAAA;ARywBR;AQrwBQ;EACE,kBAAA;EACA,SAAA;EACA,0BAAA;EACA,WAAA;ARuwBV;AQrwBU;EACE,cAAA;ARuwBZ;AQjwBI;EACE,aAAA;EACA,8BAAA;ARmwBN;AQjwBM;EACE,gBAAA;ARmwBR;AQ/vBI;EACE,wBAAA;ARiwBN;AQ9vBI;EACE,mBAAA;ARgwBN;AQ5vBU;EACE,oBAAA;AR8vBZ;AQxvBI;EACE,kBAAA;AR0vBN;AQvvBI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;ARyvBN;AQtvBI;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;ARwvBN;AQrvBI;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ARuvBN;AQnvBM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;ARqvBR;AQnvBQ;EACE,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;ARqvBV;AQnvBU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,oCAAA;EACA,WAAA;EACA,WAAA;EACA,uCAAA;EACA,0BAAA;ARqvBZ;AQlvBU;EACE,kCAAA;ARovBZ;AQlvBY;EACE,oCAAA;ARovBd;AQ5uBE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AR8uBJ;AQ3uBE;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,+CAAA;EACA,kBAAA;AR6uBJ;;AQzuBA;EACE,mBAAA;EACA,2BAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6CAAA;EACA,sCAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AR4uBF;AQ1uBE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AR4uBJ;;AQxuBA;EACE,WAAA;EACA,iBAAA;EACA,8BAAA;AR2uBF;AQzuBE;EACE,8CAAA;AR2uBJ;AQxuBE;EACE,cAAA;EACA,WAAA;AR0uBJ;;AQtuBA;EACE,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;ARyuBF;AQvuBE;EACE,iBAAA;ARyuBJ;AQtuBE;EACE,UAAA;ARwuBJ;AQltBE;EACE,8CAAA;ARotBJ;AQ/sBM;EACE,UAAA;ARitBR;AQ5sBE;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,QAAA;EACA,2BAAA;AR8sBJ;AQ5sBI;EACE,kBAAA;EACA,UAAA;EACA,0BAAA;AR8sBN;AQ5sBM;EACE,yDAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AR8sBR;AQ5sBQ;EACE,eAAA;AR8sBV;AQ3sBQ;EACE,cAAA;AR6sBV;AQzsBM;EACE,yDAAA;EACA,gBAAA;EACA,YAAA;AR2sBR;AQzsBQ;EACE,eAAA;AR2sBV;AQxsBQ;EACE,cAAA;AR0sBV;AQpsBM;EACE,UAAA;ARssBR;;AQhsBA;EACE,aAAA;ARmsBF;AQjsBE;EACE,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ARmsBJ;AQjsBI;EACE,kBAAA;ARmsBN;;AQ9rBA;EACE,mBAAA;ARisBF;;AQ9rBA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;ARisBF;AQ/rBE;EACE,eAAA;EACA,kBAAA;ARisBJ;;AQ7rBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA;EACA,gDAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;ARgsBF;;AQ7rBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;ARgsBF;AQ9rBE;EACE,0BAAA;EACA,iBAAA;ARgsBJ;;AQ5rBA;EACE,qCAAA;AR+rBF;;AQ5rBA;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AR+rBF;;AQ3rBE;EACE,uBAAA;EACA,UAAA;AR8rBJ;AQ3rBE;EACE,WAAA;AR6rBJ;AQ1rBE;EACE,WAAA;EACA,YAAA;AR4rBJ;AQzrBE;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AR2rBJ;AQxrBE;EACE,WAAA;EACA,wBAAA;AR0rBJ;AQvrBE;EACE,6CAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;ARyrBJ;AQvrBI;EACE,oBAAA;EACA,mBAAA;ARyrBN;AQrrBM;EACE,kBAAA;ARurBR;AQlrBE;EACE,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,iFACE;EAEF,iBAAA;EACA,cAAA;ARkrBJ;AQhrBI;EACE,yBAAA;ARkrBN;AQ/qBI;EACE,+BAAA;ARirBN;AQ9qBI;;;;;;;;EAQE,oBAAA;ARgrBN;AQ7qBI;EACE,mBAAA;EACA,kBAAA;EACA,2BAAA;AR+qBN;AQ7qBM;EACE,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,2BAAA;EACA,oEAAA;EACA,UAAA;AR+qBR;AQ7qBQ;EACE,aAAA;AR+qBV;;AQvqBE;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;AR0qBJ;AQxqBI;EACE,6EAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;AR0qBN;AQxqBM;EACE,gBAAA;AR0qBR;AQtqBI;EACE,qBAAA;ARwqBN;;AQlqBE;EACE,+BAAA;ARqqBJ;;AQhqBE;EACE,+BAAA;ARmqBJ;AQ/pBI;EACE,aAAA;ARiqBN;AQ5pBI;EACE,+BAAA;AR8pBN;;AQzpBA;EACE,UAAA;EACA,mBAAA;AR4pBF;;AQzpBA;EACE,+BAAA;AR4pBF;;AQzpBA;EACE,+BAAA;AR4pBF;AQ1pBE;EACE,aAAA;AR4pBJ;;AQvpBE;EACE,gBAAA;EACA,uBAAA;AR0pBJ;;AQrpBE;EACE,yBAAA;EACA,kBAAA;EACA,4BAAA;EACA,2BAAA;ARwpBJ;AQtpBI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;ARwpBN;AQtpBM;EACE,eAAA;ARwpBR;;AQjpBA;EACE,WAAA;EACA,gBAAA;ARopBF;AQlpBE;EACE,aAAA;ARopBJ;AQlpBI;EACE,eAAA;ARopBN;AQhpBE;EACE,2BAAA;EACA,kBAAA;ARkpBJ;AQ/oBI;EACE,aAAA;ARipBN;AQ7oBE;EACE,aAAA;AR+oBJ;;AQ3oBA;EACE,aAAA;AR8oBF;;AQ3oBA;EACE,UAAA;AR8oBF;;AQ3oBA;EACE,gBAAA;EACA,SAAA;AR8oBF;;AQ3oBA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;AR8oBF;;AQ3oBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;AR8oBF;AQ5oBE;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;AR8oBJ;AQ5oBI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,uCAAA;EACA,mBAAA;EACA,0BAAA;AR8oBN;AQ3oBI;EACE,kCAAA;AR6oBN;AQ3oBM;EACE,mBAAA;AR6oBR;;AQvoBA;EACE,kBAAA;AR0oBF;AQxoBE;EACE,UAAA;EACA,uBAAA;AR0oBJ;AQxoBI;EACE,eAAA;EACA,iBAAA;AR0oBN;AQvoBI;EACE,SAAA;ARyoBN;AQtoBI;EACE,+BAAA;ARwoBN;AQtoBM;EACE,sHAAA;ARwoBR;;AQloBA;EACE,WAAA;EACA,uBAAA;ARqoBF;;AQloBA;EACE,oBAAA;EACA,gBAAA;ARqoBF;AQ7nBI;;EAEE,yBAAA;EAGA,YAAA;EACA,sBAAA;AR6nBN;AQ1nBI;EACE,UAAA;EACA,gBAAA;EACA,SAAA;AR4nBN;AQxnBE;;;;EAIE,+BAAA;AR0nBJ;AQvnBE;EACE,oBAAA;ARynBJ;AQtnBE;EACE,aAAA;ARwnBJ;AQrnBE;EACE,gBAAA;ARunBJ;AQpnBE;EA7CF;IA8CI,WAAA;IACA,eAAA;IACA,UAAA;ERunBF;EQrnBE;;IAEE,wBAAA;ERunBJ;EQpnBE;IACE,SAAA;ERsnBJ;EQnnBE;;IAEE,wBAAA;ERqnBJ;EQlnBE;IACE,gBAAA;IACA,YAAA;ERonBJ;EQjnBE;IACE,aAAA;ERmnBJ;EQhnBE;IACE,UAAA;IACA,SAAA;IACA,YAAA;ERknBJ;EQ/mBE;IACE,wBAAA;ERinBJ;EQ9mBE;IACE,aAAA;ERgnBJ;AACF;;AQ5mBA;EACE;IACE,aAAA;ER+mBF;EQ5mBA;IACE,qBAAA;IACA,6BAAA;ER8mBF;AACF;AQ3mBA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AR6mBF;AQ3mBE;EACE,mBAAA;AR6mBJ;AQ1mBE;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AR4mBJ;AQzmBE;EACE,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AR2mBJ;;AQvmBA;EACE,sBAAA;AR0mBF;;AQtmBE;EACE,gBAAA;ARymBJ;AQrmBI;EACE,aAAA;ARumBN;AQnmBM;EACE,cAAA;EACA,oBAAA;ARqmBR;AQhmBE;EACE,mBAAA;EACA,eAAA;ARkmBJ;AQhmBI;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,iFACE;ARimBR;AQ9lBM;EACE,kBAAA;EACA,gDAAA;ARgmBR;AQ7lBM;EACE,kBAAA;EACA,6CAAA;EACA,aAAA;EACA,8BAAA;AR+lBR;AQ5lBM;EACE,kBAAA;AR8lBR;;AQxlBA;EACE,aAAA;EACA,WAAA;EACA,6CAAA;AR2lBF;AQzlBE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AR2lBJ;AQxlBM;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AR0lBR;AQvlBM;EACE,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ARylBR;AQtlBM;EACE,iBAAA;EACA,gBAAA;ARwlBR;AQtlBQ;EACE,eAAA;ARwlBV;AQnlBI;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;ARqlBN;AQllBI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;ARolBN;AQjlBI;EACE,kBAAA;ARmlBN;AQjlBM;EACE,mBAAA;ARmlBR;AQhlBM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;ARklBR;AQ7kBE;EACE,yDAAA;EACA,mCAAA;EACA,8CAAA;EACA,6CAAA;EACA,aAAA;AR+kBJ;AQ7kBI;EACE,UAAA;AR+kBN;AQ3kBE;EACE,yDAAA;EACA,mCAAA;AR6kBJ;AQ1kBE;EACE,gBAAA;EACA,cAAA;AR4kBJ;AQzkBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AR2kBJ;AQzkBI;EACE,aAAA;AR2kBN;AQxkBI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AR0kBN;AQvkBI;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ARykBN;AQrkBE;EACE,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,iFACE;EAEF,kBAAA;EACA,gBAAA;EACA,cAAA;ARqkBJ;AQnkBI;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;ARqkBN;AQlkBI;EACE,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ARokBN;AQhkBE;EACE,YAAA;EAAA,cAAA;EAAA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,aAAA;ARkkBJ;;AQ9jBA;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;ARikBF;;AQ9jBA;EACE,gBAAA;EACA,8BAAA;ARikBF;;AQ9jBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;ARikBF;AQ/jBE;EACE,+BAAA;ARikBJ;AQ9jBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,uCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ARgkBJ;AQ9jBI;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,6CAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,wHAAA;ARgkBN;AQ9jBM;EACE,kBAAA;EACA,6CAAA;EACA,0BAAA;EAEA,4HAAA;AR+jBR;AQ1jBE;EACE,kBAAA;AR4jBJ;AQzjBE;EACE,gBAAA;EACA,SAAA;AR2jBJ;AQxjBE;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;AR0jBJ;AQtjBI;EACE,aAAA;ARwjBN;AQnjBI;EACE,mBAAA;EACA,0CAAA;EACA,0BAAA;EACA,gBAAA;EACA,iFACE;EAEF,aAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,wDAAA;ARmjBN;AQjjBM;;EAEE,WAAA;ARmjBR;AQhjBM;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;ARkjBR;AQhjBQ;EACE,WAAA;ARkjBV;AQ9iBM;EACE,YAAA;EACA,aAAA;ARgjBR;AQ7iBM;EACE,UAAA;AR+iBR;AQ5iBM;EACE,mBAAA;EACA,sBAAA;EACA,+BAAA;AR8iBR;AQ3iBM;EACE,mBAAA;EACA,sBAAA;EACA,+BAAA;AR6iBR;AQziBI;EACE,gEAAA;AR2iBN;AQriBM;EACE,gBAAA;ARuiBR;AQliBM;EACE,6BAAA;ARoiBR;AQhiBI;EACE,mBAAA;EACA,0CAAA;EACA,0BAAA;EACA,gBAAA;EACA,iFACE;EAEF,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,wDAAA;ARgiBN;AQ9hBM;EACE,aAAA;EACA,aAAA;EACA,mBAAA;ARgiBR;AQ9hBQ;EACE,gBAAA;EACA,iBAAA;ARgiBV;AQ5hBM;EACE,UAAA;AR8hBR;AQ3hBM;EACE,mBAAA;EACA,sBAAA;EACA,+BAAA;AR6hBR;AQ1hBM;EACE,mBAAA;EACA,sBAAA;EACA,+BAAA;AR4hBR;AQxhBI;EACE,gEAAA;AR0hBN;AQthBE;EACE,iBAAA;ARwhBJ;AQrhBE;EACE,aAAA;ARuhBJ;AQphBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;ARshBJ;AQphBI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uCAAA;EACA,WAAA;EACA,UAAA;ARshBN;AQnhBI;EACE,kCAAA;ARqhBN;AQnhBM;EACE,UAAA;ARqhBR;AQjhBQ;EACE,yBAAA;ARmhBV;AQ9gBI;EACE,iBAAA;ARghBN;AQ9gBM;EACE,0BAAA;ARghBR;;AQ1gBA;EACE,gBAAA;AR6gBF;AQ3gBE;EACE,SAAA;AR6gBJ;AQ1gBE;EACE,cAAA;EACA,eAAA;EACA,WAAA;AR4gBJ;AQ1gBI;EACE,gBAAA;AR4gBN;;ASvmEE;EACE,gBAAA;AT0mEJ;;ASpmEE;EACE,gBAAA;ATumEJ;;ASnmEA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;EACA,8CAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;ATsmEF;ASnmEE;EAEE,4HAAA;EACA,0CAAA;EACA,6CAAA;ATomEJ;ASjmEE;EACE,2BAAA;ATmmEJ;AShmEE;EACE,gFAAA;EACA,0EAAA;EACA,2BAAA;EACA,yBAAA;ATkmEJ;AShmEI;EACE,yBAAA;ATkmEN;AS9lEE;EACE,WAAA;ATgmEJ;AS7lEE;EACE,gBAAA;EACA,8CAAA;EACA,0CAAA;EACA,uCAAA;AT+lEJ;AS7lEI;EACE,uCAAA;AT+lEN;AS3lEE;EACE,8CAAA;EACA,sCAAA;EACA,8CAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AT6lEJ;AS1lEM;EACE,WAAA;AT4lER;ASvlEM;EACE,uBAAA;ATylER;ASrlEI;EACE,gBAAA;EACA,cAAA;ATulEN;ASplEQ;EACE,cAAA;ATslEV;ASjlEQ;EACE,0BAAA;ATmlEV;AS7kEE;EACE,mCAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;AT+kEJ;AS7kEI;EACE,cAAA;EACA,gBAAA;AT+kEN;AS5kEQ;EACE,cAAA;EACA,0BAAA;AT8kEV;ASzkEI;EACE,gBAAA;EACA,sHAAA;AT2kEN;ASvkEM;EACE,cAAA;EACA,0BAAA;ATykER;ASrkEI;EACE,yBAAA;EACA,mCAAA;EACA,gBAAA;EACA,cAAA;ATukEN;ASpkEQ;EACE,cAAA;ATskEV;ASjkEM;EACE,mBAAA;EACA,WAAA;ATmkER;AShkEU;EACE,WAAA;ATkkEZ;AS7jEU;EACE,uBAAA;AT+jEZ;ASzjEI;EACE,SAAA;EACA,mCAAA;EACA,gBAAA;EACA,cAAA;AT2jEN;ASxjEQ;EACE,cAAA;AT0jEV;ASrjEQ;EACE,0BAAA;ATujEV;ASnjEM;EACE,mBAAA;EACA,WAAA;ATqjER;ASljEU;EACE,WAAA;ATojEZ;AS/iEU;EACE,uBAAA;ATijEZ;AS3iEI;EACE,SAAA;EACA,+DAAA;AT6iEN;ASziEE;EACE,qEAAA;EACA,mCAAA;EACA,8CAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;AT2iEJ;ASziEI;EACE,0BAAA;AT2iEN;ASziEM;EACE,0BAAA;AT2iER;ASviEI;EACE,yBAAA;EACA,cAAA;ATyiEN;ASriEM;EACE,cAAA;ATuiER;ASniEI;EACE,qEAAA;EACA,sHAAA;EACA,6CAAA;ATqiEN;ASniEM;EACE,kCAAA;ATqiER;ASliEM;EACE,iCAAA;AToiER;AS/hEI;EACE,iBAAA;ATiiEN;AS/hEM;EACE,eAAA;ATiiER;AS7hEI;EACE,mDAAA;EACA,mCAAA;EACA,8CAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AT+hEN;AS5hEQ;EACE,cAAA;AT8hEV;ASzhEM;EACE,mBAAA;EACA,WAAA;AT2hER;ASxhEU;EACE,WAAA;AT0hEZ;ASrhEU;EACE,uBAAA;ATuhEZ;ASjhEI;EACE,8CAAA;EACA,mCAAA;EACA,8CAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;ATmhEN;AShhEQ;EACE,cAAA;ATkhEV;AS7gEQ;EACE,0BAAA;AT+gEV;AS3gEM;EACE,mBAAA;EACA,WAAA;AT6gER;AS1gEU;EACE,WAAA;AT4gEZ;ASvgEU;EACE,uBAAA;ATygEZ;ASlgEM;EACE,cAAA;EACA,0BAAA;ATogER;AShgEI;EAEE,qEAAA;EACA,sHAAA;EACA,6CAAA;ATigEN;AS9/DI;EACE,qEAAA;EACA,+DAAA;ATggEN;AS5/DE;EACE,UAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,2BAAA;AT8/DJ;AS5/DI;EACE,cAAA;AT8/DN;AS1/DM;EACE,kBAAA;EACA,SAAA;EACA,0BAAA;EACA,WAAA;AT4/DR;AS1/DQ;EACE,cAAA;AT4/DV;ASt/DE;EACE,kBAAA;EACA,mBAAA;ATw/DJ;ASr/DE;EACE,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,mCAAA;EACA,6BAAA;ATu/DJ;ASp/DM;EACE,mCAAA;ATs/DR;;ASh/DA;EACE,uBAAA;EACA,SAAA;EACA,UAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;ATm/DF;ASj/DE;EACE,kBAAA;ATm/DJ;;AS/+DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;ATk/DF;;AS/+DA;EACE,WAAA;ATk/DF;;AS/+DA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;ATk/DF;AS/+DE;EACE,iBAAA;EACA,gBAAA;ATi/DJ;;AUp6EA;EACE,kBAAA;EACA,qBAAA;AVu6EF;AUr6EE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AVu6EJ;AUp6EE;EACE,uCAAA;EACA,kCAAA;EACA,6CAAA;AVs6EJ;AUn6EE;EACE,qBAAA;EACA,iBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6CAAA;EACA,WAAA;EACA,eAAA;AVq6EJ;;AUj6EA;EACE,aAAA;EACA,8BAAA;AVo6EF;;AUj6EA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AVo6EF;AUl6EE;EACE,UAAA;AVo6EJ;AUj6EE;EACE,UAAA;AVm6EJ;AUh6EE;EACE,WAAA;AVk6EJ;;AU95EA;EACE,kBAAA;AVi6EF;AU/5EE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AVi6EJ;AU95EE;EACE,kCAAA;AVg6EJ;AU95EI;EACE,uCAAA;EACA,6CAAA;AVg6EN;AU75EI;EACE,oCAAA;EACA,UAAA;AV+5EN;AU35EE;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;AV65EJ;AU35EI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,6CAAA;EACA,0BAAA;AV65EN;AU15EI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;AV45EN;;AUv5EA;EACE,YAAA;EACA,iBAAA;AV05EF;;AUv5EA;;EAEE,kBAAA;EACA,6CAAA;EACA,sCAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;AV05EF;AUx5EE;;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,YAAA;AV25EJ;AUx5EE;;EACE,iCAAA;AV25EJ;AUx5EE;;EACE,UAAA;AV25EJ;AUx5EE;;EACE,YAAA;EACA,eAAA;AV25EJ;AUx5EE;;EACE,UAAA;AV25EJ;AUx5EE;;EACE,WAAA;AV25EJ;AUx5EE;;EACE,mBAAA;EACA,kBAAA;AV25EJ;AUz5EI;;EACE,aAAA;EACA,sBAAA;AV45EN;AUz5EQ;;EACE,uBAAA;AV45EV;AUz5EQ;;EACE,qBAAA;AV45EV;AUz5EQ;;EACE,mBAAA;AV45EV;AUv5EI;;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AV05EN;AUx5EM;;EACE,eAAA;AV25ER;AUt5EM;;EACE,WAAA;AVy5ER;AUp5EE;;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;AVu5EJ;;AUn5EA;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;EACA,yBAAA;AVs5EF;AUp5EE;EACE,eAAA;EACA,mBAAA;AVs5EJ;AUn5EE;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AVq5EJ;;AUh5EE;;;;;;EAME,oBAAA;AVm5EJ;;AU/4EA;;EAEE,aAAA;EACA,sBAAA;EACA,gBAAA;AVk5EF;AUh5EE;;EACE,uBAAA;AVm5EJ;;AU/4EA;EACE,kBAAA;EACA,mBAAA;AVk5EF;AUh5EE;EAEE,aAAA;EACA,mBAAA;AVi5EJ;AU94EE;EACE,uBAAA;AVg5EJ;AU74EE;EACE,yBAAA;AV+4EJ;AU34EI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AV64EN;AU14EI;EACE,kCAAA;AV44EN;AU14EM;EACE,6CAAA;AV44ER;AUz4EM;EACE,mBAAA;AV24ER;AUv4EI;EACE,eAAA;AVy4EN;AUv4EM;EACE,uBAAA;EACA,oBAAA;AVy4ER;AUr4EI;EACE,uCAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;AVs4EN;AUp4EM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,6CAAA;EACA,0BAAA;AVs4ER;AUn4EM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AVq4ER;AU93EI;EACE,oBAAA;EACA,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AVg4EN;AU73EI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;AV+3EN;AU53EI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,6CAAA;AV83EN;AU53EM;EACE,sCAAA;AV83ER;AU53EQ;EACE;IACE,WAAA;IACA,YAAA;IACA,oBAAA;IACA,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;IACA,6CAAA;EV83EV;AACF;AU33EQ;EACE;IACE,SAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,oBAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,kCAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;EV63EV;AACF;AUv3EE;EACE,UAAA;EACA,kBAAA;AVy3EJ;AUp3EM;EACE,WAAA;EACA,YAAA;EACA,SAAA;AVs3ER;AUn3EM;EACE,WAAA;EACA,YAAA;AVq3ER;AU92EM;EACE,WAAA;EACA,YAAA;EACA,SAAA;AVg3ER;AU72EM;EACE,WAAA;EACA,YAAA;AV+2ER;AUx2EM;EACE,WAAA;EACA,YAAA;EACA,SAAA;AV02ER;AUv2EM;EACE,WAAA;EACA,YAAA;AVy2ER;;AUn2EA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AVs2EF;AUp2EE;EAEE,aAAA;EACA,mBAAA;AVq2EJ;AUl2EE;EACE,uBAAA;AVo2EJ;AUj2EE;EACE,yBAAA;AVm2EJ;AU/1EI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AVi2EN;AU91EI;EACE,kCAAA;AVg2EN;AU91EM;EACE,kBAAA;EACA,6CAAA;EACA,sCAAA;AVg2ER;AU71EM;EACE,2EAAA;AV+1ER;AU31EI;EACE,qBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AV41EN;AU11EM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,0BAAA;AV41ER;AUz1EM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AV21ER;AUp1EI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;AVs1EN;AUn1EI;EACE,oBAAA;EACA,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AVq1EN;AUl1EI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;EACA,6CAAA;AVo1EN;AUl1EM;EACE,sCAAA;AVo1ER;AUn1EQ;EACE;IACE,WAAA;IACA,WAAA;IACA,YAAA;IACA,uBAAA;IACA,kBAAA;IACA,2EAAA;EVq1EV;AACF;AUn1EQ;EACE;IACE,WAAA;IACA,YAAA;IACA,qBAAA;IACA,YAAA;IACA,eAAA;IACA,kCAAA;EVq1EV;AACF;AU70EM;EACE,WAAA;EACA,YAAA;EACA,SAAA;AV+0ER;AU50EM;EACE,WAAA;EACA,YAAA;AV80ER;AUv0EM;EACE,WAAA;EACA,YAAA;EACA,SAAA;AVy0ER;AUt0EM;EACE,WAAA;EACA,YAAA;AVw0ER;AUj0EM;EACE,WAAA;EACA,YAAA;EACA,SAAA;AVm0ER;AUh0EM;EACE,WAAA;EACA,YAAA;AVk0ER;;AU5zEA;EACE,kBAAA;AV+zEF;AU7zEE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AV+zEJ;AU5zEE;EACE,+BAAA;EAEA,uCAAA;AV6zEJ;AU1zEE;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,yDAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AV4zEJ;;AUxzEA;EACE,aAAA;EACA,cAAA;AV2zEF;AUzzEE;EACE,kBAAA;AV2zEJ;;AUvzEA;EACE,eAAA;EACA,YAAA;AV0zEF;AUxzEE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AV0zEJ;AUxzEI;EACE,YAAA;AV0zEN;;AUpzEE;EACE,iBAAA;AVuzEJ;AUpzEE;;EAEE,eAAA;AVszEJ;AUlzEI;;EAEE,eAAA;AVozEN;AU/yEI;;EAEE,eAAA;AVizEN;;AU5yEA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AV+yEF;AU7yEE;EACE,UAAA;AV+yEJ;AU5yEE;EACE,UAAA;AV8yEJ;AU3yEE;EACE,WAAA;AV6yEJ;;AUzyEA;EACE,YAAA;EACA,qBAAA;EACA,qBAAA;AV4yEF;;AUzyEA;EACE,eAAA;AV4yEF;;AUxyEE;EACE,UAAA;AV2yEJ;AUxyEE;EACE,UAAA;AV0yEJ;AUvyEE;EACE,WAAA;AVyyEJ;AUtyEE;EAME,WAAA;AVmyEJ;;AU/xEA;EACE,UAAA;AVkyEF;;AU/xEA;EACE,UAAA;AVkyEF;;AU/xEA;EACE,WAAA;AVkyEF;;AU9xEE;EACE,aAAA;AViyEJ;;AU7xEA;EACE,WAAA;AVgyEF;AU7xEI;EACE,UAAA;AV+xEN;AU5xEI;EACE,UAAA;AV8xEN;AU3xEI;EACE,WAAA;AV6xEN;AUxxEI;EACE,iBAAA;AV0xEN;AUvxEI;EACE,SAAA;EACA,uBAAA;AVyxEN;AUtxEI;EACE,aAAA;AVwxEN;AUrxEI;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,2EAAA;AVuxEN;AUrxEM;EACE,aAAA;AVuxER;AUlxEE;EACE,WAAA;EACA,SAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AVoxEJ;AUlxEI;;EAEE,kBAAA;EACA,mCAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AVoxEN;AUlxEM;;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,mCAAA;EACA,kBAAA;AVqxER;AUlxEM;;;EAEE,qCAAA;AVqxER;AUnxEQ;;;EACE,6CAAA;EACA,sGAAA;AVuxEV;AUnxEM;;EACE,sCAAA;AVsxER;AUjxEE;;EAEE,aAAA;AVmxEJ;AUhxEE;;;;EAIE,gBAAA;EACA,6CAAA;EACA,kBAAA;AVkxEJ;AUhxEI;;;;;;;;EAEE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,2CAAA;AVwxEN;AUpxEE;;;;EAIE,6CAAA;EACA,gBAAA;AVsxEJ;AUnxEE;;EAEE,0BAAA;EACA,6CAAA;EACA,gBAAA;AVqxEJ;;AUjxEA;EACE,SAAA;EACA,0BAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;AVoxEF;AUlxEE;EACE,kBAAA;EACA,mCAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AVoxEJ;AUlxEI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gDAAA;EACA,mCAAA;AVoxEN;AUjxEI;EACE,qCAAA;AVmxEN;AUjxEM;EACE,6CAAA;AVmxER;AUhxEM;EACE,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;AVkxER;AU9wEI;EACE,sCAAA;AVgxEN;;AU3wEA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AV8wEF;AU5wEE;EACE,eAAA;AV8wEJ;;AU1wEA;;EAEE,+BAAA;AV6wEF;;AU1wEA;EACE,4BAAA;EACA,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,iFACE;EAEF,kBAAA;AV2wEF;AUxwEI;EACE,kBAAA;EACA,gBAAA;AV0wEN;AUtwEE;EACE,oBAAA;AVwwEJ;AUrwEE;EACE,mCAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,gCAAA;EACA,iBAAA;EACA,mBAAA;AVuwEJ;AUrwEI;EACE,2BAAA;EACA,8BAAA;EACA,kBAAA;AVuwEN;AUpwEI;EACE,4BAAA;EACA,+BAAA;AVswEN;AUlwEE;EACE,YAAA;EACA,yBAAA;EACA,sBAAA;AVowEJ;AUlwEI;EACE,kBAAA;AVowEN;AUlwEM;EACE,cAAA;AVowER;AUhwEI;EACE,8BAAA;EACA,kBAAA;AVkwEN;AU/vEI;EACE,+BAAA;AViwEN;AU5vEI;EACE,2BAAA;AV8vEN;AU3vEI;EACE,4BAAA;AV6vEN;AUzvEE;;EAEE,eAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;AV2vEJ;AUzvEI;;EACE,gBAAA;EACA,gBAAA;EACA,sBAAA;AV4vEN;AUxvEE;EACE,YAAA;EACA,yBAAA;AV0vEJ;AUrvEM;EACE,kBAAA;AVuvER;AUrvEQ;EACE,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;EACA,yCAAA;AVuvEV;;AUhvEA;EACE,oBAAA;EACA,gBAAA;AVmvEF;AUhvEI;EACE,kBAAA;AVkvEN;AUhvEM;EACE,kBAAA;AVkvER;AU/uEM;EACE,iBAAA;EACA,kBAAA;AVivER;AU7uEI;EACE,iBAAA;AV+uEN;AU7uEM;EACE,iBAAA;AV+uER;AU5uEM;EACE,iBAAA;AV8uER;;AUxuEA;EACE,WAAA;AV2uEF;AUzuEE;EACE,kBAAA;AV2uEJ;AUxuEE;EACE,iBAAA;AV0uEJ;;AUtuEA;;;EAGE,+BAAA;AVyuEF;;AUtuEA;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,iBAAA;AVyuEF;;AUtuEA;EACE,6CAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AVyuEF;AUvuEE;EACE,6CAAA;EACA,qEAAA;EACA,mCAAA;EACA,iBAAA;AVyuEJ;AUvuEI;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AVyuEN;AUtuEI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,uBAAA;AVwuEN;AUtuEM;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;AVwuER;AUnuEE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AVquEJ;;AUjuEA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AVouEF;AUluEE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AVouEJ;;AU9tEI;EACE,gBAAA;AViuEN;AU5tEI;;;;;EAKE,kBAAA;EACA,iBAAA;EACA,kBAAA;AV8tEN;AU3tEI;EACE,yBAAA;AV6tEN;AU1tEI;;;;EAIE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AV4tEN;AUztEI;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AV2tEN;AUttEI;;;;;EAKE,iBAAA;EACA,cAAA;AVwtEN;AUrtEI;EACE,yBAAA;AVutEN;AUptEI;;;EAGE,iBAAA;EACA,iBAAA;AVstEN;AUntEI;EACE,iBAAA;AVqtEN;;AUhtEA;EACE,eAAA;AVmtEF;;AUhtEA;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,qFACE;EAEF,6CAAA;EACA,kDAAA;EACA,mCAAA;EACA,kBAAA;AVitEF;AU/sEE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AVitEJ;AU/sEI;EACE,kBAAA;AVitEN;AU7sEE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AV+sEJ;AU5sEM;EACE,WAAA;AV8sER;AUzsEM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AV2sER;AUxsEM;EACE,4BAAA;AV0sER;AUtsEI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AVwsEN;AUrsEI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AVusEN;AUnsEM;EACE,qBAAA;EACA,4BAAA;AVqsER;AUjsEQ;;EAEE,qBAAA;AVmsEV;AU9rEQ;EACE,4BAAA;AVgsEV;AU5rEM;EACE,UAAA;AV8rER;AU3rEM;EACE,cAAA;AV6rER;AUzrEI;EACE,aAAA;EACA,cAAA;EACA,UAAA;AV2rEN;AUxrEI;EACE,aAAA;EACA,cAAA;EACA,UAAA;AV0rEN;AUvrEI;EACE,aAAA;EACA,cAAA;EACA,UAAA;AVyrEN;;AUprEA;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AVurEF;AUrrEE;EACE,gBAAA;EACA,eAAA;AVurEJ;;AUnrEA;EACE,WAAA;AVsrEF;;AUnrEA;EACE,kBAAA;AVsrEF;AUprEE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AVsrEJ;;AUjrEE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AVorEJ;AUlrEI;EACE,2BAAA;EACA,uBAAA;AVorEN;;AU9qEE;EACE,aAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AVirEJ;AU/qEI;;EAEE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AVirEN;AU9qEI;EACE,kBAAA;AVgrEN;AU5qEE;EACE,gBAAA;AV8qEJ;AU5qEI;EACE,eAAA;AV8qEN;AU5qEM;EACE,+BAAA;AV8qER;AUzqEE;EACE,iBAAA;AV2qEJ;AUxqEE;EACE,kBAAA;AV0qEJ;;AUtqEA;EACE,cAAA;EACA,eAAA;AVyqEF;;AUtqEA;EACE,aAAA;AVyqEF;;AUtqEA;EACE,mBAAA;AVyqEF;AUvqEE;EACE,kBAAA;AVyqEJ;AUvqEI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;AVyqEN;AUrqEE;EACE,YAAA;EACA,kBAAA;AVuqEJ;AUrqEI;EACE,aAAA;AVuqEN;AUnqEE;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,qBAAA;AVqqEJ;AUlqEE;EACE,cAAA;EACA,gBAAA;AVoqEJ;AUlqEI;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mCAAA;AVoqEN;AUlqEM;EACE,UAAA;AVoqER;AUjqEM;EACE,mBAAA;EACA,sBAAA;EACA,8BAAA;AVmqER;AUhqEM;EACE,mBAAA;EACA,sBAAA;EACA,8BAAA;AVkqER;AU/pEM;EACE,YAAA;EAAA,cAAA;EAAA,2BAAA;EACA,0BAAA;EACA,sBAAA;AViqER;AU7pEI;EACE,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AV+pEN;AU7pEM;EACE,iBAAA;AV+pER;AU5pEM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AV8pER;AU3pEM;EACE,iBAAA;AV6pER;AU3pEQ;EACE,cAAA;AV6pEV;AUzpEM;EACE,gBAAA;AV2pER;;AUrpEA;EACE,kBAAA;EACA,UAAA;AVwpEF;AUtpEE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,4BAAA;AVwpEJ;AUrpEE;EACE,kBAAA;AVupEJ;;AUnpEA;EACE,kBAAA;AVspEF;AUppEE;EACE,oBAAA;AVspEJ;AUppEI;EACE,iCAAA;AVspEN;AUlpEE;EACE,kBAAA;EACA,6CAAA;EACA,sCAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AVopEJ;AUlpEI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;AVopEN;AUhpEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2CAAA;EACA,eAAA;EACA,UAAA;AVkpEJ;AU/oEE;EACE,aAAA;AVipEJ;AU/oEI;EACE,cAAA;EACA,kBAAA;AVipEN;AU9oEQ;EACE,gBAAA;AVgpEV;AU5oEM;EACE,kBAAA;AV8oER;AU3oEM;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;AV6oER;AU3oEQ;EACE,mBAAA;AV6oEV;AU1oEQ;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;AV4oEV;AUzoEQ;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;AV2oEV;AUxoEQ;EACE,iBAAA;AV0oEV;AUroEQ;EACE,mBAAA;AVuoEV;AUpoEQ;EACE,gDAAA;AVsoEV;AUhoEE;EACE,aAAA;AVkoEJ;;AU7nEE;EACE,cAAA;AVgoEJ;;AU5nEA;EACE,kBAAA;AV+nEF;AU7nEE;EACE,mBAAA;AV+nEJ;AU5nEE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AV8nEJ;;AU1nEA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AV6nEF;AU1nEI;EACE,WAAA;EACA,YAAA;AV4nEN;AUxnEE;EACE,YAAA;EAAA,cAAA;EAAA,kCAAA;EACA,iCAAA;EACA,6BAAA;AV0nEJ;;AUtnEA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AVynEF;AUvnEE;EACE,YAAA;EAAA,cAAA;EAAA,2BAAA;EACA,0BAAA;EACA,sBAAA;AVynEJ;;AUpnEE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kCAAA;AVunEJ;AUrnEI;EACE,eAAA;AVunEN;;AWj/HA;EACE,iBAAA;AXo/HF;;AWj/HA;EACE,kBAAA;AXo/HF;;AWj/HA;EACE,mBAAA;AXo/HF;;AWj/HA;EACE,gBAAA;AXo/HF;;AWj/HA;EACE,wBAAA;AXo/HF;;AWj/HA;EACE,mBAAA;AXo/HF;;AWj/HA;EACE,mBAAA;AXo/HF;;AWj/HA;EACE,iBAAA;AXo/HF;;AWh/HE;EACE,UAAA;EACA,YAAA;AXm/HJ;AWh/HE;EACE,mBAAA;EACA,sBAAA;EACA,8BAAA;AXk/HJ;AW/+HE;EACE,mBAAA;EACA,sBAAA;EACA,8BAAA;AXi/HJ;;AW7+HA;EACE,oBAAA;AXg/HF;;AW7+HA;EACE,4BAAA;AXg/HF;;AW7+HA;EACE,2BAAA;AXg/HF;;AW7+HA;EACE,eAAA;AXg/HF;;AW7+HA;EACE,WAAA;AXg/HF;;AW7+HA;EACE,UAAA;AXg/HF;;AW7+HA;EACE,iBAAA;AXg/HF;;AW7+HA;EACE,kBAAA;AXg/HF;;AW7+HA;EACE,kBAAA;AXg/HF;;AW7+HA;EACE,iBAAA;AXg/HF;;AW7+HA;EACE,iBAAA;AXg/HF;;AW7+HA;EACE,aAAA;EACA,mBAAA;AXg/HF;;AW7+HA;EACE,QAAA;AXg/HF;;AW7+HA;EACE,QAAA;AXg/HF;;AW7+HA;EACE,SAAA;AXg/HF;;AW7+HA;EACE,SAAA;AXg/HF;;AW7+HA;EACE,8BAAA;AXg/HF;;AW7+HA;EACE,yBAAA;AXg/HF;;AW7+HA;EACE,oBAAA;AXg/HF;AW9+HE;EACE,oBAAA;AXg/HJ;;AW5+HA;EACE,mBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;AX++HF;;AW5+HA;EACE,sBAAA;EACA,uBAAA;AX++HF;;AW5+HA;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;AX++HF;;AW5+HA;EACE,mBAAA;AX++HF;;AW5+HA;EACE,gBAAA;AX++HF;;AW5+HA;EACE,gBAAA;AX++HF;;AW5+HA;EACE,8BAAA;AX++HF;;AW5+HA;EACE,kBAAA;AX++HF;;AW5+HA;EACE,4BAAA;AX++HF;;AW5+HA;EACE,gBAAA;AX++HF;;AW5+HA;EACE,gBAAA;AX++HF;;AW5+HA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,8CAAA;EACA,sDAAA;EACA,gDAAA;EACA,UAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AX++HF;;AW5+HA;EACE,UAAA;AX++HF;;AW5+HA;EACE,kBAAA;EACA,WAAA;AX++HF;;AW5+HA;EACE,wBAAA;AX++HF;;AW5+HA;EACE,8BAAA;AX++HF;;AW5+HA;EACE,uBAAA;AX++HF;;AW5+HA;EACE,mBAAA;AX++HF;;AW5+HA;EACE,mBAAA;AX++HF;;AW5+HA;EACE,iBAAA;AX++HF;;AW5+HA;EACE,eAAA;AX++HF;;AW5+HA;EACE,yBAAA;AX++HF;;AW5+HA;EACE,UAAA;AX++HF;;AW5+HA;EACE,eAAA;AX++HF;;AW5+HA;EACE,oBAAA;AX++HF;;AW5+HA;EACE,oBAAA;AX++HF;;AW5+HA;EACE,YAAA;AX++HF;;AW5+HA;EACE,2BAAA;AX++HF;;AYzvIA;EACE,oBAAA;AZ4vIF;;AYzvIA;EACE,8BAAA;AZ4vIF;;AYzvIA;;EAEE,gBAAA;EACA,oBAAA;AZ4vIF;;AYzvIA;;EAEE,0BAAA;EACA,8BAAA;AZ4vIF;;AYzvIA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AZ4vIF;;AYzvIA;EACE,YAAA;AZ4vIF;;AYzvIA;EACE,iBAAA;EACA,6CAAA;EACA,0BAAA;AZ4vIF;;AYzvIA;EACE,iBAAA;AZ4vIF;;AYzvIA;EACE,6CAAA;EACA,0BAAA;AZ4vIF;;AYzvIA;;EAEE,eAAA;AZ4vIF;;AYzvIA;;EAEE,eAAA;AZ4vIF;;AYzvIA;;EAEE,eAAA;AZ4vIF;;AYzvIA;;EAEE,eAAA;AZ4vIF;;AYzvIA;EAeE,eAAA;AZ8uIF;AY5vIE;EACE,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;AZ8vIJ;AY3vIE;EACE,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;AZ6vIJ;AYxvIE;EACE,eAAA;AZ0vIJ;AYvvIE;EACE,eAAA;AZyvIJ;AYtvIE;EACE,eAAA;AZwvIJ;AYrvIE;EACE,iBAAA;AZuvIJ;AYpvIE;EACE,kBAAA;AZsvIJ;AYnvIE;EACE,mBAAA;AZqvIJ;;AY/uII;EACE,aAAA;AZkvIN;AYhvII;EACE,SAAA;AZkvIN;;Aan2IA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;Abs2IF;Aap2IE;EACE,qBAAA;Abs2IJ;Aan2IE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;Abq2IJ;Aaj2II;EACE,aAAA;Abm2IN;Aa/1IE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;Abi2IJ;Aa91IE;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Abg2IJ;Aa71IE;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Ab+1IJ;Aa51IE;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;Ab81IJ;Aa31IE;EACE,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Ab61IJ;Aa11IE;EACE,kBAAA;EACA,kBAAA;Ab41IJ;Aa11II;EACE,UAAA;Ab41IN;Aax1IE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;Ab01IJ;Aax1II;EACE,YAAA;Ab01IN;Aav1II;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;Aby1IN;Aav1IM;EACE,mCAAA;Aby1IR;Aav1IQ;EACE,mCAAA;Aby1IV;Aar1IM;EACE,wBAAA;Abu1IR;Aar1IQ;EACE,wBAAA;Abu1IV;Aan1IM;EACE,iBAAA;Abq1IR;Aal1IM;EACE,uCAAA;Abo1IR;Aa/0IE;EACE,2BAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EAEA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yDAAA;EACA,mCAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;Abg1IJ;Aa90II;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,gEAAA;Abg1IN;Aa90IM;EACE,aAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;Abg1IR;Aa70IM;EACE,WAAA;Ab+0IR;Aa50IM;EACE,SAAA;Ab80IR;Aa50IQ;EACE,WAAA;EACA,YAAA;Ab80IV;Aa10IM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;Ab40IR;Aav0IM;EACE,UAAA;EACA,QAAA;Aby0IR;Aar0II;EACE,mBAAA;Abu0IN;Aap0II;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,UAAA;Abs0IN;Aan0II;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,6DAAA;Abq0IN;Aan0IM;EACE,gBAAA;Abq0IR;Aaj0II;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;Abm0IN;Aa/zIM;EACE,eAAA;Abi0IR;Aa9zIM;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;Abg0IR;Aa5zII;EACE,kBAAA;Ab8zIN;Aa1zIE;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EAEA,8BAAA;Ab2zIJ;AazzII;EACE,gBAAA;EACA,WAAA;Ab2zIN;AaxzII;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;Ab0zIN;AatzIE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AbwzIJ;AatzII;EACE,SAAA;EACA,gBAAA;AbwzIN;AarzII;EACE,iBAAA;AbuzIN;AarzIM;EACE,qBAAA;EACA,yBAAA;EACA,kCAAA;EACA,eAAA;AbuzIR;AarzIQ;EACE,kCAAA;AbuzIV;;AahzIA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;AbmzIF;;Aa/yIE;;EAEE,uBAAA;EACA,+BAAA;AbkzIJ;;Aa9yIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AbizIF;Aa/yIE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AbizIJ;Aa9yIM;EACE,aAAA;AbgzIR;Aa5yII;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,MAAA;EACA,yDAAA;EACA,4BAAA;EACA,kCAAA;Ab8yIN;;AazyIA;EACE,WAAA;Ab4yIF;Aa1yIE;EACE,eAAA;EACA,aAAA;Ab4yIJ;Aa1yII;EACE,cAAA;Ab4yIN;AaxyIE;EACE,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;Ab0yIJ;AaxyII;EACE,aAAA;EACA,mBAAA;Ab0yIN;AavyII;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,oCAAA;EACA,uCAAA;EACA,0BAAA;AbyyIN;AatyII;EACE,kCAAA;EACA,uBAAA;AbwyIN;AatyIM;EACE,oCAAA;AbwyIR;;AalyIA;EACE,eAAA;EACA,iBAAA;EACA,8CAAA;AbqyIF;;AalyIA;EACE,kBAAA;EACA,eAAA;EACA,eAAA;AbqyIF;;AalyIA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AbqyIF;;AalyIA;EACE,WAAA;EACA,aAAA;AbqyIF;AanyIE;EACE,uCAAA;EACA,OAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AbqyIJ;AanyII;EACE,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AbqyIN;AajyIE;EACE,gBAAA;AbmyIJ;AahyIE;EACE,WAAA;AbkyIJ;Aa/xIE;EAEE,sBAAA;AbgyIJ;Aa7xIE;EACE,iBAAA;Ab+xIJ;AazxIQ;EACE,UAAA;Ab2xIV;AarxIM;EACE,iEAAA;EACA,mCAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;AbuxIR;AalxIM;EACE,iEAAA;EACA,0BAAA;EACA,6CAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AboxIR;AahxII;EACE,uCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AbkxIN;Aa/wII;EACE,uCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AbixIN;Aa/wIM;EACE,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,+BAAA;EACA,UAAA;EACA,mBAAA;AbixIR;Aa3wIE;EACE,YAAA;EACA,wBAAA;Ab6wIJ;Aa3wII;EACE,oBAAA;EACA,mBAAA;Ab6wIN;;AaxwIA;EACE,aAAA;Ab2wIF;AazwIE;EACE,oBAAA;EACA,mBAAA;Ab2wIJ;;AavwIA;EACE,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;Ab0wIF;AaxwIE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,wCAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;Ab0wIJ;AavwIE;EACE,kBAAA;EACA,6CAAA;EACA,uCAAA;EACA,8CAAA;AbywIJ;AatwIM;EACE,eAAA;AbwwIR;AalwII;EACE,eAAA;AbowIN;;Ach2JA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;Adm2JF;Acj2JE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;Adm2JJ;Ach2JE;EACE,kBAAA;Adk2JJ;Ac/1JE;EACE,mBAAA;Adi2JJ;Ach2JI;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;Adk2JN;Ac/1JI;EACE,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;Adi2JN;Ac91JE;EACE,aAAA;Adg2JJ;Ac71JE;EACE,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Ad+1JJ;Ac51JE;EACE,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;Ad81JJ;Ac51JI;EACE,uBAAA;Ad81JN;Ac31JI;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;Ad61JN;Ac11JI;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;Ad41JN;Acz1JE;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;Ad21JJ;Acx1JE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;Ad01JJ;Acv1JE;EACE,kBAAA;Ady1JJ;Act1JE;EACE,aAAA;EACA,mBAAA;Adw1JJ;Act1JI;EACE,kBAAA;Adw1JN;Acp1JE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;Ads1JJ;Acn1JE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;Adq1JJ;Acl1JE;EACE,kBAAA;Ado1JJ;Acl1JE;EACE,kBAAA;Ado1JJ;;Aeh9JE;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gDAAA;Afm9JJ;Aej9JI;EACE,kBAAA;Afm9JN;Aeh9JI;EACE,WAAA;Afk9JN;Ae/8JI;EACE,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Afi9JN;Ae98JI;EACE,wBAAA;Afg9JN;Ae78JI;EACE,wBAAA;Af+8JN;Ae38JE;EACE,kBAAA;EACA,gDAAA;EACA,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,sBAAA;Af68JJ;Ae18JI;EACE;IACE,gBAAA;Ef48JN;Ee18JI;IACE,YAAA;Ef48JN;Eez8JI;IACE,YAAA;Ef28JN;AACF;Aez8JI;EACE;IACE,gBAAA;Ef28JN;Eex8JI;IACE,gBAAA;Ef08JN;Eev8JI;IACE,gBAAA;Efy8JN;AACF;Aet8JI;EACE,kBAAA;Afw8JN;Aer8JM;EACE,yBAAA;Afu8JR;Aep8JM;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,0BAAA;EACA,UAAA;Afs8JR;Aep8JQ;EACE,cAAA;Afs8JV;Aej8JI;EACE,kBAAA;Afm8JN;Aeh8JI;EACE,UAAA;Afk8JN;Ae/7JI;EACE,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;Afi8JN;Ae57JI;EACE,6CAAA;EACA,qCAAA;Af87JN;Ae57JM;EACE,qCAAA;Af87JR;Aex7JE;EACE,cAAA;Af07JJ;Aev7JE;EACE,cAAA;Afy7JJ;Aet7JE;EACE,yCAAA;EACA,iFAAA;EACA,kBAAA;EACA,gBAAA;Afw7JJ;Aer7JE;EACE,2BAAA;Afu7JJ;Aep7JE;EACE,wBAAA;Afs7JJ;Aen7JE;EACE,kBAAA;Afq7JJ;Ael7JM;EACE,sCAAA;Afo7JR;Ae/6JM;EACE,sCAAA;Afi7JR;Ae/6JU;EACE,UAAA;Afi7JZ;Aez6JE;;EAEE,WAAA;EACA,kBAAA;Af26JJ;Aez6JI;;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;Af46JN;Ae16JM;;EACE,WAAA;EACA,YAAA;EACA,UAAA;Af66JR;Aev6JI;EACE,cAAA;Afy6JN;Aev6JM;EACE,6CAAA;EACA,gBAAA;Afy6JR;Aer6JI;EACE,6CAAA;Afu6JN;Aep6JI;EACE,SAAA;Afs6JN;;Aeh6JE;EACE,yBAAA;EACA,mBAAA;Afm6JJ;Aeh6JE;EACE,kBAAA;Afk6JJ;Aeh6JI;EACE,yBAAA;Afk6JN;Ae/5JI;EACE,yBAAA;Afi6JN;Ae55JI;EACE,SAAA;Af85JN;;Aez5JA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;Af45JF;;Aex5JE;EACE,WAAA;Af25JJ;;AgBppKA;EACE,YAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,yCAAA;EACA,gBAAA;AhBupKF;AgBrpKE;EACE,WAAA;EACA,gBAAA;EAEA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,6CAAA;EACA,kBAAA;AhBspKJ;AgBppKI;EACE,oBAAA;AhBspKN;AgBnpKI;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,0DAAA;AhBqpKN;AgBnpKM;EACE,oBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;AhBqpKR;AgBlpKM;EACE,gBAAA;AhBopKR;AgB/oKE;EACE,gBAAA;AhBipKJ;AgB/oKI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AhBipKN;AgB9oKI;EACE,cAAA;EACA,eAAA;EACA,WAAA;AhBgpKN;AgB7oKQ;EADF;IAEI,YAAA;IAAA,cAAA;IAAA,4BAAA;IACA,2BAAA;IACA,uBAAA;EhBgpKR;AACF;AgB3oKE;EACE,gBAAA;EACA,oBAAA;EACA,6CAAA;EACA,mCAAA;EACA,4FACE;EAEF,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AhB2oKJ;AgBzoKI;EACE,aAAA;AhB2oKN;AgBxoKI;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AhB0oKN;AgBvoKI;EACE,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;AhByoKN;AgBtoKI;EACE,aAAA;AhBwoKN;AgBpoKE;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AhBsoKJ;AgBnoKE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AhBqoKJ;AgBnoKI;EACE,gBAAA;AhBqoKN;AgBjoKE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mCAAA;EACA,yEAAA;EACA,aAAA;AhBmoKJ;AgBhoKE;EACE,eAAA;AhBkoKJ;;AiBxxKE;EACE,iBAAA;EACA,gBAAA;AjB2xKJ;AiBxxKE;EACE,iBAAA;EACA,gBAAA;AjB0xKJ;;AiBtxKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AjByxKJ;AiBvxKI;EACE,aAAA;EACA,mBAAA;AjByxKN;AiBvxKM;EACE,iBAAA;AjByxKR;AiBrxKE;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AjBuxKJ;AiBrxKI;EACE,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjBuxKN;AiBnxKE;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;AjBqxKJ;AiBlxKE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AjBoxKJ;AiBlxKI;EACE,4BAAA;AjBoxKN;AiBjxKE;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AjBmxKJ;AiBjxKE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;AjBmxKJ;AiBhxKE;EACE,aAAA;AjBkxKJ;AiB/wKE;EACE,aAAA;EACA,qCAAA;EA0BA,cAAA;AjBwvKJ;AiBhxKI;EACE,eAAA;EACA,qBAAA;EACA,qCAAA;EACA,2CAAA;EACA,sBAAA;AjBkxKN;AiBhxKM;EACE,mBAAA;AjBkxKR;AiB9wKI;EAhBF;IAiBI,qCAAA;EjBixKJ;AACF;AiB/wKI;EApBF;IAqBI,qCAAA;EjBkxKJ;AACF;AiBhxKI;EAxBF;IAyBI,qCAAA;EjBmxKJ;AACF;AiB7wKI;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AjB+wKN;AiB3wKE;EACE,mBAAA;EACA,qEAAA;EACA,mCAAA;EAEA,aAAA;AjB4wKJ;AiB1wKI;EACE,aAAA;AjB4wKN;AiBzwKI;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjB2wKN;AiBxwKI;EACE,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AjB0wKN;AiBvwKI;EACE,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,uBAAA;EACA,mBAAA;AjBywKN;AiBrwKM;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AjBuwKR;AiBrwKQ;EACE,4BAAA;EACA,mBAAA;AjBuwKV;AiBpwKQ;EACE,kCAAA;AjBswKV;AiBjwKI;EACE,iFACE;EAEF,6CAAA;EACA,qEAAA;AjBiwKN;AiB/vKM;EACE,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,uBAAA;EACA,mBAAA;AjBiwKR;AiB9vKM;EACE,2CAAA;AjBgwKR;AiB7vKM;EACE,2CAAA;AjB+vKR;AiB5vKM;EACE,qCAAA;AjB8vKR;AiBzvKE;EACE,aAAA;EACA,cAAA;EACA,UAAA;AjB2vKJ;AiBxvKM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AjB0vKR;AiBxvKQ;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjB0vKV;AiBvvKQ;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AjByvKV;AiBtvKQ;EACE,aAAA;EACA,eAAA;AjBwvKV;AiBrvKQ;EACE,WAAA;EACA,aAAA;AjBuvKV;AiBpvKQ;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,uBAAA;AjBsvKV;AiBhvKE;EACE,aAAA;EACA,cAAA;EACA,UAAA;AjBkvKJ;AiBhvKI;EACE,kBAAA;AjBkvKN;AiB/uKI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AjBivKN;AiB/uKM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AjBivKR;AiB9uKM;EACE,eAAA;EACA,mBAAA;AjBgvKR;AiB5uKI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;AjB8uKN;AiB5uKM;EACE,eAAA;EACA,mBAAA;AjB8uKR;;AiBvuKE;EACE,2BAAA;AjB0uKJ;;AiBtuKA;EACE,aAAA;AjByuKF;AiBvuKE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AjByuKJ;AiBvuKI;EACE,aAAA;EACA,mBAAA;AjByuKN;AiBruKE;EACE,cAAA;AjBuuKJ;AiBruKI;EACE,cAAA;EACA,eAAA;AjBuuKN;AiBnuKE;EACE,aAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;AjBquKJ;AiBluKE;EACE,aAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AjBouKJ;AiBluKI;EACE,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,iFACE;EAEF,mBAAA;EACA,aAAA;AjBkuKN;AiBhuKM;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AjBkuKR;AiBhuKQ;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AjBkuKV;AiB9tKM;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AjBguKR;AiB7tKM;EACE,gBAAA;EACA,aAAA;AjB+tKR;AiB5tKM;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;AjB8tKR;;AiBxtKA;EACE,aAAA;EACA,mBAAA;AjB2tKF;AiBztKE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AjB2tKJ;AiBxtKE;EACE,gBAAA;EACA,eAAA;AjB0tKJ;AiBvtKE;EACE,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,uBAAA;AjBytKJ;;AiBrtKA;EACE,mBAAA;EACA,iBAAA;AjBwtKF;AiBttKE;EACE,aAAA;EACA,iBAAA;AjBwtKJ;AiBrtKE;EACE,aAAA;EACA,mBAAA;AjButKJ;AiBrtKI;EACE,mBAAA;AjButKN;AiBrtKM;EACE,WAAA;AjButKR;AiBptKM;EACE,4BAAA;EACA,WAAA;AjBstKR;AiBntKM;EACE,iBAAA;AjBqtKR;AiBntKQ;EACE,uBAAA;AjBqtKV;AiBhtKI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AjBktKN;AiBhtKM;EACE,aAAA;EACA,mBAAA;AjBktKR;AiBhtKQ;EACE,kBAAA;EACA,sBAAA;EACA,OAAA;AjBktKV;AiB/sKQ;EACE,kBAAA;AjBitKV;AiB/sKU;EACE,eAAA;AjBitKZ;AiB3sKI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AjB6sKN;AiB3sKM;EACE,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AjB6sKR;AiB1sKM;EACE,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjB4sKR;;AiBrsKE;EACE,eAAA;AjBwsKJ;AiBrsKE;EACE,UAAA;AjBusKJ;AiBpsKE;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;AjBssKJ;AiBnsKE;EACE,aAAA;EACA,eAAA;EACA,gCAAA;EACA,oBAAA;EACA,mBAAA;AjBqsKJ;AiBnsKI;EACE,gBAAA;AjBqsKN;AiBlsKI;EACE,gBAAA;EACA,gBAAA;AjBosKN;AiBhsKE;EACE,aAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;AjBksKJ;AiBhsKI;EACE,mBAAA;AjBksKN;AiBhsKM;EACE,gBAAA;AjBksKR;AiB9rKI;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,kBAAA;AjBgsKN;AiB7rKI;EACE,kBAAA;AjB+rKN;AiB5rKI;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjB8rKN;AiB1rKE;EACE,aAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;AjB4rKJ;AiB1rKI;EACE,cAAA;EACA,eAAA;EACA,WAAA;AjB4rKN;AiBzrKI;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,kBAAA;AjB2rKN;AiBxrKI;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AjB0rKN;AiBxrKM;EACE,gBAAA;AjB0rKR;;AiBprKA;EACE,kBAAA;EACA,gBAAA;AjBurKF;AiBtrKE;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AjBwrKJ;AiBtrKE;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AjBwrKJ;;AiBprKA;EACE,6CAAA;AjBurKF;AiBrrKE;EACE,2CAAA;AjBurKJ;AiBprKE;EACE,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,iBAAA;AjBsrKJ;AiBnrKE;;;EAGE,+BAAA;AjBqrKJ;;AiBjrKA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AjBorKF;AiBlrKE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;AjBorKJ;AiBjrKE;EACE,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,kBAAA;AjBmrKJ;AiBjrKI;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjBmrKN;;AiB9qKA;EACE,iFACE;EAEF,yCAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AjB+qKF;AiB7qKE;EACE,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,kBAAA;AjB+qKJ;AiB7qKI;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjB+qKN;;AiB1qKA;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sCAAA;EACA,iBAAA;AjB6qKF;;AiB1qKA;EACE,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,iFACE;EAEF,kBAAA;AjB2qKF;AiBzqKE;EACE,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AjB2qKJ;AiBxqKE;EACE,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AjB0qKJ;;AkBv+LA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AlB0+LF;AkBx+LE;;EAEE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AlB0+LJ;AkBx+LI;;EACE,kBAAA;EACA,yCAAA;EACA,mCAAA;EACA,8CAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AlB2+LN;AkBx+LI;;EACE,oBAAA;EACA,YAAA;AlB2+LN;AkBv+LE;EACE,WAAA;EACA,UAAA;AlBy+LJ;AkBr+LI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AlBu+LN;AkBp+LI;EACE,cAAA;EACA,sCAAA;AlBs+LN;AkBn+LI;EACE,cAAA;EACA,sCAAA;AlBq+LN;;AmBniMA;EACE,kBAAA;AnBsiMF;AmBpiME;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6CAAA;EACA,mCAAA;EACA,2CAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AnBsiMJ;AmBniME;EACE,mBAAA;AnBqiMJ;AmBniMI;EACE,gBAAA;AnBqiMN;;AoBxjMA;EACE,6CAAA;EACA,mCAAA;EACA,2CAAA;EACA,SAAA;EACA,aAAA;ApB2jMF;AoBzjME;EACE,WAAA;EACA,UAAA;ApB2jMJ;AoBxjME;EACE,WAAA;ApB0jMJ;AoBvjME;EACE,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;ApByjMJ;AoBvjMI;EACE,gBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,qBAAA;ApByjMN;AoBrjME;EACE,aAAA;ApBujMJ;AoBpjME;;EAEE,uCAAA;ApBsjMJ;AoBpjME;EACE,uBAAA;ApBsjMJ;AoBnjME;;;;EAIE,qBAAA;EACA,yBAAA;EACA,SAAA;EACA,wBAAA;ApBqjMJ;AoBljME;EACE,SAAA;ApBojMJ;AoBjjME;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;ApBmjMJ;AoBhjME;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,qBAAA;EACA,6BAAA;ApBkjMJ;AoBhjMI;EACE,oBAAA;EACA,YAAA;ApBkjMN;AoB/iMI;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;ApBgjMN;AoB7iMI;EAEE,8BAAA;EACA,uCAAA;ApB8iMN;AoB1iME;EACE,gBAAA;ApB4iMJ;;AoBviME;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;ApB0iMJ;AoBxiMI;EACE,2EAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ApB0iMN;;AoBriMA;EACE,sBAAA;ApBwiMF;;AoBriMA;EACE,eAAA;ApBwiMF;AoBviME;EACE,UAAA;EACA,eAAA;ApByiMJ;;AoBpiME;EACE,kBAAA;ApBuiMJ;AoBpiME;EACE,WAAA;ApBsiMJ;AoBpiMI;EACE,WAAA;EACA,UAAA;ApBsiMN;AoBniMI;EACE,WAAA;ApBqiMN;AoBniMM;EACE,WAAA;EACA,0BAAA;EACA,cAAA;ApBqiMR;AoBniMQ;EACE,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,qCAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;ApBqiMV;AoBniMU;EACE,sCAAA;ApBqiMZ;AoBliMU;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gDAAA;EACA,mCAAA;ApBoiMZ;AoBjiMU;EACE,qCAAA;ApBmiMZ;AoBjiMY;EACE,6CAAA;ApBmiMd;AoBhiMY;EACE,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;ApBkiMd;;AoBxhME;EACE,WAAA;EACA,kBAAA;ApB2hMJ;AoBxhME;EACE,aAAA;ApB0hMJ;AoBvhME;;EAEE,WAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,qBAAA;EACA,6BAAA;ApByhMJ;AoBthME;EACE,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ApBwhMJ;AoBrhME;EACE,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,qBAAA;ApBuhMJ;AoBphME;EACE,qBAAA;EACA,yBAAA;ApBshMJ;AoBnhME;EACE,eAAA;EACA,gBAAA;ApBqhMJ;AoBlhME;EACE,eAAA;EACA,iBAAA;ApBohMJ;AoBjhME;EACE,6BAAA;EACA,gBAAA;ApBmhMJ;AoBhhME;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;ApBkhMJ;AoB/gME;EACE,yBAAA;EACA,mBAAA;ApBihMJ;AoB9gME;EACE,uCAAA;EACA,uCAAA;ApBghMJ;AoB7gME;EACE,SAAA;ApB+gMJ;AoB5gME;EACE,kBAAA;EACA,6CAAA;EACA,sCAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;ApB8gMJ;AoB5gMI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,uBAAA;EACA,YAAA;ApB8gMN;AoBzgMI;EACE,aAAA;ApB2gMN;AoBvgMM;EACE,wBAAA;ApBygMR;;AoB5/LE;EAaE,wBAAA;ApBm/LJ;;AoB/+LA;EACE,kBAAA;ApBk/LF;AoBh/LE;EACE,4BAAA;ApBk/LJ;AoB/+LE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;ApBi/LJ;;AqBx2MA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,iBAAA;ArB22MF;AqBz2ME;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;ArB22MJ;AqBx2ME;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yEAAA;EAEA,UAAA;ArBy2MJ;AqBv2MI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBA3CC;EA4CD,sBAAA;EACA,mEAAA;ArBy2MN;AqBx2MM;EACE;IACE,WAAA;IACA,OAAA;ErB02MR;EqBx2MM;IACE,WAAA;IACA,OAAA;ErB02MR;EqBx2MM;IACE,WAAA;IACA,uBAAA;ErB02MR;EqBx2MM;IACE,WAAA;IACA,OAAA;ErB02MR;EqBx2MM;IACE,WAAA;IACA,OAAA;ErB02MR;AACF;AqBr2ME;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAvEK;EAwEL,gEAAA;ArBu2MJ;AqBt2MI;EACE;IACE,YAAA;ErBw2MN;EqBr2MI;IACE,UAAA;ErBu2MN;EqBp2MI;IACE,YAAA;ErBs2MN;AACF;;AsB/7MA;EACE,iBAAA;EACA,kBAAA;AtBk8MF;AsBh8ME;EAJF;IAKI,uBAAA;EtBm8MF;AACF;AsBj8ME;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AtBm8MJ;AsBj8MI;EARF;IASI,uBAAA;EtBo8MJ;AACF;AsBj8ME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AtBm8MJ;AsBj8MI;EANF;IAOI,QAAA;IACA,cAAA;EtBo8MJ;EsBl8MI;IACE,cAAA;IACA,mBAAA;EtBo8MN;EsBl8MM;IACE,gBAAA;EtBo8MR;AACF;AsBh8MI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AtBk8MN;AsB97ME;EACE,aAAA;EACA,mBAAA;AtBg8MJ;AsB97MI;EACE,gBAAA;AtBg8MN;AsB57ME;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,2EAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AtB87MJ;AsB57MI;EAdF;IAeI,gBAAA;IACA,mBAAA;IACA,gBAAA;EtB+7MJ;AACF;AsB77MI;EApBF;IAqBI,+BAAA;IACA,gBAAA;EtBg8MJ;AACF;AsB97MI;EAzBF;IA0BI,kBAAA;IACA,cAAA;IACA,+BAAA;EtBi8MJ;AACF;AsB/7MI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,0BAAA;EACA,SAAA;AtBi8MN;AsB/7MM;EAVF;IAWI,eAAA;IACA,gBAAA;EtBk8MN;AACF;AsBh8MM;EAfF;IAgBI,eAAA;EtBm8MN;AACF;AsBh8MI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AtBk8MN;AsBh8MM;EAXF;IAYI,eAAA;EtBm8MN;AACF;AsBj8MM;EAfF;IAgBI,eAAA;EtBo8MN;AACF;AsBj8MI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;AtBm8MN;AsBj8MM;EAXF;IAYI,eAAA;IACA,gBAAA;EtBo8MN;AACF;AsBl8MM;EAhBF;IAiBI,eAAA;EtBq8MN;AACF;AsBl8MI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6CAAA;EACA,gBAAA;EACA,8CAAA;EACA,gBAAA;EACA,SAAA;EACA,qBAAA;AtBo8MN;;AuBvmNI;EACE,wBAAA;EACA,kBAAA;AvB0mNN;AuBvmNQ;EACE,aAAA;AvBymNV;AuBrmNM;;EAEE,kBAAA;AvBumNR;AuBrmNQ;;EACE,wBAAA;AvBwmNV;;AuBhmNE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AvBmmNJ;;AuB/lNA;EACE,QAAA;EACA,uBAAA;EAEA,aAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,UAAA;AvBimNF;AuB/lNE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yDAAA;EACA,eAAA;AvBimNJ;AuB/lNI;EACE,eAAA;EACA,kCAAA;AvBimNN;AuB9lNI;EACE,yDAAA;AvBgmNN;;AwB7pNA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,eAAA;AxBgqNF;AwB9pNE;EANF;IAOI,gDAAA;ExBiqNF;AACF;AwB/pNE;EAVF;IAWI,gDAAA;ExBkqNF;AACF;AwBhqNE;EAdF;IAeI,gDAAA;ExBmqNF;AACF;;AA1pNA;;;EAGE,SAAA;EACA,uCAAA;EACA,mCAAA;EACA,kCAAA;AA6pNF;;AAzpNE;EACE,gBAAA;AA4pNJ;;AAxpNA;EACE,+EAAA;AA2pNF;;AAxpNA;EACE,sBAAA;AA2pNF;;AyBxsNA;;;;;;EAME,aAAA;AzB2sNF;;AyBxsNA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AzB2sNF;;AyBxsNA;EACE,kBAAA;EACA,aAAA;AzB2sNF;;AyBxsNA;EACE,wBAAA;AzB2sNF;;AyBxsNA;EACE,aAAA;AzB2sNF;;AyBxsNA;EACE;IACE,gBAAA;EzB2sNF;AACF;AyBvsNE;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;AzBysNJ;AyBtsNE;EACE,eAAA;AzBwsNJ;AyBrsNE;EACE,aAAA;AzBusNJ;AyBpsNE;EACE,cAAA;AzBssNJ;AyBnsNE;EACE,aAAA;AzBqsNJ;AyBlsNE;EACE,UAAA;EACA,gBAAA;AzBosNJ;AyBjsNE;EACE,aAAA;AzBmsNJ;AyBhsNE;EACE,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AzBksNJ;AyBhsNI;EACE,oBAAA;AzBksNN;AyBhsNM;EACE,aAAA;EACA,yBAAA;AzBksNR;AyB/rNM;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AzBisNR;AyBhsNQ;EACE,gBAAA;EACA,gBAAA;AzBksNV;AyB5rNE;EACE,yBAAA;AzB8rNJ;AyB1rNI;EACE,aAAA;AzB4rNN;AyBlrNE;EACE,oBAAA;AzBorNJ;AyBjrNE;;EAEE,eAAA;AzBmrNJ;AyBhrNE;EACE,eAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AzBkrNJ;AyB/qNE;EACE,kBAAA;AzBirNJ;AyB9qNE;EACE,eAAA;AzBgrNJ;AyB7qNM;EACE,+BAAA;EACA,iBAAA;AzB+qNR;AyB3qNM;EACE,aAAA;EACA,8BAAA;AzB6qNR;AyB3qNQ;EACE,+BAAA;EACA,mBAAA;AzB6qNV;AyBzqNM;EACE,aAAA;AzB2qNR;AyBxqNM;EACE,UAAA;AzB0qNR;AyBvqNM;EACE,aAAA;AzByqNR;AyBtqNM;EACE,WAAA;AzBwqNR;AyB3pNE;EACE,uBAAA;EACA,oBAAA;AzB6pNJ;AyB1pNE;EACE,aAAA;AzB4pNJ;AyBzpNE;EACE,eAAA;AzB2pNJ;AyBxpNE;EACE,aAAA;AzB0pNJ;AyBvpNE;EACE,aAAA;AzBypNJ;AyBtpNE;EACE,WAAA;EACA,yBAAA;AzBwpNJ;AyBrpNE;EACE,oBAAA;AzBupNJ;AyBppNE;EACE,aAAA;AzBspNJ;AyBnpNE;EACE,aAAA;AzBqpNJ;AyBlpNE;EACE,aAAA;AzBopNJ;AyBlpNI;EACE,YAAA;AzBopNN;AyBjpNI;EACE,0BAAA;AzBmpNN;AyB9oNI;EACE,SAAA;AzBgpNN;AyB/oNM;EAFF;IAGI,0BAAA;IACA,YAAA;IAAA,cAAA;IAAA,2BAAA;EzBkpNN;AACF;AyBjpNM;EANF;IAOI,YAAA;IAAA,cAAA;IAAA,iCAAA;IACA,gCAAA;EzBopNN;AACF;AyBjpNI;EACE,2BAAA,EAAA,eAAA;EACA,yBAAA;UAAA,iBAAA;AzBmpNN;AyBhpNI;EACE,aAAA;AzBkpNN;AyB/oNI;EACE,aAAA;AzBipNN;AyB7oNE;EACE,aAAA;AzB+oNJ;AyB3oNI;EACE,aAAA;AzB6oNN;AyBzoNE;EACE,SAAA;EACA,SAAA;AzB2oNJ;AyBxoNE;EACE,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AzB0oNJ;AyBvoNE;EACE,cAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AzByoNJ;AyBtoNE;EACE,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AzBwoNJ;AyBroNE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AzBuoNJ;AyBroNI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AzBuoNN;AyBpoNI;EACE,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AzBsoNN;AyBpoNM;EACE,mBAAA;AzBsoNR;AyBjoNE;EACE,mBAAA;AzBmoNJ;AyB/nNI;EACE,UAAA;AzBioNN;AyB9nNI;EACE,iBAAA;AzBgoNN;AyB5nNE;EACE,cAAA;AzB8nNJ;AyB3nNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AzB6nNJ;AyB1nNE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AzB4nNJ;AyBznNE;EACE,aAAA;AzB2nNJ;AyBxnNE;EACE;;IAEE,cAAA;EzB0nNJ;EyBvnNE;IACE,mBAAA;EzBynNJ;EyBvnNI;IACE,gBAAA;EzBynNN;EyBrnNE;IACE,kBAAA;EzBunNJ;EyBpnNE;IACE,cAAA;EzBsnNJ;EyBnnNE;;;;IAIE,sBAAA;EzBqnNJ;AACF;AyB9mNE;EACE,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AzBgnNJ;AyB9mNI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AzBgnNN;AyB5mNE;EACE;IACE,cAAA;IACA,eAAA;IACA,WAAA;EzB8mNJ;AACF;AyB3mNE;EACE,aAAA;AzB6mNJ;;AyBnmNE;;EACE,eAAA;AzBumNJ;AyBpmNE;;EACE,yCAAA;AzBumNJ;AyBpmNE;;EACE,yBAAA;AzBumNJ;AyBrmNI;;EACE,wBAAA;AzBwmNN;AyBpmNE;;;;EAEE,cAAA;AzBwmNJ;AyBpmNI;;EACE,gBAAA;AzBumNN;AyBpmNI;;EACE,oBAAA;AzBumNN","sourcesContent":["@import 'variable';\n@import 'reset';\n@import 'icons';\n@import 'app';\n@import 'layout/index';\n@import 'form-builder/index';\n@import 'generic/button';\n@import 'generic/form-control';\n@import 'generic/utility';\n@import 'editor';\n@import 'library/library';\n@import 'auth';\n@import 'generic/table';\n@import 'generic/modal';\n@import 'company/company';\n@import 'generic/pagination';\n@import 'generic/dropdown';\n@import 'generic/datepicker';\n@import 'generic/loader';\n@import 'home';\n@import 'init-form';\n@import 'tasks/tasks';\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\nbody,\nhtml,\n*::placeholder {\n  margin: 0;\n  font-family: 'Inter', Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  &.ReactModal__Body--open {\n    overflow: hidden;\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n@import 'responsive';\n","/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0-modified | 20110126\n   License: none (public domain)\n*/\n\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn,  img, ins, kbd, q, s, samp,\nsmall, strike, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* make sure to set some focus styles for accessibility */\n:focus {\n  outline: 0;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol, ul {\n  list-style: none;\n}\n\nblockquote, q {\n  quotes: none;\n}\n\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ninput[type=search]::-webkit-search-cancel-button,\ninput[type=search]::-webkit-search-decoration,\ninput[type=search]::-webkit-search-results-button,\ninput[type=search]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\ninput[type=search] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n  resize: vertical;\n}\n\n/**\n * Correct `inline-block` display not defined in IE 6/7/8/9 and Firefox 3.\n */\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  *display: inline;\n  *zoom: 1;\n  max-width: 100%;\n}\n\n/**\n * Prevent modern browsers from displaying `audio` without controls.\n * Remove excess height in iOS 5 devices.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n * Known issue: no IE 6 support.\n */\n\n[hidden] {\n  display: none;\n}\n\n/**\n * 1. Correct text resizing oddly in IE 6/7 when body `font-size` is set using\n *    `em` units.\n * 2. Prevent iOS text size adjust after orientation change, without disabling\n *    user zoom.\n */\n\nhtml {\n  font-size: 100%; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -ms-text-size-adjust: 100%; /* 2 */\n}\n\n/**\n * Address `outline` inconsistency between Chrome and other browsers.\n */\n\na:focus {\n  outline: thin dotted;\n}\n\n/**\n * Improve readability when focused and also mouse hovered in all browsers.\n */\n\na:active,\na:hover {\n  outline: 0;\n}\n\n/**\n * 1. Remove border when inside `a` element in IE 6/7/8/9 and Firefox 3.\n * 2. Improve image quality when scaled in IE 7.\n */\n\nimg {\n  border: 0; /* 1 */\n  -ms-interpolation-mode: bicubic; /* 2 */\n}\n\n/**\n * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n */\n\nfigure {\n  margin: 0;\n}\n\n/**\n * Correct margin displayed oddly in IE 6/7.\n */\n\nform {\n  margin: 0;\n}\n\n/**\n * Define consistent border, margin, and padding.\n */\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct color not being inherited in IE 6/7/8/9.\n * 2. Correct text not wrapping in Firefox 3.\n * 3. Correct alignment displayed oddly in IE 6/7.\n */\n\nlegend {\n  border: 0; /* 1 */\n  padding: 0;\n  white-space: normal; /* 2 */\n  *margin-left: -7px; /* 3 */\n}\n\n/**\n * 1. Correct font size not being inherited in all browsers.\n * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n *    and Chrome.\n * 3. Improve appearance and consistency in all browsers.\n */\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-size: 100%; /* 1 */\n  margin: 0; /* 2 */\n  vertical-align: baseline; /* 3 */\n  *vertical-align: middle; /* 3 */\n}\n\n/**\n * Address Firefox 3+ setting `line-height` on `input` using `!important` in\n * the UA stylesheet.\n */\n\nbutton,\ninput {\n  line-height: normal;\n}\n\n/**\n * Address inconsistent `text-transform` inheritance for `button` and `select`.\n * All other form control elements do not inherit `text-transform` values.\n * Correct `button` style inheritance in Chrome, Safari 5+, and IE 6+.\n * Correct `select` style inheritance in Firefox 4+ and Opera.\n */\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/**\n * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n *    and `video` controls.\n * 2. Correct inability to style clickable `input` types in iOS.\n * 3. Improve usability and consistency of cursor style between image-type\n *    `input` and others.\n * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n *    Known issue: inner spacing remains in IE 6.\n */\n\nbutton,\nhtml input[type=\"button\"], /* 1 */\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n  cursor: pointer; /* 3 */\n  *overflow: visible;  /* 4 */\n}\n\n/**\n * Re-set default cursor for disabled elements.\n */\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n/**\n * 1. Address box sizing set to content-box in IE 8/9.\n * 2. Remove excess padding in IE 8/9.\n * 3. Remove excess padding in IE 7.\n *    Known issue: excess padding remains in IE 6.\n */\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n  *height: 13px; /* 3 */\n  *width: 13px; /* 3 */\n}\n\n/**\n * 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.\n * 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome\n *    (include `-moz` to future-proof).\n */\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; /* 2 */\n  box-sizing: content-box;\n}\n\n/**\n * Remove inner padding and search cancel button in Safari 5 and Chrome\n * on OS X.\n */\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * Remove inner padding and border in Firefox 3+.\n */\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/**\n * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n * 2. Improve readability and alignment in all browsers.\n */\n\ntextarea {\n  overflow: auto; /* 1 */\n  vertical-align: top; /* 2 */\n}\n\n/**\n * Remove most spacing between table cells.\n */\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nhtml,\nbutton,\ninput,\nselect,\ntextarea {\n  color: #222;\n}\n\n\n::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\nimg {\n  vertical-align: middle;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.chromeframe {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}","@font-face {\n  font-family: 'icomoon';\n  src:  url('../fonts/icomoon.eot');\n  src:  url('../fonts/icomoon.eot') format('embedded-opentype'),\n  url('../fonts/icomoon.ttf') format('truetype'),\n  url('../fonts/icomoon.woff') format('woff'),\n  url('../fonts/icomoon.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-icon-sliders-rotate:before {\n  content: \"\\e91c\";\n}\n.icon-icon-edit:before {\n  content: \"\\e917\";\n}\n.icon-green-circle {\n  width: 8px;\n  height: 8px;\n  background-color: green;\n  border-radius: 50%;\n  display: inline-block;\n}\n.icon-red-circle {\n  width: 8px;\n  height: 8px;\n  background-color: red;\n  border-radius: 50%;\n  display: inline-block;\n}\n.icon-icon-plus-circle:before {\n  content: \"\\e916\";\n}\n.icon-icon-upload:before {\n  content: \"\\e915\";\n}\n.icon-icon-home:before {\n  content: \"\\e914\";\n}\n.icon-icon-info:before {\n  content: \"\\e913\";\n  color: #cbd2e0;\n}\n.icon-icon-more-horizontal:before {\n  content: \"\\e90e\";\n}\n.icon-search:before {\n  content: \"\\e90f\";\n  color: #a0abc0;\n}\n.icon-icon-list:before {\n  content: \"\\e910\";\n}\n.icon-icon-sliders:before {\n  content: \"\\e911\";\n}\n.icon-icon-file:before {\n  content: \"\\e912\";\n}\n.icon-icon-folder:before {\n  content: \"\\e90d\";\n}\n.icon-star-empty:before {\n  content: \"\\e907\";\n}\n.icon-star-full:before {\n  content: \"\\e90c\";\n}\n.icon-icon-calendar:before {\n  content: \"\\e908\";\n}\n.icon-icon-mail:before {\n  content: \"\\e909\";\n}\n.icon-icon-clock:before {\n  content: \"\\e90a\";\n}\n.icon-plus-svgrepo-com:before {\n  content: \"\\e90b\";\n}\n.icon-icon-x:before {\n  content: \"\\e905\";\n}\n.icon-file-text:before {\n  content: \"\\e906\";\n}\n.icon-arrow-down:before {\n  content: \"\\e904\";\n}\n.icon-settings:before {\n  content: \"\\e900\";\n}\n.icon-placeholder:before {\n  content: \"\\e901\";\n}\n.icon-copy:before {\n  content: \"\\e902\";\n}\n.icon-remove:before {\n  content: \"\\e903\";\n}\n",".App {\n  text-align: center;\n\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n",".header-wrapper {\n  height: 80px;\n  width: 100%;\n  padding: 24px 30px;\n  border-bottom: 1px solid #eaecf0;\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  position: sticky;\n  top: 0;\n  z-index: 11;\n  background: #fff;\n\n  .pageBreadcrumbs {\n    display: flex;\n    align-items: center;\n    margin-left: 20px;\n\n    span {\n      color: var(--secondary-eading, #101828);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      cursor: pointer;\n      position: relative;\n\n      margin-right: 8px;\n\n      &:not(:last-child)::after {\n        padding-left: 8px;\n        content: '>';\n        cursor: auto;\n      }\n    }\n  }\n\n  .header-logo {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: -0.16px;\n\n    img {\n      max-width: 280px;\n      max-height: 40px;\n      object-fit: contain;\n    }\n  }\n\n  .header-left {\n    display: flex;\n    align-items: center;\n  }\n\n  .form-builder-header {\n    display: flex;\n\n    li {\n      margin-left: 32px;\n\n      &.active {\n        a {\n          color: var(--wf-base-800, #7f56d9);\n\n          svg {\n            * {\n              stroke: #7f56d9;\n            }\n          }\n        }\n      }\n\n      &.disable {\n        pointer-events: none;\n      }\n\n      a {\n        text-decoration: none;\n        color: var(--wf-base-600, #717d96);\n        text-align: center;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 24px;\n        letter-spacing: -0.16px;\n        position: relative;\n        transition: color 0.25s ease;\n        display: flex;\n        align-items: center;\n\n        svg {\n          margin-right: 5px;\n\n          * {\n            stroke: #717d96;\n          }\n        }\n\n        &:hover {\n          color: var(--wf-base-800, #2d3648);\n\n          i:before {\n            color: var(--wf-base-800, #2d3648);\n          }\n\n          svg {\n            * {\n              stroke: #2d3648;\n            }\n          }\n        }\n\n        &::before {\n          content: '';\n          display: block;\n          width: 0;\n          height: 2px;\n          background: var(--wf-base-800, #2d3648);\n          position: absolute;\n          left: 0;\n          top: calc(100% + 12px);\n          transition: width 0.25s ease;\n        }\n\n        i {\n          margin-right: 8px;\n        }\n      }\n    }\n  }\n}\n",".user-menu {\n  &-wrapper {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n    .user-logo {\n      margin-right: 12px;\n    }\n\n    span {\n      display: block;\n      color: #2D3648;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 22px;\n      letter-spacing: -0.33px;\n\n      &.text-secondary {\n        color: var(--text-grey-50, #85878F);\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 18px;\n        letter-spacing: -0.13px;\n      }\n    }\n  }\n\n  .user-dropdown {\n    position: relative;\n\n    &-item {\n      max-height: 340px;\n      overflow-y: auto;\n    }\n\n    &-menu {\n      position: absolute;\n      top: 100%;\n      right: 0;\n      border-radius: 8px;\n      background: #FFF;\n      box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.10);\n      min-width: 260px;\n      padding: 16px 0;\n\n      li {\n        padding: 10px 16px 10px 50px;\n        position: relative;\n        transition: all 0.25s ease;\n        margin: 6px 0;\n        color: var(--secondary-eading, #101828);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n\n        &:hover {\n          background: #F9F5FF;\n        }\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: 11px;\n          left: 16px;\n          width: 20px;\n          height: 20px;\n          border: 1px solid #7F56D9;\n          border-radius: 100%;\n          transition: all 0.25s ease;\n        }\n\n        &::after {\n          content: '';\n          position: absolute;\n          top: 17px;\n          left: 22px;\n          width: 10px;\n          height: 10px;\n          background: #7F56D9;\n          border-radius: 100%;\n          transition: all 0.25s ease;\n          opacity: 0;\n        }\n\n        &.active::after {\n          opacity: 1;\n        }\n      }\n    }\n  }\n}",".sidebar-menu {\n  border-right: 1px solid var(--divider, #eaecf0);\n  background: var(--secondary-surface, #f9fafb);\n  height: calc(100vh - 80px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  left: 0;\n  top: 80px;\n  position: fixed;\n\n  &-mini {\n    width: 75px;\n\n    .sidebar-menu-link {\n      justify-content: center;\n    }\n  }\n\n  &-top {\n    margin-top: 24px;\n  }\n\n  .sidebar-menu-link {\n    display: flex;\n    text-decoration: none;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    width: 48px;\n    height: 48px;\n    transition: background 0.25s ease;\n\n    i {\n      color: #2d3648;\n\n      &.icon-arrow-down {\n        transform: rotate(270deg);\n      }\n    }\n\n    svg:not(#fi-rs-building):not(#formbuilder) {\n      stroke: #98a2b3;\n    }\n\n    #fi-rs-building,\n    #formbuilder {\n      fill: #98a2b3;\n    }\n\n    &.disabled {\n      opacity: 0.5;\n      pointer-events: none;\n    }\n\n    &-active,\n    &:hover {\n      border-radius: var(--corner-radius-main, 8px);\n      background: var(--primary-100, #f4ebff);\n\n      svg:not(#fi-rs-building):not(#formbuilder) {\n        stroke: #7f56d9;\n\n        path {\n          stroke: #7f56d9;\n        }\n      }\n\n      #fi-rs-building,\n      #formbuilder {\n        fill: #7f56d9;\n      }\n    }\n  }\n\n  .sidebar-menu-bottom {\n    border-top: 1px solid #eaecf0;\n    padding: 12px 0;\n  }\n}\n",".form-builder-layout-full {\n  .form-builder-wrapper main.send-page .form-control-actions {\n    left: 0;\n    width: 100%;\n  }\n\n  .form-builder-wrapper main.send-page {\n    padding-left: 0;\n  }\n}\n\n.forbidden-page-wrapper {\n  .sidebar-menu {\n    display: none;\n  }\n\n  .form-builder-wrapper main.default-layout {\n    padding-left: 0;\n  }\n}\n\n.default-layout {\n  background: #fff;\n\n  .page-wrapper {\n    padding: 32px 40px;\n    width: 100%;\n  }\n}\n\n.forbidden-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n\n  h1 {\n    color: var(--secondary-eading, #101828);\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 38px;\n    text-align: center;\n    margin-bottom: 12px;\n  }\n\n  p {\n    color: var(--secondary-text, #667085);\n    text-align: center;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 21px;\n    max-width: 416px;\n    margin: 0 auto;\n  }\n}",".required {\n  color: rgba(217, 45, 32, 1);\n}\n\n.form-builder-wrapper {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  min-height: calc(100vh - 80px);\n  position: relative;\n  background: #f7f9fc;\n  overflow-x: hidden;\n\n  main.send-page {\n    padding-left: 75px;\n    width: 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n    justify-content: center;\n    padding-bottom: 150px;\n    padding-top: 24px;\n\n    & > div {\n      max-width: 1100px;\n      width: 100%;\n    }\n\n    .send-form-wrapper {\n      justify-content: space-between;\n      margin-bottom: 24px;\n    }\n\n    .send-form-title {\n      color: var(--secondary-eading, #101828);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px;\n\n      strong {\n        color: var(--secondary-eading, #101828);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n      }\n    }\n\n    .render-form {\n      max-width: 1100px;\n    }\n\n    .form-control-actions {\n      width: calc(100% - 75px);\n      left: 75px;\n\n      &.submit-form-actions {\n        width: calc(100% - 80px);\n        display: grid;\n        grid-template-columns: 1fr auto 1fr;\n\n        &::before {\n          display: inline-block;\n          content: '';\n        }\n      }\n    }\n  }\n\n  main.form-builder-wrapper-settings {\n    padding-right: 0;\n  }\n\n  main {\n    flex: 1 0 auto;\n    width: auto;\n    max-width: 100%;\n    display: flex;\n    min-height: calc(100vh - 80px);\n    padding-left: 395px;\n    padding-right: 300px;\n\n    &.default-layout {\n      padding-left: 75px;\n      padding-right: 0;\n    }\n  }\n\n  .form-builder-setting-tab {\n    padding: 30px 42px;\n    background: #fff;\n    min-height: 100%;\n    display: flex;\n\n    .react-tabs__tab-panel--selected {\n      display: flex;\n      height: auto;\n      width: 100%;\n    }\n\n    .react-tabs__tab-panel {\n      padding: 0;\n    }\n  }\n\n  .form-control-item-settings label {\n    display: block;\n    color: var(--secondary-eading, #101828);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n  }\n\n  .form-item-title {\n    span {\n      color: var(--secondary-text, #667085);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  .form-builder-setting-tab-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 996px;\n\n    &.w-full {\n      max-width: 100%;\n    }\n\n    .d-flex {\n      display: flex;\n      margin-bottom: 30px;\n\n      .form-control-radio {\n        margin-right: 44px;\n\n        &:first-child {\n          width: 145px;\n        }\n\n        &:nth-child(2) {\n          width: 145px;\n        }\n      }\n    }\n\n    .select-multy-wrapper {\n      position: relative;\n\n      .select-placeholder {\n        position: absolute;\n        top: 13px;\n        left: 15px;\n        z-index: 2;\n        pointer-events: none;\n        color: #a0abc0;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        letter-spacing: -0.16px;\n      }\n    }\n\n    .form-control-select .react-select-multi__control {\n      height: 48px;\n      position: relative;\n\n      & .css-1p3m7a8-multiValue {\n        display: none;\n      }\n    }\n\n    .form-control-radio {\n      margin-bottom: 0;\n    }\n\n    .form-builder-recipient-settings {\n      .form-control-item-settings {\n        display: flex;\n\n        .form-label-big {\n          font-size: 16px;\n        }\n      }\n\n      .form-control-item-group {\n        margin-bottom: 28px;\n\n        .form-control-item-half {\n          flex: 0 0 50%;\n          max-width: 50%;\n          width: 50%;\n        }\n      }\n\n      &.form-init-settings {\n        padding-bottom: 80px;\n\n        .form-settings-label {\n          width: 604px;\n        }\n      }\n\n      .form-settings-label {\n        width: 471px;\n\n        span {\n          color: var(--secondary-text, #667085);\n          font-size: 14px;\n        }\n      }\n\n      .form-settings-inputs {\n        width: 100%;\n        padding-left: 24px;\n\n        &.disabled {\n          opacity: 0.6;\n          pointer-events: none;\n        }\n      }\n    }\n\n    .form-builder-access-settings {\n      max-width: 600px;\n    }\n\n    .form-control-actions {\n      display: flex;\n      justify-content: flex-end;\n      border-top: 1px solid #cbd2e0;\n      padding: 28px 0 0;\n\n      .btn-outline:not(:last-child) {\n        margin-right: 18px;\n      }\n    }\n  }\n\n  .form-builder-aside-left {\n    flex: 0 0 320px;\n    max-width: 320px;\n    width: 320px;\n    background: #fff;\n    border-right: 1px solid var(--divider, #eaecf0);\n    padding: 20px;\n    height: calc(100vh - 80px);\n    overflow-y: auto;\n    position: fixed;\n    top: 80px;\n    left: 75px;\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: 16px;\n\n    .form-control-item {\n      height: 44px;\n    }\n\n    &.p-0 {\n      padding: 0;\n    }\n\n    .form-builder-aside-tab {\n      width: 100%;\n\n      .react-tabs__tab {\n        text-align: left;\n        justify-content: flex-start;\n        padding: 24px;\n        color: var(--secondary-eading, #101828);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n        transition: all 0.25s ease;\n        cursor: pointer;\n        border-right: 2px solid transparent;\n\n        &.react-tabs__tab--disabled {\n          color: var(--secondary-base, #cbd2e0);\n        }\n\n        &.react-tabs__tab--selected {\n          color: var(--wf-base-800, #7f56d9);\n          background: var(--wf-base-300, #f4ebff);\n          border-right: 2px solid #7f56d9;\n        }\n\n        &::after {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .form-builder-aside-property {\n    flex: 0 0 286px;\n    max-width: 286px;\n    width: 286px;\n    background: #fff;\n    border-left: 1px solid var(--divider, #eaecf0);\n    padding: 20px;\n    height: calc(100vh - 80px);\n    overflow-y: auto;\n    position: fixed;\n    top: 80px;\n    right: 0;\n    transition: all 0.25s ease;\n    transform: translateX(100%);\n\n    .form-control-item {\n      display: flex;\n\n      .settings-actions {\n        padding-left: 16px;\n      }\n\n      .btn-remove {\n        i {\n          position: relative;\n          top: auto;\n          transform: translate(0, 0);\n          right: auto;\n\n          &::before {\n            color: #b42318;\n          }\n        }\n      }\n    }\n\n    .settings-actions {\n      display: flex;\n      justify-content: space-between;\n\n      .btn {\n        margin-bottom: 0;\n      }\n    }\n\n    &.form-builder-aside-property-open {\n      transform: translateX(0);\n    }\n\n    .property-item {\n      margin-bottom: 24px;\n\n      .form-control-item {\n        &.automatic--addition--rows--date {\n          .react-datepicker-wrapper {\n            display: inline-flex;\n          }\n        }\n      }\n    }\n\n    .btn-outline {\n      margin-bottom: 8px;\n    }\n\n    .text-secondary {\n      color: #cbd2e0;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      letter-spacing: -0.12px;\n      display: block;\n    }\n\n    &-title {\n      color: var(--secondary-eading, #101828);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 20px;\n    }\n\n    &-sub-title {\n      color: var(--secondary-eading, #101828);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 16px;\n      margin-bottom: 16px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n\n    .tabs {\n      &-nav {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 24px;\n\n        &-item {\n          color: var(--wf-base-600, #717d96);\n          text-align: center;\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: 24px;\n          letter-spacing: -0.16px;\n          padding: 12px;\n          width: 100px;\n          position: relative;\n\n          &::before {\n            content: '';\n            position: absolute;\n            top: 100%;\n            left: 50%;\n            transform: translateX(-50%) scale(0);\n            width: 100%;\n            height: 2px;\n            background: var(--wf-base-800, #2d3648);\n            transition: all 0.25s ease;\n          }\n\n          &-active {\n            color: var(--wf-base-800, #2d3648);\n\n            &::before {\n              transform: translateX(-50%) scale(1);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .form-builder-content {\n    flex: 0 0 100%;\n    width: 100%;\n    max-width: 100%;\n    padding: 42px 40px;\n  }\n\n  .form-builder-drop-area {\n    min-height: 550px;\n    width: 100%;\n    background: #fff;\n    box-shadow: 0 8px 25px 0 rgba(45, 54, 72, 0.05);\n    border-radius: 8px;\n  }\n}\n\n.form-builder-element {\n  margin-bottom: 14px;\n  padding: 12px 5px 12px 12px;\n  color: var(--wf-base-800, #2d3648);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.16px;\n  border-radius: 6px;\n  border: 1px solid var(--wf-base-400, #cbd2e0);\n  background: var(--wf-base-white, #fff);\n  width: calc(50% - 8px);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  &-title {\n    color: #cbd2e0;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 140%;\n    margin-bottom: 16px;\n  }\n}\n\n.drop-area {\n  width: 100%;\n  min-height: 550px;\n  border: 2px dashed transparent;\n\n  &-active {\n    border: 2px dashed var(--wf-base-400, #cbd2e0);\n  }\n\n  .form-builder-item {\n    display: block;\n    width: 100%;\n  }\n}\n\n.form-builder-element-preview {\n  max-width: 100%;\n  border-radius: 8px;\n  border: 1px dashed transparent;\n  padding: 24px;\n  transition: border 0.25s ease;\n  position: relative;\n\n  &:not(.from-builder-title) {\n    min-height: 134px;\n  }\n\n  &-drag {\n    opacity: 0;\n    //height: 120px;\n    //position: relative;\n    //width: 100%;\n    //display: flex;\n    //align-items: center;\n    //justify-content: center;\n    //border: 1px dashed #2D3648;\n    //\n    //&::before {\n    //  content: 'Drop Here';\n    //  font-size: 16px;\n    //  text-align: center;\n    //  font-style: normal;\n    //  font-weight: 700;\n    //}\n    //\n    //& > * {\n    //  display: none;\n    //}\n  }\n\n  &:hover {\n    border: 1px dashed var(--primary-500, #9e77ed);\n  }\n\n  &:hover {\n    .form-builder-element-preview-action {\n      .btn.btn-icon {\n        opacity: 1;\n      }\n    }\n  }\n\n  &-action {\n    position: absolute;\n    left: 100%;\n    padding-left: 6px;\n    top: 50%;\n    transform: translateY(-50%);\n\n    .btn.btn-icon {\n      border-radius: 6px;\n      opacity: 0;\n      transition: all 0.25s ease;\n\n      &.btn-settings {\n        border: 1px solid var(--secondary-input-outline, #dadee4);\n        background: #fff;\n        padding: 8px;\n        margin-bottom: 6px;\n\n        i {\n          font-size: 20px;\n        }\n\n        i:before {\n          color: #667085;\n        }\n      }\n\n      &.btn-remove {\n        border: 1px solid var(--secondary-input-outline, #fda29b);\n        background: #fff;\n        padding: 8px;\n\n        i {\n          font-size: 20px;\n        }\n\n        i:before {\n          color: #b42318;\n        }\n      }\n    }\n\n    &-active {\n      .btn.btn-icon {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.from-builder-title {\n  padding: 30px;\n\n  h1 {\n    margin-bottom: 0;\n    color: var(--wf-base-800, #2d3648);\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 140%;\n\n    i {\n      margin-right: 14px;\n    }\n  }\n}\n\n.additional-dropdown {\n  margin-bottom: 20px;\n}\n\n.info-text {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 21px */\n  letter-spacing: -0.14px;\n  color: var(--wf-base-800, #2d3648);\n  display: flex;\n  align-items: center;\n  margin-bottom: 28px;\n  max-width: 600px;\n\n  i {\n    font-size: 24px;\n    margin-right: 12px;\n  }\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  background: var(--primary-50, #f9f5ff);\n  border-bottom: 1px solid var(--divider, #eaecf0);\n  color: #7f56d9;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px; /* 127.273% */\n  letter-spacing: 0.03px;\n}\n\n.avatar-group {\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n  margin-right: 8px;\n\n  .avatar {\n    margin-right: 0 !important;\n    margin-left: -8px;\n  }\n}\n\n.react-tabs__tab.react-tabs__tab--disabled {\n  color: var(--secondary-base, #cbd2e0);\n}\n\n.instructions {\n  color: var(--secondary-text, #667085);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  margin-top: 10px;\n  display: block;\n}\n\n.init-page {\n  .form-builder-setting-tab.bg-transparent {\n    background: transparent;\n    padding: 0;\n  }\n\n  .react-tabs__tab-panel {\n    width: 100%;\n  }\n\n  .init-form-tab {\n    width: 100%;\n    height: 100%;\n  }\n\n  .init-form-action {\n    max-width: 1100px;\n    margin: 0 auto 25px;\n    display: flex;\n    align-items: center;\n  }\n\n  .init-form-tab-content {\n    width: 100%;\n    padding: 24px 15px 150px;\n  }\n\n  .form-control-actions {\n    border-top: 1px solid var(--divider, #eaecf0);\n    width: calc(100% - 395px);\n    display: flex;\n    justify-content: flex-end;\n    padding: 32px 40px;\n    background: #fff;\n    position: fixed;\n    bottom: 0;\n    z-index: 9;\n\n    .btn {\n      display: inline-flex;\n      align-items: center;\n    }\n\n    .btn-outline {\n      &:not(:last-child) {\n        margin-right: 18px;\n      }\n    }\n  }\n\n  .render-form {\n    border-radius: 8px;\n    border: 1px solid var(--divider, #eaecf0);\n    background: #fff;\n    box-shadow:\n      0 1px 2px 0 rgba(16, 24, 40, 0.06),\n      0 1px 3px 0 rgba(16, 24, 40, 0.1);\n    max-width: 1100px;\n    margin: 0 auto;\n\n    .form-builder-element-preview:hover {\n      border-color: transparent;\n    }\n\n    .form-builder-element-preview-table {\n      pointer-events: auto !important;\n    }\n\n    .form-builder-element-preview-wrapper .form-grid-item,\n    .form-builder-element-preview-wrapper .react-ios-time-picker-main,\n    .form-builder-element-preview-wrapper select,\n    .form-builder-element-preview-wrapper .form-control,\n    .form-builder-element-preview-wrapper .form-control-checkbox,\n    .form-builder-element-preview-wrapper .form-control-radio,\n    .form-builder-element-preview-wrapper .sigCanvas,\n    .form-builder-element-preview-wrapper .btn-signature {\n      pointer-events: auto;\n    }\n\n    &__copy-group {\n      margin-bottom: 24px;\n      position: relative;\n      outline: 1px dashed #cbd2e0;\n\n      &__remove-btn {\n        top: 50%;\n        right: -44px;\n        width: 38px;\n        height: 38px;\n        justify-content: center;\n        background: #fff !important;\n        position: absolute;\n        transform: translateY(-50%);\n        border: 1px solid var(--secondary-input-outline, #fda29b) !important;\n        z-index: 1;\n\n        .label {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n.init-page {\n  .form-view-wrapper {\n    position: relative;\n    max-width: 1100px;\n    margin: 0 auto;\n\n    .form-view-actions {\n      border-top: var(--outline, 1px) solid var(--Secondary-Input-Outline, #dadee4);\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      padding: 24px;\n\n      .btn {\n        min-width: 137px;\n      }\n    }\n\n    .render-form {\n      padding-bottom: 100px;\n    }\n  }\n}\n\n.general-form-tab-content {\n  .form-builder-element-preview-wrapper {\n    pointer-events: auto !important;\n  }\n}\n\n.ReactModal__Overlay .modal-default.print-modal {\n  .form-builder-element-preview-wrapper {\n    pointer-events: none !important;\n  }\n\n  .form-builder-element-preview-login {\n    .add-facility {\n      display: none;\n    }\n  }\n\n  .table-form-builder-element-preview {\n    .form-builder-element-preview-wrapper {\n      pointer-events: auto !important;\n    }\n  }\n}\n\n.from-builder-title-setting {\n  padding: 0;\n  margin-bottom: 32px;\n}\n\n.form-readonlyy .sigCanvas {\n  pointer-events: none !important;\n}\n\n.form-readonlyy.form-builder-element-preview-file-upload {\n  pointer-events: auto !important;\n\n  .btn.btn-icon {\n    display: none;\n  }\n}\n\n.share-with-company {\n  .from-builder-title-setting {\n    max-width: 696px;\n    margin: 40px auto -24px;\n  }\n}\n\n.init-page {\n  .form-control-actions.form-init-content {\n    width: calc(100% - 395px);\n    padding: 32px 42px;\n    transform: translateX(-42px);\n    justify-content: flex-start;\n\n    & > div {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n\n      .btn-outline-secondary {\n        margin-right: 0;\n      }\n    }\n  }\n}\n\n// Print modal\n.print {\n  border: 6px;\n  background: #fff;\n\n  .html-area {\n    padding: 34px;\n\n    img {\n      max-width: 100%;\n    }\n  }\n\n  .form-builder-element-preview {\n    border: 0 solid transparent;\n    padding: 12px 24px;\n\n    // Hide required label is it's print modal\n    .required {\n      display: none;\n    }\n  }\n\n  .sigCanvas-clear {\n    display: none;\n  }\n}\n\n.form-builder-recipient-settings-init {\n  padding: 30px;\n}\n\n.form-builder-wrapper .form-builder-setting-tab.p-0 {\n  padding: 0;\n}\n\n.file-upload.library-item {\n  min-width: 250px;\n  margin: 0;\n}\n\n.btn-attach {\n  margin: 10px 0;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.modal-tabs {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n\n  .btn-tab {\n    height: 73px;\n    width: 50%;\n    border: 0;\n    background: #ffffff;\n    color: var(--Secondary-eading, #101828);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    border-radius: 8px 8px 0 0;\n    position: relative;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 100%;\n      left: 0;\n      width: 100%;\n      height: 2px;\n      background: var(--Primary-700, #6941c6);\n      transform: scale(0);\n      transition: all 0.25s ease;\n    }\n\n    &.btn-tab-active {\n      color: var(--Primary-700, #6941c6);\n\n      &::before {\n        transform: scale(1);\n      }\n    }\n  }\n}\n\n.ReactModal__Overlay .modal-default.modal-with-tabs {\n  padding-top: 105px;\n\n  .library {\n    padding: 0;\n    background: transparent;\n\n    .breadcrumbs-item {\n      font-size: 13px;\n      line-height: 13px;\n    }\n\n    .breadcrumbs-item::after {\n      top: -4px;\n    }\n\n    .library-item {\n      max-width: calc(33.333% - 16px);\n\n      &.library-item-active {\n        background: linear-gradient(0deg, rgba(127, 86, 217, 0.12) 0%, rgba(127, 86, 217, 0.12) 100%), var(--on-primary, #fff);\n      }\n    }\n  }\n}\n\n.btn-signature {\n  width: 100%;\n  height: 40px !important;\n}\n\n.ReactModal__Overlay .modal-default.print-modal {\n  padding-bottom: 32px;\n  max-width: 800px;\n\n  .form-control-table-wrapper-print {\n    table {\n      //width: 100%;\n      //table-layout: fixed;\n    }\n\n    td,\n    th {\n      border: 1px solid #eaecf0;\n      //width: auto !important;\n      //min-width: auto;\n      padding: 5px;\n      word-break: break-word;\n    }\n\n    .form-control {\n      padding: 0;\n      border-radius: 0;\n      border: 0;\n    }\n  }\n\n  .form-builder-element-preview-file-attach,\n  .form-builder-element-preview-file-attach .form-builder-element-preview-wrapper,\n  .form-builder-element-preview-file-upload,\n  .form-builder-element-preview-file-upload .form-builder-element-preview-wrapper {\n    pointer-events: auto !important;\n  }\n\n  .form-control-file {\n    pointer-events: none;\n  }\n\n  .form-builder-element-preview-wrapper .btn {\n    display: none;\n  }\n\n  .form-builder-element-preview:not(.from-builder-title) {\n    min-height: auto;\n  }\n\n  @media print {\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n\n    .form-builder-element-preview-file-attach,\n    .form-builder-element-preview-file-upload {\n      display: none !important;\n    }\n\n    .form-control-select .react-select__control {\n      border: 0;\n    }\n\n    .react-select__indicators,\n    .react-select__placeholder {\n      display: none !important;\n    }\n\n    .form-builder-element-preview {\n      min-height: auto;\n      padding: 6px;\n    }\n\n    .optional {\n      display: none;\n    }\n\n    .form-control {\n      padding: 0;\n      border: 0;\n      height: auto;\n    }\n\n    .modal-header {\n      display: none !important;\n    }\n\n    .from-builder-title {\n      padding: 15px;\n    }\n  }\n}\n\n@media print {\n  #root {\n    display: none;\n  }\n\n  .ReactModal__Overlay {\n    padding: 0 !important;\n    position: relative !important;\n  }\n}\n\n.success-page {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  padding-top: 40px;\n  padding-bottom: 40px;\n  width: 100%;\n\n  img {\n    margin-bottom: 14px;\n  }\n\n  h2 {\n    color: var(--Secondary-eading, #101828);\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n    margin-bottom: 12px;\n  }\n\n  p {\n    color: var(--Secondary-Text, #667085);\n    text-align: center;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 21px;\n    max-width: 375px;\n  }\n}\n\n.library-filter .btn.btn-file {\n  padding: 10px 12px 8px;\n}\n\n.init-page {\n  .form-builder-element-preview:not(.from-builder-title) {\n    min-height: auto;\n  }\n\n  .form-builder-element-preview-login {\n    .add-facility {\n      display: none;\n    }\n\n    &.show-button {\n      .add-facility {\n        display: block;\n        pointer-events: auto;\n      }\n    }\n  }\n\n  .share-with-company {\n    background: #f7f9fc;\n    padding: 0 24px;\n\n    .init-form-tab-content {\n      padding: 0;\n      max-width: 696px;\n      margin: 40px auto;\n      background: #fff;\n      border-radius: 8px;\n      border: 1px solid var(--divider, #eaecf0);\n      box-shadow:\n        0 1px 2px 0 rgba(16, 24, 40, 0.06),\n        0 1px 3px 0 rgba(16, 24, 40, 0.1);\n\n      .share-with-company-header {\n        padding: 16px 24px;\n        border-bottom: 1px solid var(--divider, #eaecf0);\n      }\n\n      .share-with-company-footer {\n        padding: 16px 24px;\n        border-top: 1px solid var(--divider, #eaecf0);\n        display: flex;\n        justify-content: space-between;\n      }\n\n      .share-with-company-body {\n        padding: 16px 24px;\n      }\n    }\n  }\n}\n\n.report-builder {\n  display: flex;\n  width: 100%;\n  background: var(--Secondary-surface, #f9fafb);\n\n  .report-builder-aside {\n    flex: 0 0 435px;\n    max-width: 435px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    padding: 24px;\n\n    .result {\n      .result-title {\n        color: var(--Primary-600, #7f56d9);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 21px;\n        margin-top: 14px;\n        margin-bottom: 4px;\n      }\n\n      .result-item {\n        display: flex;\n        align-items: center;\n        color: var(--Secondary-eading, #101828);\n        font-feature-settings: 'calt' off;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        margin-bottom: 8px;\n      }\n\n      .result-list {\n        max-height: 200px;\n        overflow-y: auto;\n\n        svg {\n          cursor: pointer;\n        }\n      }\n    }\n\n    .title {\n      color: var(--Secondary-eading, #101828);\n      font-size: 25px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 150%;\n      margin-bottom: 23px;\n    }\n\n    .btn {\n      display: flex;\n      align-items: center;\n      margin: 0 auto;\n    }\n\n    .form-item-wrapper {\n      position: relative;\n\n      .form-control {\n        padding-right: 45px;\n      }\n\n      .icon-search {\n        position: absolute;\n        top: 10px;\n        right: 12px;\n      }\n    }\n  }\n\n  .ql-container {\n    border: 1px solid var(--Secondary-Input-Outline, #dadee4);\n    background: var(--On-Primary, #fff);\n    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n    border-radius: var(--Corner-radius-main, 8px);\n    padding: 32px;\n\n    .ql-editor {\n      padding: 0;\n    }\n  }\n\n  .ql-toolbar {\n    border: 1px solid var(--Secondary-Input-Outline, #dadee4);\n    background: var(--On-Primary, #fff);\n  }\n\n  .report-builder-editor {\n    max-width: 797px;\n    margin: 0 auto;\n  }\n\n  .report-builder-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n\n    .actions {\n      display: flex;\n    }\n\n    .btn-outline {\n      margin-left: 12px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    h3 {\n      color: var(--Secondary-eading, #101828);\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n    }\n  }\n\n  .report-builder-empty {\n    border-radius: 8px;\n    border: 1px solid var(--divider, #eaecf0);\n    background: #fff;\n    box-shadow:\n      0 1px 2px 0 rgba(16, 24, 40, 0.06),\n      0 1px 3px 0 rgba(16, 24, 40, 0.1);\n    padding: 40px 32px;\n    max-width: 797px;\n    margin: 0 auto;\n\n    h3 {\n      color: #000;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n      margin-bottom: 24px;\n      text-align: center;\n    }\n\n    p {\n      color: var(--Secondary-Text, #667085);\n      text-align: center;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 21px;\n      max-width: 352px;\n      margin: 0 auto;\n    }\n  }\n\n  .report-builder-content {\n    flex: 0 0 calc(100% - 435px);\n    max-width: calc(100% - 435px);\n    width: calc(100% - 435px);\n    padding: 40px;\n  }\n}\n\n.btn-preview {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 24px;\n}\n\n.modal-open {\n  overflow: hidden;\n  max-height: calc(100vh - 80px);\n}\n\n.preview-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #f7f9fc;\n  z-index: 9999;\n  overflow-y: auto;\n\n  &.init-page .render-form .form-builder-element-preview-wrapper .form-control {\n    pointer-events: none !important;\n  }\n\n  .preview-modal-actions {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 40px 0;\n    color: var(--Secondary-eading, #101828);\n    /* Input Label */\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n\n    .btn-orientation {\n      margin-left: 8px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 0;\n      border-radius: 6px;\n      border: 1px solid var(--Primary-300, #d6bbfb);\n      opacity: var(--outline, 1);\n      width: 32px;\n      height: 32px;\n      background: linear-gradient(0deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), var(--On-Primary, #fff);\n\n      &.active {\n        border-radius: 6px;\n        border: 1px solid var(--Primary-300, #d6bbfb);\n        opacity: var(--outline, 1);\n\n        background: linear-gradient(0deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), var(--Primary-100, #f4ebff);\n      }\n    }\n  }\n\n  .send-form {\n    position: relative;\n  }\n\n  .render-form {\n    box-shadow: none;\n    border: 0;\n  }\n\n  .form-control-actions {\n    position: absolute;\n    width: 100%;\n    justify-content: space-between;\n    padding: 24px;\n  }\n\n  .form-view-wrapper-desktop {\n    .preview-modal-actions {\n      display: none;\n    }\n  }\n\n  .form-view-wrapper-phone {\n    .send-form-wrapper {\n      border-radius: 30px;\n      border: 20px solid var(--divider, #eaecf0);\n      opacity: var(--outline, 1);\n      background: #fff;\n      box-shadow:\n        0 1px 2px 0 rgba(16, 24, 40, 0.06),\n        0 1px 3px 0 rgba(16, 24, 40, 0.1);\n      height: 600px;\n      overflow-y: auto;\n      width: 360px;\n      margin: 0 auto;\n      scrollbar-width: thin;\n      scrollbar-color: rgba(0, 0, 0, 0.06) rgba(0, 0, 0, 0.01);\n\n      .form-control,\n      .form-control-select {\n        width: 100%;\n      }\n\n      .form-control-checkbox-wrapper {\n        flex-wrap: wrap;\n        flex-direction: column;\n        max-height: 100%;\n\n        .form-control-checkbox {\n          width: 100%;\n        }\n      }\n\n      &.send-form-wrapper-horizontal {\n        width: 600px;\n        height: 360px;\n      }\n\n      &::-webkit-scrollbar {\n        width: 7px;\n      }\n\n      &::-webkit-scrollbar-track {\n        border-radius: 40px;\n        border: 1px solid #fff;\n        background: rgba(0, 0, 0, 0.01);\n      }\n\n      &::-webkit-scrollbar-thumb {\n        border-radius: 40px;\n        border: 1px solid #fff;\n        background: rgba(0, 0, 0, 0.06);\n      }\n    }\n\n    .from-builder-title {\n      border-bottom: var(--outline, 1px) solid var(--divider, #eaecf0);\n    }\n  }\n\n  .form-view-wrapper-tablet {\n    .send-form-wrapper-vertical {\n      .send-form {\n        min-height: 100%;\n      }\n    }\n\n    .send-form-wrapper-horizontal {\n      .send-form {\n        min-height: calc(100% + 50px);\n      }\n    }\n\n    .send-form-wrapper {\n      border-radius: 30px;\n      border: 20px solid var(--divider, #eaecf0);\n      opacity: var(--outline, 1);\n      background: #fff;\n      box-shadow:\n        0 1px 2px 0 rgba(16, 24, 40, 0.06),\n        0 1px 3px 0 rgba(16, 24, 40, 0.1);\n      height: 1133px;\n      overflow-y: auto;\n      width: 744px;\n      margin: 0 auto;\n      scrollbar-width: thin;\n      scrollbar-color: rgba(0, 0, 0, 0.06) rgba(0, 0, 0, 0.01);\n\n      &.send-form-wrapper-horizontal {\n        width: 1133px;\n        height: 744px;\n        background: #f7f9fc;\n\n        .send-form {\n          max-width: 744px;\n          margin: 40px auto;\n        }\n      }\n\n      &::-webkit-scrollbar {\n        width: 7px;\n      }\n\n      &::-webkit-scrollbar-track {\n        border-radius: 40px;\n        border: 1px solid #fff;\n        background: rgba(0, 0, 0, 0.01);\n      }\n\n      &::-webkit-scrollbar-thumb {\n        border-radius: 40px;\n        border: 1px solid #fff;\n        background: rgba(0, 0, 0, 0.06);\n      }\n    }\n\n    .from-builder-title {\n      border-bottom: var(--outline, 1px) solid var(--divider, #eaecf0);\n    }\n  }\n\n  .form-view-wrapper {\n    margin: 40px auto;\n  }\n\n  .header-center {\n    display: flex;\n  }\n\n  .tabs-nav-item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--Secondary-Text, #667085);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    position: relative;\n    padding: 0 24px;\n    cursor: pointer;\n    margin: 0 16px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 48px;\n      left: 0;\n      width: 100%;\n      background: var(--Primary-700, #6941c6);\n      height: 1px;\n      opacity: 0;\n    }\n\n    &.tabs-nav-item-active {\n      color: var(--Primary-700, #6941c6);\n\n      &::before {\n        opacity: 1;\n      }\n\n      svg {\n        path {\n          stroke: rgba(127, 86, 217, 1);\n        }\n      }\n    }\n\n    svg {\n      margin-right: 8px;\n\n      path {\n        stroke: rgba(102, 112, 133, 1);\n      }\n    }\n  }\n}\n\n.ReactModal__Overlay .modal-default.modal-reset {\n  max-width: 441px;\n\n  .login-page {\n    margin: 0;\n  }\n\n  .form-control-item {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n",".dropdown-menu {\n  .btn {\n    text-align: left;\n  }\n\n}\n\n.company-profile-header-action {\n  .btn {\n    line-height: 1.2;\n  }\n}\n\n.btn {\n  padding: 10px 18px;\n  font-size: 16px;\n  color: #fff;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: -0.16px;\n  border-radius: 6px;\n  background: #7F56D9;\n  border: 2px solid var(--wf-base-800, #7F56D9);\n  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n  text-decoration: none;\n  white-space: nowrap;\n  user-select: none;\n  cursor: pointer;\n\n\n  &:hover,\n  &:active {\n    background: linear-gradient(0deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0.21) 100%), var(--primary-600, #7F56D9);\n    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.20);\n    border: 2px solid var(--primary-600, #9A7AE1);\n  }\n\n  &:active {\n    box-shadow: none !important;\n  }\n\n  &[disabled] {\n    border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36)) !important;\n    background: var(--secondary-outline, rgba(152, 162, 179, 0.36)) !important;\n    box-shadow: none !important;\n    color: #101828 !important;\n\n    i:before {\n      color: #101828 !important;\n    }\n  }\n\n  i:before {\n    color: #fff;\n  }\n\n  &.btn-white {\n    background: #fff;\n    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n    border: 1px solid var(--gray-300, #D0D5DD);\n    color: var(--secondary-eading, #101828);\n\n    i::before {\n      color: var(--secondary-eading, #101828);\n    }\n  }\n\n  &.btn-danger {\n    border: 1px solid var(--tertiary-100, #D92D20);\n    background: var(--on-primary, #D92D20);\n    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n    color: #fff;\n    display: flex;\n    align-items: center;\n\n    i {\n      &:before {\n        color: #fff;\n      }\n    }\n\n    svg {\n      * {\n        stroke: #fff !important;\n      }\n    }\n\n    &:hover {\n      background: #fff;\n      color: #D92D20;\n\n      i {\n        &:before {\n          color: #D92D20;\n        }\n      }\n\n      svg {\n        * {\n          stroke: #D92D20 !important;\n        }\n      }\n    }\n  }\n\n  &.btn-text {\n    background: var(--on-primary, #FFF);\n    border: 0;\n    color: #101828;\n    height: 41px;\n    box-shadow: none;\n    transition: all 0.25s ease;\n\n    &.btn-text-primary {\n      color: #7F56D9;\n      font-weight: 600;\n\n      i {\n        &:before {\n          color: #7F56D9;\n          transition: all 0.25s ease;\n        }\n      }\n    }\n\n    &:hover {\n      box-shadow: none;\n      background: linear-gradient(0deg, rgba(127, 86, 217, 0.12) 0%, rgba(127, 86, 217, 0.12) 100%), var(--on-primary, #FFF);\n    }\n\n    i {\n      &:before {\n        color: #2D3648;\n        transition: all 0.25s ease;\n      }\n    }\n\n    &.btn-success {\n      border: 1px solid #12B76A;\n      background: var(--on-primary, #FFF);\n      box-shadow: none;\n      color: #12B76A;\n\n      i {\n        &:before {\n          color: #12B76A;\n        }\n      }\n\n\n      &:hover {\n        background: #12B76A;\n        color: #fff;\n\n        i {\n          &:before {\n            color: #fff;\n          }\n        }\n\n        svg {\n          * {\n            stroke: #fff !important;\n          }\n        }\n      }\n    }\n\n    &.btn-danger {\n      border: 0;\n      background: var(--on-primary, #FFF);\n      box-shadow: none;\n      color: #D92D20;\n\n      i {\n        &:before {\n          color: #D92D20;\n        }\n      }\n\n      svg {\n        * {\n          stroke: #D92D20 !important;\n        }\n      }\n\n      &:hover {\n        background: #D92D20;\n        color: #fff;\n\n        i {\n          &:before {\n            color: #fff;\n          }\n        }\n\n        svg {\n          * {\n            stroke: #fff !important;\n          }\n        }\n      }\n    }\n\n    &[disabled] {\n      border: 0;\n      background: var(--secondary-outline, rgba(152, 162, 179, 0.36));\n    }\n  }\n\n  &.btn-outline {\n    border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n    background: var(--on-primary, #FFF);\n    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n    transition: all 0.25s ease;\n    color: #101828;\n    height: 41px;\n\n    &.btn-down {\n      transform: translateY(2px);\n\n      svg {\n        transform: translateY(2px);\n      }\n    }\n\n    &.btn-outline-secondary {\n      border: 1px solid #9E77ED;\n      color: #7F56D9;\n    }\n\n    &.btn-filter {\n      i::before {\n        color: #101828;\n      }\n    }\n\n    &.btn-active {\n      border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n      background: linear-gradient(0deg, rgba(127, 86, 217, 0.12) 0%, rgba(127, 86, 217, 0.12) 100%), var(--on-primary, #FFF);\n      box-shadow: 0 2px 5px 0 rgba(16, 24, 40, 0.20);\n\n      i:before {\n        color: var(--primary-600, #7F56D9);\n      }\n\n      svg * {\n        fill: var(--primary-600, #7F56D9);\n      }\n    }\n\n\n    &.btn-edit {\n      padding: 8px 20px;\n\n      i:before {\n        font-size: 24px;\n      }\n    }\n\n    &.btn-success {\n      border: 1px solid var(--secondary-outline, #12B76A);\n      background: var(--on-primary, #FFF);\n      box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n      color: #12B76A;\n      display: flex;\n      align-items: center;\n\n      i {\n        &:before {\n          color: #12B76A;\n        }\n      }\n\n\n      &:hover {\n        background: #12B76A;\n        color: #fff;\n\n        i {\n          &:before {\n            color: #fff;\n          }\n        }\n\n        svg {\n          * {\n            stroke: #fff !important;\n          }\n        }\n      }\n    }\n\n    &.btn-danger {\n      border: 1px solid var(--tertiary-100, #D92D20);\n      background: var(--on-primary, #FFF);\n      box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n      color: #D92D20;\n      display: flex;\n      align-items: center;\n\n      i {\n        &:before {\n          color: #D92D20;\n        }\n      }\n\n      svg {\n        * {\n          stroke: #D92D20 !important;\n        }\n      }\n\n      &:hover {\n        background: #D92D20;\n        color: #fff;\n\n        i {\n          &:before {\n            color: #fff;\n          }\n        }\n\n        svg {\n          * {\n            stroke: #fff !important;\n          }\n        }\n      }\n    }\n\n    i {\n      &:before {\n        color: #2D3648;\n        transition: all 0.25s ease;\n      }\n    }\n\n    &:hover,\n    &:active {\n      border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n      background: linear-gradient(0deg, rgba(127, 86, 217, 0.12) 0%, rgba(127, 86, 217, 0.12) 100%), var(--on-primary, #FFF);\n      box-shadow: 0 2px 5px 0 rgba(16, 24, 40, 0.20);\n    }\n\n    &[disabled] {\n      border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n      background: var(--secondary-outline, rgba(152, 162, 179, 0.36));\n    }\n  }\n\n  &.btn-icon {\n    padding: 0;\n    border: 0;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    box-shadow: none !important;\n\n    i:before {\n      color: #2D3648;\n    }\n\n    &.btn-remove {\n      i {\n        position: relative;\n        top: auto;\n        transform: translate(0, 0);\n        right: auto;\n\n        &::before {\n          color: #B42318;\n        }\n      }\n    }\n  }\n\n  &.btn-wide {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n\n  &.btn-remove {\n    display: inline-flex;\n    border: 0;\n    align-items: center;\n    color: var(--tertiary-600, #B42318);\n    background-color: transparent;\n\n    i {\n      &::before {\n        color: var(--tertiary-600, #B42318);\n      }\n    }\n  }\n}\n\n.btn-link {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  color: var(--primary-600, #7F56D9);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n\n  i {\n    margin-right: 10px;\n  }\n}\n\n.btn-left {\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.btn-full {\n  width: 100%;\n}\n\n.btn.btn-outline.btn-save {\n  display: flex;\n  align-items: center;\n  color: #7F56D9;\n  border: 1px solid #7F56D9;\n\n\n  svg {\n    margin-right: 5px;\n    margin-top: -1px;\n  }\n}",".form-radio-button {\n  position: relative;\n  display: inline-block;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 2;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  input:checked + span {\n    background: var(--primary-100, #f4ebff);\n    color: var(--primary-700, #6941c6);\n    border: 1px solid var(--primary-300, #d6bbfb);\n  }\n\n  span {\n    display: inline-block;\n    padding: 8px 11px;\n    color: var(--primary-700, #6941c6);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    letter-spacing: -0.16px;\n    border-radius: 8px;\n    border: 1px solid var(--primary-500, #9e77ed);\n    z-index: -1;\n    cursor: pointer;\n  }\n}\n\n.form-group {\n  display: flex;\n  justify-content: space-between;\n}\n\n.form-grid-full-name {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 20px;\n\n  &-small {\n    width: 50%;\n  }\n\n  &-medium {\n    width: 75%;\n  }\n\n  &-large {\n    width: 100%;\n  }\n}\n\n.form-switcher {\n  position: relative;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 2;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  input:checked + span {\n    color: var(--wf-base-800, #2d3648);\n\n    &::before {\n      background: var(--primary-600, #7f56d9);\n      border: 1px solid var(--wf-base-800, #7f56d9);\n    }\n\n    &::after {\n      background: var(--primary-600, #fff);\n      left: 19px;\n    }\n  }\n\n  span {\n    color: var(--wf-base-800, #717d96);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    letter-spacing: -0.14px;\n    position: relative;\n    padding-left: 52px;\n    transition: all 0.25s ease;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0;\n      transform: translateY(-50%);\n      width: 40px;\n      height: 24px;\n      border-radius: 999px;\n      border: 1px solid var(--wf-base-800, #717d96);\n      transition: all 0.25s ease;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      left: 6px;\n      width: 19px;\n      height: 19px;\n      background: #717d96;\n      border-radius: 100%;\n      transition: all 0.25s ease;\n    }\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n  min-height: 130px;\n}\n\n.form-control,\n.react-ios-time-picker-input {\n  border-radius: 6px;\n  border: 1px solid var(--wf-base-400, #cbd2e0);\n  background: var(--wf-base-white, #fff);\n  height: 44px;\n  padding: 12px 12px 12px 16px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.14px;\n  color: #2d3648;\n  width: 100%;\n\n  &::placeholder {\n    color: #98a2b3;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.16px;\n    opacity: 0.5;\n  }\n\n  &:disabled {\n    background-color: hsl(0, 0%, 95%);\n  }\n\n  &-small {\n    width: 50%;\n  }\n\n  &.form-control-clicks-small {\n    width: 200px;\n    margin-top: 5px;\n  }\n\n  &-medium {\n    width: 75%;\n  }\n\n  &-large {\n    width: 100%;\n  }\n\n  &-item {\n    margin-bottom: 24px;\n    position: relative;\n\n    &.form-control-item-login {\n      display: flex;\n      flex-direction: column;\n\n      &.alignment {\n        &-left {\n          align-items: flex-start;\n        }\n\n        &-right {\n          align-items: flex-end;\n        }\n\n        &-center {\n          align-items: center;\n        }\n      }\n    }\n\n    i {\n      position: absolute;\n      right: 15px;\n      top: 50%;\n      transform: translateY(-50%);\n\n      &.icon-search {\n        font-size: 24px;\n      }\n    }\n\n    &.form-control-item-with-type-dropdown {\n      .btn-dropdown i {\n        right: 40px;\n      }\n    }\n  }\n\n  &::placeholder {\n    color: #717d96;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.16px;\n  }\n}\n\n.form-label {\n  color: var(--wf-base-800, #2d3648);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: -0.14px;\n  margin-bottom: 8px;\n  display: block;\n  justify-content: space-between;\n  white-space: break-spaces;\n\n  &-big {\n    font-size: 18px;\n    margin-bottom: 16px;\n  }\n\n  .optional {\n    color: var(--secondary-dark, #101828);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    float: right;\n    padding-left: 15px;\n  }\n}\n\n.form-builder-element-preview-wrapper {\n  .form-grid-item,\n  .react-ios-time-picker-main,\n  select,\n  .form-control-checkbox,\n  .form-control-radio,\n  .sigCanvas {\n    pointer-events: none;\n  }\n}\n\n.form-control-radio-wrapper,\n.form-control-checkbox-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n\n  &.center {\n    justify-content: center;\n  }\n}\n\n.form-control-radio {\n  position: relative;\n  margin-bottom: 15px;\n\n  &.center,\n  &.right {\n    display: flex;\n    align-items: center;\n  }\n\n  &.center {\n    justify-content: center;\n  }\n\n  &.right {\n    justify-content: flex-end;\n  }\n\n  &:not(.element) {\n    input {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      z-index: 2;\n      opacity: 0;\n      cursor: pointer;\n    }\n\n    input:checked + span {\n      color: var(--wf-base-800, #2d3648);\n\n      &::before {\n        border: 1px solid var(--wf-base-800, #7f56d9);\n      }\n\n      &::after {\n        background: #7f56d9;\n      }\n    }\n\n    input:disabled {\n      cursor: default;\n\n      & + span {\n        opacity: 0.6 !important;\n        pointer-events: none;\n      }\n    }\n\n    span {\n      color: var(--secondary-eading, #101828);\n\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 16px;\n      position: relative;\n      padding-left: 30px;\n      transition: all 0.25s ease;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 0;\n        transform: translateY(-50%);\n        width: 20px;\n        height: 20px;\n        border-radius: 999px;\n        border: 1px solid var(--wf-base-800, #cbd2e0);\n        transition: all 0.25s ease;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: 6px;\n        width: 10px;\n        height: 10px;\n        background: transparent;\n        border-radius: 100%;\n        transition: all 0.25s ease;\n      }\n    }\n  }\n\n  // radiobutton-element\n  &.element {\n    .radiobutton-label {\n      display: inline-flex;\n      align-items: center;\n      color: var(--secondary-eading, #101828);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      user-select: none;\n      cursor: pointer;\n    }\n\n    input {\n      width: 22px;\n      height: 22px;\n      position: absolute;\n      opacity: 0;\n      pointer-events: none;\n      z-index: -1;\n    }\n\n    .radiobutton-button {\n      width: 22px;\n      height: 22px;\n      display: inline-flex;\n      margin-right: 8px;\n      align-items: center;\n      border-radius: 50%;\n      overflow: hidden;\n      position: relative;\n      justify-content: center;\n      border: 1px solid var(--primary-600, #7f56d9);\n\n      &.checked {\n        background: var(--primary-50, #f9f5ff);\n\n        @media screen {\n          &::before {\n            width: 10px;\n            height: 10px;\n            display: inline-flex;\n            content: '';\n            border-radius: 50%;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            background-color: var(--primary-600, #7f56d9);\n          }\n        }\n\n        @media print {\n          &::before {\n            top: -3px;\n            left: -1px;\n            width: 22px;\n            height: 22px;\n            display: inline-flex;\n            content: '•';\n            border-radius: 50%;\n            font-size: 30px;\n            color: var(--primary-600, #7f56d9);\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n          }\n        }\n      }\n    }\n  }\n\n  .icon-icon-info {\n    z-index: 9;\n    position: relative;\n  }\n\n  &-small {\n    span {\n      &::after {\n        width: 10px;\n        height: 10px;\n        left: 4px;\n      }\n\n      &::before {\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n\n  &-medium {\n    span {\n      &::after {\n        width: 14px;\n        height: 14px;\n        left: 4px;\n      }\n\n      &::before {\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  &-large {\n    span {\n      &::after {\n        width: 16px;\n        height: 16px;\n        left: 4px;\n      }\n\n      &::before {\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n}\n\n.form-control-checkbox {\n  display: block;\n  position: relative;\n  margin-bottom: 15px;\n\n  &.center,\n  &.right {\n    display: flex;\n    align-items: center;\n  }\n\n  &.center {\n    justify-content: center;\n  }\n\n  &.right {\n    justify-content: flex-end;\n  }\n\n  &:not(.element) {\n    input {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      z-index: 2;\n      opacity: 0;\n      cursor: pointer;\n    }\n\n    input:checked + span {\n      color: var(--wf-base-800, #2d3648);\n\n      &::before {\n        border-radius: 4px;\n        border: 1px solid var(--primary-600, #7f56d9);\n        background: var(--primary-50, #f9f5ff);\n      }\n\n      &::after {\n        background: url('../../images/ok-icon.svg') no-repeat center center;\n      }\n    }\n\n    span {\n      display: inline-block;\n      color: var(--wf-base-800, #717d96);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      letter-spacing: -0.14px;\n      position: relative;\n      //margin-left: 30px;\n      padding-left: 30px;\n      transition: all 0.25s ease;\n      min-width: 20px;\n      min-height: 20px;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 0;\n        transform: translateY(-50%);\n        width: 20px;\n        height: 20px;\n        border-radius: 4px;\n        border: 1px solid var(--wf-base-800, #717d96);\n        transition: all 0.25s ease;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: 4px;\n        width: 14px;\n        height: 14px;\n        background: transparent;\n        border-radius: 3px;\n      }\n    }\n  }\n\n  // CheckboxElement\n  &.element {\n    input {\n      position: absolute;\n      z-index: -1;\n      opacity: 0;\n      cursor: pointer;\n      pointer-events: none;\n    }\n\n    .checkbox-label {\n      display: inline-flex;\n      align-items: center;\n      color: var(--secondary-eading, #101828);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      user-select: none;\n      cursor: pointer;\n    }\n\n    .checkbox-button {\n      width: 22px;\n      height: 22px;\n      display: inline-flex;\n      margin-right: 8px;\n      align-items: center;\n      border-radius: 4px;\n      user-select: none;\n      justify-content: center;\n      border: 1px solid var(--primary-600, #7f56d9);\n\n      &.checked {\n        background: var(--primary-50, #f9f5ff);\n        @media screen {\n          &::before {\n            content: '';\n            width: 14px;\n            height: 14px;\n            background: transparent;\n            border-radius: 3px;\n            background: url('../../images/ok-icon.svg') no-repeat center center;\n          }\n        }\n        @media print {\n          &::before {\n            width: auto;\n            height: auto;\n            display: inline-block;\n            content: '✔';\n            font-size: 14px;\n            color: var(--primary-600, #7f56d9);\n          }\n        }\n      }\n    }\n  }\n\n  &-small {\n    span {\n      &::after {\n        width: 10px;\n        height: 10px;\n        left: 5px;\n      }\n\n      &::before {\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n\n  &-medium {\n    span {\n      &::after {\n        width: 14px;\n        height: 14px;\n        left: 5px;\n      }\n\n      &::before {\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  &-large {\n    span {\n      &::after {\n        width: 16px;\n        height: 16px;\n        left: 5px;\n      }\n\n      &::before {\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n}\n\n.form-control-checkbox-span {\n  position: relative;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 2;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  input:checked + span {\n    color: var(--wf-base-800, #fff);\n\n    background: var(--wf-base-800, #7f56d9);\n  }\n\n  span {\n    color: var(--secondary-eading, #101828);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n    letter-spacing: -0.14px;\n    position: relative;\n    transition: all 0.25s ease;\n    border-radius: 30px;\n    border: 1px solid var(--secondary-input-outline, #dadee4);\n    background: var(--On-Primary, #fff);\n    min-width: 44px;\n    min-height: 44px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n  }\n}\n\n.week-grid {\n  display: flex;\n  margin: 10px 0;\n\n  .form-control-checkbox-span {\n    margin-right: 10px;\n  }\n}\n\n.month-grid {\n  flex-wrap: wrap;\n  width: 421px;\n\n  .form-control-checkbox-span {\n    flex: 0 0 100px;\n    max-width: 100px;\n    width: 100px;\n    margin-bottom: 15px;\n\n    span {\n      width: 100px;\n    }\n  }\n}\n\n.form-control-star {\n  & > span {\n    margin-right: 3px;\n  }\n\n  .icon-star-empty,\n  .icon-star-full {\n    font-size: 20px;\n  }\n\n  &.form-control-star-small {\n    .icon-star-empty,\n    .icon-star-full {\n      font-size: 16px;\n    }\n  }\n\n  &.form-control-star-large {\n    .icon-star-empty,\n    .icon-star-full {\n      font-size: 26px;\n    }\n  }\n}\n\n.sigCanvas {\n  border: 1px solid #cbd2e0;\n  display: block;\n  margin-bottom: 5px;\n  border-radius: 8px;\n\n  &-small {\n    width: 50%;\n  }\n\n  &-medium {\n    width: 75%;\n  }\n\n  &-large {\n    width: 100%;\n  }\n}\n\n.form-control.textarea {\n  height: auto;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.sigCanvas-clear {\n  cursor: pointer;\n}\n\n.form-label {\n  &-small .form-label {\n    width: 50%;\n  }\n\n  &-medium .form-label {\n    width: 75%;\n  }\n\n  &-large .form-label {\n    width: 100%;\n  }\n\n  &-small .form-grid-full-name .form-label,\n  &-medium .form-grid-full-name .form-label,\n  &-large .form-grid-full-name .form-label,\n  &-small .w-full.form-label,\n  &-medium .w-full.form-label,\n  &-large .w-full.form-label {\n    width: 100%;\n  }\n}\n\n.form-label-small .instructions {\n  width: 50%;\n}\n\n.form-label-medium .instructions {\n  width: 75%;\n}\n\n.form-label-large .instructions {\n  width: 100%;\n}\n\n.form-builder-element-preview {\n  .optional {\n    display: none;\n  }\n}\n\n.form-control-select {\n  width: 100%;\n\n  &.form-control {\n    &-small {\n      width: 50%;\n    }\n\n    &-medium {\n      width: 75%;\n    }\n\n    &-large {\n      width: 100%;\n    }\n  }\n\n  .react-select-multi__control {\n    .react-select-multi__value-container {\n      flex-wrap: nowrap;\n    }\n\n    .react-select-multi__multi-value {\n      border: 0;\n      background: transparent;\n    }\n\n    .react-select-multi__clear-indicator {\n      display: none;\n    }\n\n    .react-select-multi__multi-value__remove {\n      width: 20px;\n      min-width: 20px;\n      height: 20px;\n      background: url('../../images/x-circle.svg') no-repeat center center;\n\n      svg {\n        display: none;\n      }\n    }\n  }\n\n  .react-select-multi__menu {\n    z-index: 99;\n    margin: 0;\n    border-radius: 0 0 6px 6px;\n    width: max-content;\n    min-width: 100%;\n\n    .react-select__option,\n    .react-select-multi__option {\n      position: relative;\n      background: var(--primary-50, #fff);\n      color: var(--secondary-dark, #101828);\n      font-feature-settings: 'calt' off;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      padding-left: 50px;\n\n      &::before {\n        content: '';\n        position: absolute;\n        left: 15px;\n        top: 9px;\n        width: 20px;\n        height: 20px;\n        border: 1px solid var(--secondary-base, #cbd2e0);\n        background: var(--On-Primary, #fff);\n        border-radius: 4px;\n      }\n\n      &.react-select__option--is-selected,\n      &.react-select-multi__option--is-selected {\n        color: var(--secondary-dark, #101828);\n\n        &::before {\n          border: 1px solid var(--primary-600, #7f56d9);\n          background: var(--primary-50, #f9f5ff) url('../../images/check.svg') no-repeat center center;\n        }\n      }\n\n      &:hover {\n        background: var(--primary-50, #f9f5ff);\n      }\n    }\n  }\n\n  .react-select__indicator-separator,\n  .react-select-multi__indicator-separator {\n    display: none;\n  }\n\n  .react-select-control,\n  .react-select-multi,\n  .react-select__control,\n  .react-select-multi__control {\n    min-height: 40px;\n    border: 1px solid var(--wf-base-400, #cbd2e0);\n    border-radius: 6px;\n\n    .react-select__placeholder,\n    .react-select-multi__placeholder {\n      opacity: 0.5;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%; /* 24px */\n      letter-spacing: -0.16px;\n      color: var(--secondary-on-surface, #98a2b3);\n    }\n  }\n\n  .react-select-control:hover,\n  .react-select__control:hover,\n  .react-select-multi-control:hover,\n  .react-select-multi__control:hover {\n    border: 1px solid var(--wf-base-400, #cbd2e0);\n    box-shadow: none;\n  }\n\n  .react-select__control.react-select__control-menu-is-open,\n  .react-select-multi__control.react-select-multi__control-menu-is-open {\n    border-radius: 6px 6px 0 0;\n    border: 1px solid var(--wf-base-400, #cbd2e0);\n    box-shadow: none;\n  }\n}\n\n.react-select__menu {\n  margin: 0;\n  border-radius: 0 0 6px 6px;\n  min-width: max-content;\n  width: 100%;\n  z-index: 99 !important;\n\n  .react-select__option {\n    position: relative;\n    background: var(--primary-50, #fff);\n    color: var(--secondary-dark, #101828);\n    font-feature-settings: 'calt' off;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    padding-left: 50px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 15px;\n      top: 9px;\n      width: 20px;\n      height: 20px;\n      border-radius: 100%;\n      border: 1px solid var(--secondary-base, #cbd2e0);\n      background: var(--On-Primary, #fff);\n    }\n\n    &.react-select__option--is-selected {\n      color: var(--secondary-dark, #101828);\n\n      &::before {\n        border: 1px solid var(--primary-600, #7f56d9);\n      }\n\n      &::after {\n        content: '';\n        border-radius: 100%;\n        width: 14px;\n        height: 14px;\n        position: absolute;\n        left: 19px;\n        top: 13px;\n        background: #7f56d9;\n      }\n    }\n\n    &:hover {\n      background: var(--primary-50, #f9f5ff);\n    }\n  }\n}\n\n.table_container {\n  width: max-content;\n  max-width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n\n  &:not(.sticky-table-clone) {\n    min-width: 100%;\n  }\n}\n\n.readOnly-td,\n.readOnly-td2 {\n  pointer-events: none !important;\n}\n\n.form-control-table {\n  overflow: visible !important;\n  border-radius: 8px;\n  background: var(--White, #fff);\n  border-collapse: separate;\n  box-shadow:\n    0 1px 2px 0 rgba(16, 24, 40, 0.06),\n    0 1px 3px 0 rgba(16, 24, 40, 0.1);\n  width: max-content;\n\n  thead {\n    th {\n      text-align: center;\n      white-space: pre;\n    }\n  }\n\n  .th-disabled {\n    pointer-events: none;\n  }\n\n  th {\n    background: var(--gray-50, #f9fafb);\n    color: var(--secondary-text, #667085);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    border-top: 1px solid #eaecf0;\n    border-bottom: 1px solid #eaecf0;\n    padding: 10px 4px;\n    white-space: nowrap;\n\n    &:first-child {\n      border-top-left-radius: 8px;\n      border-left: 1px solid #eaecf0;\n      padding-left: 10px;\n    }\n\n    &:last-child {\n      border-top-right-radius: 8px;\n      border-right: 1px solid #eaecf0;\n    }\n  }\n\n  td {\n    padding: 4px;\n    white-space: break-spaces;\n    vertical-align: middle;\n\n    &.current-user {\n      text-align: center;\n\n      .btn {\n        margin: 0 auto;\n      }\n    }\n\n    &:first-child {\n      border-left: 1px solid #eaecf0;\n      padding-left: 10px;\n    }\n\n    &:last-child {\n      border-right: 1px solid #eaecf0;\n    }\n  }\n\n  tr:last-child {\n    &:first-child {\n      border-top-left-radius: 8px;\n    }\n\n    &:last-child {\n      border-top-right-radius: 8px;\n    }\n  }\n\n  td,\n  th {\n    min-width: 10px;\n    color: var(--gray-900, #101828);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    will-change: width, max-width;\n\n    &.first-section {\n      text-align: left;\n      min-width: 130px;\n      vertical-align: middle;\n    }\n  }\n\n  .form-control {\n    height: 40px;\n    padding: 7px 7px 7px 12px;\n  }\n\n  tbody {\n    tr {\n      &.asAddNewRowButton {\n        position: relative;\n\n        td {\n          height: 10px;\n          overflow-x: visible;\n          border-top: 1px solid #eaecf0;\n          border-bottom: 1px solid #eaecf0;\n          background-color: var(--gray-50, #f9fafb);\n        }\n      }\n    }\n  }\n}\n\n.form-control-table-wrapper {\n  padding-bottom: 15px;\n  overflow-x: auto;\n\n  &.alignment {\n    &--center {\n      text-align: center;\n\n      .form-label {\n        text-align: center;\n      }\n\n      .form-control-table {\n        margin-left: auto;\n        margin-right: auto;\n      }\n    }\n\n    &--right {\n      text-align: right;\n\n      .form-label {\n        text-align: right;\n      }\n\n      .form-control-table {\n        margin-left: auto;\n      }\n    }\n  }\n}\n\n.form-control-table-alignment-wrapper {\n  width: 100%;\n\n  &.center {\n    text-align: center;\n  }\n\n  &.right {\n    text-align: right;\n  }\n}\n\n.form-readonly,\n.form-readonlyy,\n.readonly {\n  pointer-events: none !important;\n}\n\n.form-list {\n  color: var(--wf-base-800, #717d96);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.14px;\n  position: relative;\n  padding-left: 10px;\n  transition: all 0.25s ease;\n  list-style: inherit;\n  margin-left: 10px;\n}\n\n.form-control-file {\n  border: 1px solid var(--wf-base-400, #dadee4);\n  border-radius: 8px;\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  color: var(--wf-base-800, #2d3648);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: -0.14px;\n\n  &.form-control-file-default {\n    border-radius: var(--corner-radius-main, 8px);\n    border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n    background: var(--on-primary, #fff);\n    min-height: 131px;\n\n    .icon-icon-upload {\n      text-align: center;\n      margin: 0 auto;\n      display: block;\n      font-size: 24px;\n    }\n\n    span {\n      display: block;\n      text-align: center;\n      color: #7f56d9;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 24px; /* 171.429% */\n      letter-spacing: -0.14px;\n\n      &.sub-text {\n        color: var(--secondary-dark, #101828);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%; /* 21px */\n        letter-spacing: -0.14px;\n      }\n    }\n  }\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n  }\n}\n\n.form-control-file-attach {\n  border-radius: 6px;\n  min-height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  color: var(--wf-base-800, #2d3648);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: -0.14px;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    z-index: 1;\n  }\n}\n\n.form-label-alignment {\n  &-left {\n    .form-label {\n      text-align: left;\n    }\n  }\n\n  &-center {\n    .form-label,\n    .instructions,\n    .sigCanvas-wrapper,\n    .text-secondary,\n    .form-submitters {\n      text-align: center;\n      margin-left: auto;\n      margin-right: auto;\n    }\n\n    .form-control-star {\n      display: table !important;\n    }\n\n    .form-control,\n    .form-control-star,\n    .form-control-select,\n    .form-control-file {\n      margin-left: auto;\n      margin-right: auto;\n      display: block;\n      text-align: center;\n    }\n\n    .dropdown-input {\n      margin-left: auto;\n      margin-right: auto;\n      padding-left: 36px;\n    }\n  }\n\n  &-right {\n    .form-control,\n    .sigCanvas-wrapper,\n    .form-control-file,\n    .form-control-star,\n    .form-control-select {\n      margin-left: auto;\n      display: block;\n    }\n\n    .form-control-star {\n      display: table !important;\n    }\n\n    .form-label,\n    .instructions,\n    .text-secondary {\n      text-align: right;\n      margin-left: auto;\n    }\n\n    .dropdown-input {\n      margin-left: auto;\n    }\n  }\n}\n\n.form-control-table-responsive {\n  min-width: 100%;\n}\n\n.form-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -10px 16px;\n  box-shadow:\n    0 1px 2px 0 rgba(16, 24, 40, 0.06),\n    0px 1px 3px 0px rgba(16, 24, 40, 0.1);\n  border-radius: var(--corner-radius-main, 8px);\n  border-left: 4px solid var(--primary-100, #f4ebff);\n  background: var(--on-primary, #fff);\n  padding: 16px 10px;\n\n  .form-wrapper-title {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n    color: var(--secondary-text, #667085);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.16px;\n    display: flex;\n    align-items: center;\n    padding: 0 10px;\n    margin-bottom: 16px;\n\n    img {\n      margin-right: 10px;\n    }\n  }\n\n  .form-item {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n    padding: 0 10px;\n    margin-bottom: 24px;\n    position: relative;\n\n    &.form-item-select {\n      .danger-icon {\n        right: 43px;\n      }\n    }\n\n    &.form-item-mail {\n      .mail-icon {\n        position: absolute;\n        top: 36px;\n        left: 23px;\n      }\n\n      .form-control {\n        padding: 12px 12px 12px 43px;\n      }\n    }\n\n    .remove-icon {\n      position: absolute;\n      top: 38px;\n      right: 23px;\n      z-index: 2;\n      cursor: pointer;\n    }\n\n    .danger-icon {\n      position: absolute;\n      top: 35px;\n      right: 23px;\n      opacity: 0;\n      z-index: 2;\n    }\n\n    &-error {\n      .form-control {\n        border-color: #b42318;\n        padding: 12px 43px 12px 16px;\n      }\n\n      &.form-item-select {\n        .form-control-select .react-select__control,\n        .form-control-select .react-select-multi__control {\n          border-color: #b42318;\n        }\n      }\n\n      &.form-item-mail {\n        .form-control {\n          padding: 12px 43px 12px 43px;\n        }\n      }\n\n      .danger-icon {\n        opacity: 1;\n      }\n\n      .form-error {\n        color: #b42318;\n      }\n    }\n\n    &-half {\n      flex: 0 0 50%;\n      max-width: 50%;\n      width: 50%;\n    }\n\n    &.form-item-75 {\n      flex: 0 0 75%;\n      max-width: 75%;\n      width: 75%;\n    }\n\n    &.form-item-25 {\n      flex: 0 0 25%;\n      max-width: 25%;\n      width: 25%;\n    }\n  }\n}\n\n.add-facility {\n  color: var(--primary-600, #7f56d9);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  display: table;\n  cursor: pointer;\n  padding: 10px 0;\n\n  i:before {\n    font-weight: 700;\n    font-size: 16px;\n  }\n}\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.date-piker-wrapper {\n  position: relative;\n\n  .date-piker-icon {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    z-index: 2;\n    font-size: 24px;\n    color: #a0abc0;\n  }\n}\n\n.file-tab {\n  .file-list {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 16px;\n    column-gap: 20px;\n\n    li {\n      max-width: calc(25% - 15px);\n      width: calc(25% - 15px);\n    }\n  }\n}\n\n.file-list {\n  li {\n    display: flex;\n    color: var(--gray-700, #344054);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    border-radius: 8px;\n    border: 1px solid var(--gray-200, #eaecf0);\n    background: var(--white, #fff);\n    padding: 16px;\n    margin-bottom: 16px;\n    justify-content: space-between;\n\n    .d-flex,\n    p {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: 100%;\n    }\n\n    img {\n      margin-right: 10px;\n    }\n  }\n\n  .btn.btn-icon {\n    box-shadow: none;\n\n    i {\n      font-size: 20px;\n\n      &::before {\n        color: var(--gray-700, #344054);\n      }\n    }\n  }\n\n  .icon-remove {\n    margin-left: 10px;\n  }\n\n  .icon-icon-file {\n    margin-right: 10px;\n  }\n}\n\n.form-error {\n  color: #b42318;\n  font-size: 12px;\n}\n\n.select-placeholder {\n  display: none;\n}\n\n.form-control-item-settings {\n  margin-bottom: 28px;\n\n  .select-multy-wrapper {\n    position: relative;\n\n    .select-placeholder {\n      position: absolute;\n      top: 10px;\n      left: 15px;\n      z-index: 2;\n      pointer-events: none;\n      color: #a0abc0;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      letter-spacing: -0.16px;\n      display: none;\n    }\n  }\n\n  .css-3w2yfm-ValueContainer {\n    height: 44px;\n    position: relative;\n\n    & .css-1p3m7a8-multiValue {\n      display: none;\n    }\n  }\n\n  p {\n    color: var(--wf-base-800, #2d3648);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.16px;\n    margin: 20px 0 16px 0;\n  }\n\n  ul {\n    display: block;\n    margin-top: 20px;\n\n    &.individual-users-list {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n      max-height: 200px;\n      overflow-y: auto;\n      scrollbar-width: thin;\n      scrollbar-color: rgba(0, 0, 0, 0.1);\n\n      &::-webkit-scrollbar {\n        width: 7px;\n      }\n\n      &::-webkit-scrollbar-track {\n        border-radius: 40px;\n        border: 1px solid #fff;\n        background: rgba(0, 0, 0, 0.1);\n      }\n\n      &::-webkit-scrollbar-thumb {\n        border-radius: 40px;\n        border: 1px solid #fff;\n        background: rgba(0, 0, 0, 0.1);\n      }\n\n      li {\n        flex: 0 0 calc(50% - 5px);\n        max-width: calc(50% - 5px);\n        width: calc(50% - 5px);\n      }\n    }\n\n    li {\n      display: inline-flex;\n      align-items: center;\n      color: var(--secondary-dark, #101828);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      margin-bottom: 10px;\n\n      .avatar {\n        margin-right: 8px;\n      }\n\n      img {\n        width: 20px;\n        height: 20px;\n        margin-right: 12px;\n      }\n\n      .btn-icon {\n        margin-left: 10px;\n\n        i::before {\n          color: #ffb8b8;\n        }\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n.form-control-monthly_fee {\n  position: relative;\n  z-index: 1;\n\n  &::before {\n    position: absolute;\n    z-index: 2;\n    content: '$';\n    top: 3px;\n    left: 15px;\n    color: rgba(45, 54, 72, 0.5);\n  }\n\n  .form-control {\n    padding-left: 30px;\n  }\n}\n\n.folder-select {\n  position: relative;\n\n  &.folder-select-disable {\n    pointer-events: none;\n\n    .folder-select-input {\n      background-color: hsl(0, 0%, 95%);\n    }\n  }\n\n  .folder-select-input {\n    border-radius: 6px;\n    border: 1px solid var(--wf-base-400, #cbd2e0);\n    background: var(--wf-base-white, #fff);\n    height: 44px;\n    padding: 12px 12px 12px 16px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 130%;\n    letter-spacing: -0.14px;\n    color: #2d3648;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n\n    &-placeholder {\n      color: #717d96;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 130%; /* 24px */\n      letter-spacing: -0.16px;\n    }\n  }\n\n  .folder-select-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    max-height: 440px;\n    overflow-y: auto;\n    border-radius: 8px;\n    background: #fff;\n    overscroll-behavior: contain;\n    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);\n    padding: 16px 0;\n    z-index: 9;\n  }\n\n  .folder-select-ul {\n    margin-top: 0;\n\n    li {\n      display: block;\n      position: relative;\n\n      &:last-child {\n        & > span {\n          margin-bottom: 0;\n        }\n      }\n\n      ul {\n        padding-left: 35px;\n      }\n\n      & > span {\n        display: flex;\n        align-items: center;\n        padding: 10px 16px 10px 50px;\n        margin-bottom: 8px;\n\n        &:hover {\n          background: #f9f5ff;\n        }\n\n        &::before {\n          content: '';\n          border-radius: 100%;\n          position: absolute;\n          left: 16px;\n          top: 10px;\n          width: 20px;\n          height: 20px;\n          border: 1px solid var(--secondary-base, #cbd2e0);\n        }\n\n        &::after {\n          content: '';\n          border-radius: 100%;\n          position: absolute;\n          left: 22px;\n          top: 16px;\n          width: 10px;\n          height: 10px;\n          background: #7f56d9;\n          transform: scale(0);\n          transition: all 0.25s ease;\n        }\n\n        svg {\n          margin-right: 8px;\n        }\n      }\n\n      &.active-folder > span {\n        &::after {\n          transform: scale(1);\n        }\n\n        &::before {\n          border: 1px solid var(--secondary-base, #7f56d9);\n        }\n      }\n    }\n  }\n\n  .folder-select-ul-inner {\n    margin-top: 0;\n  }\n}\n\n.form-item {\n  .text-secondary {\n    display: block;\n  }\n}\n\n.input-clear {\n  position: relative;\n\n  .form-control {\n    padding-right: 50px;\n  }\n\n  .btn.btn-icon {\n    position: absolute;\n    top: 12px;\n    right: 15px;\n    z-index: 2;\n  }\n}\n\n.number-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding-top: 10px;\n\n  .btn-outline {\n    svg {\n      width: 21px;\n      height: 21px;\n    }\n  }\n\n  .btn {\n    flex: 0 0 calc(33.333333% - 7px);\n    max-width: calc(33.333333% - 7px);\n    width: calc(33.333333% - 7px);\n  }\n}\n\n.number-wrapper-action {\n  display: flex;\n  gap: 10px;\n  padding-top: 10px;\n\n  .btn {\n    flex: 0 0 calc(50% - 5px);\n    max-width: calc(50% - 5px);\n    width: calc(50% - 5px);\n  }\n}\n\n.form-control {\n  &.multiline {\n    min-height: 40px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    font-family: Arial, sans-serif;\n    pointer-events: initial !important;\n\n    &::placeholder {\n      font-size: 16px;\n    }\n  }\n}\n",".mr-2 {\n  margin-right: 8px;\n}\n\n.mr-4 {\n  margin-right: 16px;\n}\n\n.mb-4 {\n  margin-bottom: 15px;\n}\n\n.mt-4 {\n  margin-top: 28px;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.mb-6 {\n  margin-bottom: 28px;\n}\n\n.fw-bolder {\n  font-weight: bolder;\n}\n\n.fw-bold {\n  font-weight: bold;\n}\n\n.scrollbar {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 12px;\n  }\n\n  &::-webkit-scrollbar-track {\n    border-radius: 40px;\n    border: 1px solid #fff;\n    background: rgba(0, 0, 0, 0.1);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 40px;\n    border: 1px solid #fff;\n    background: rgba(0, 0, 0, 0.1);\n  }\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.pt-6 {\n  padding-top: 32px !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 6px;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-half {\n  width: 50%;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.mr-auto {\n  margin-right: auto;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.mr-a {\n  margin-left: auto;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.d-flex {\n  display: flex;\n  align-items: center;\n}\n\n.gap-1 {\n  gap: 4px;\n}\n\n.gap-2 {\n  gap: 8px;\n}\n\n.gap-3 {\n  gap: 12px;\n}\n\n.gap-4 {\n  gap: 16px;\n}\n\n.justify-content-space-between {\n  justify-content: space-between;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.disabled-link {\n  pointer-events: none;\n\n  * {\n    pointer-events: none;\n  }\n}\n\n.bt-1 {\n  background: #cbd2e0;\n  width: 100%;\n  display: block;\n  height: 1px;\n  margin-bottom: 24px;\n}\n\n.flex-column {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.text-secondary {\n  color: var(--secondary-text, #667085);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 21px */\n  letter-spacing: -0.14px;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.mt-2 {\n  margin-top: 16px;\n}\n\n.mt-4 {\n  margin-top: 30px;\n}\n\n.mb-2 {\n  margin-bottom: 16px !important;\n}\n\n.mb-1 {\n  margin-bottom: 8px;\n}\n\n.pt-5 {\n  padding-top: 26px !important;\n}\n\n.ml-2 {\n  margin-left: 6px;\n}\n\n.ml-3 {\n  margin-left: 8px;\n}\n\n.react-tooltip {\n  max-width: 350px;\n  z-index: 99;\n  border-radius: 6px;\n  background: var(--on-primary, #fff) !important;\n  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1) !important;\n  color: var(--secondary-dark, #101828) !important;\n  opacity: 0;\n  padding: 16px !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 21px */\n  letter-spacing: -0.14px;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.z-index {\n  z-index: 2;\n}\n\n.z-index-10 {\n  position: relative;\n  z-index: 10;\n}\n\n.react-tooltip-arrow {\n  display: none !important;\n}\n\n.justify-space-between {\n  justify-content: space-between;\n}\n\n.flex-start {\n  align-items: flex-start;\n}\n\n.flex-center {\n  align-items: center;\n}\n\n.no-wrap {\n  white-space: nowrap;\n}\n\n.ml-4 {\n  margin-left: 16px;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.ml-0 {\n  margin-left: 0 !important;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.breadcrumbs-item-last {\n  pointer-events: none;\n}\n\n.pointer-none {\n  pointer-events: none;\n}\n\n.opacity-50 {\n  opacity: 0.5;\n}\n\n.pt-4 {\n  padding-top: 6px !important;\n}\n",".ql-font-arial {\n  font-family: 'Arial';\n}\n\n.ql-font-times-new-roman {\n  font-family: 'Times New Roman';\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=arial]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=arial]::before {\n  content: 'Arial';\n  font-family: 'Arial';\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=times-new-roman]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=times-new-roman]::before {\n  content: 'Times New Roman';\n  font-family: 'Times New Roman';\n}\n\n.ql-picker-label.ql-active {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quill .ql-snow .ql-picker.ql-font {\n  width: 138px;\n}\n\n.ql-container.ql-snow {\n  min-height: 150px;\n  border: 1px solid var(--wf-base-400, #CBD2E0);\n  border-radius: 0 0 6px 6px;\n}\n\n.ql-editor.ql-blank {\n  min-height: 150px;\n}\n\n.ql-toolbar.ql-snow {\n  border: 1px solid var(--wf-base-400, #CBD2E0);\n  border-radius: 6px 6px 0 0;\n}\n\n.quill .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,\n.quill .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n  content: '10px';\n}\n\n.quill .ql-snow .ql-picker.ql-size .ql-picker-label::before,\n.quill .ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: '14px';\n}\n\n.quill .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,\n.quill .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n  content: '20px';\n}\n\n.quill .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,\n.quill .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n  content: '32px';\n}\n\n.html-area {\n  ul {\n    list-style: inherit;\n    margin-block-end: 16px;\n    margin-block-start: 16px;\n    padding-inline-start: 40px;\n  }\n\n  ol {\n    list-style: decimal;\n    margin-block-end: 16px;\n    margin-block-start: 16px;\n    padding-inline-start: 40px;\n  }\n\n  font-size: 14px;\n\n  .ql-size-huge {\n    font-size: 32px;\n  }\n\n  .ql-size-large {\n    font-size: 20px;\n  }\n\n  .ql-size-small {\n    font-size: 10px;\n  }\n\n  .ql-align-right {\n    text-align: right;\n  }\n\n  .ql-align-center {\n    text-align: center;\n  }\n\n  .ql-align-justify {\n    text-align: justify;\n  }\n}\n\n.quill {\n  &.hidden {\n    .ql-toolbar {\n      display: none;\n    }\n    .ql-container {\n      border: 0;\n    }\n  }\n}",".library {\n  padding: 40px 30px;\n  width: 100%;\n  background: #fff;\n\n  &.library-available-to-me {\n    padding-bottom: 100px;\n  }\n\n  .library--header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n\n  &.library-attach {\n    .library-item-button {\n      display: none;\n    }\n  }\n\n  &-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: 16px;\n    margin: 0 -8px;\n  }\n\n  &-title {\n    color: var(--secondary-eading, #101828);\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n  }\n\n  .breadcrumbs-item {\n    color: var(--secondary-text, #667085);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px\n  }\n\n  &-subtitle {\n    color: var(--secondary-text, #667085);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    margin-bottom: 16px;\n  }\n\n  .total {\n    color: var(--primary-600, #7F56D9);\n    text-align: center;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px\n  }\n\n  .library-item-button {\n    margin-right: 16px;\n    position: relative;\n\n    &.library-item-button-open {\n      z-index: 9;\n    }\n  }\n\n  .library-item-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: min-content;\n    border-radius: 8px;\n    background: #FFF;\n    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.10);\n\n    &.file {\n      width: 144px;\n    }\n\n    .btn {\n      color: var(--secondary-eading, #101828);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px;\n      padding: 10px 16px;\n      height: auto;\n      text-align: left;\n      background: transparent;\n      border: 0;\n      box-shadow: none;\n      display: flex;\n      align-items: center;\n\n      &.btn-remove {\n        color: var(--tertiary-600, #B42318);\n\n        i::before {\n          color: var(--tertiary-600, #B42318);\n        }\n      }\n\n      &.btn-active {\n        color: rgb(18, 183, 106);\n\n        i::before {\n          color: rgb(18, 183, 106);\n        }\n      }\n\n      i {\n        margin-right: 8px;\n      }\n\n      i::before {\n        color: var(--secondary-eading, #101828);\n      }\n    }\n  }\n\n  &-item {\n    max-width: calc(20% - 16px);\n    width: 100%;\n    flex: 0 0 100%;\n    display: flex;\n    margin: 0 8px;\n    //padding-right: 16px;\n    color: var(--secondary-eading, #101828);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n    border-radius: 8px;\n    position: relative;\n    border: 1px solid var(--secondary-input-outline, #DADEE4);\n    background: var(--On-Primary, #FFF);\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n\n    &.list-item {\n      width: 100%;\n      max-width: initial;\n      margin: 0;\n      padding: 6px 20px;\n      border: 0;\n      border-radius: 0;\n      border-bottom: 1px solid var(--Secondary-Input-Outline, #DADEE4);\n\n      .library-item-text {\n        display: flex;\n        padding: 0;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 16px;\n        align-items: center;\n      }\n\n      .library-item__name {\n        width: 100%;\n      }\n\n      .library-item-button {\n        margin: 0;\n\n        .library-item-menu-button {\n          width: 32px;\n          height: 32px;\n        }\n      }\n\n      .library-item-date {\n        width: auto;\n        border: none;\n        margin-top: 0;\n        padding-top: 0;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 20px;\n        color: #667085;\n      }\n    }\n\n    &:nth-child(5n) {\n      .library-item-menu {\n        left: auto;\n        right: 0;\n      }\n    }\n\n    &-disabled {\n      cursor: not-allowed;\n    }\n\n    .forms-count {\n      top: -10px;\n      right: -10px;\n      width: 20px;\n      height: 20px;\n      display: inline-flex;\n      position: absolute;\n      border-radius: 50%;\n      color: #ffffff;\n      font-size: 12px;\n      align-items: center;\n      justify-content: center;\n      background: var(--Tertiary-500, #d92d20);\n      z-index: 9;\n    }\n\n    .library-item-date {\n      width: 100%;\n      margin-top: 10px;\n      padding-top: 10px;\n      border-top: 1px solid var(--secondary-input-outline, #DADEE4);\n\n      .value {\n        margin-left: 4px;\n      }\n    }\n\n    .library-item-text {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      padding: 16px;\n      width: 100%;\n    }\n\n    .btn {\n      i {\n        margin-right: 0;\n      }\n\n      &.btn-small {\n        width: 40px;\n        height: 40px;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    i {\n      margin-right: 10px;\n    }\n  }\n\n  &-filters {\n    display: flex;\n    align-items: flex-end;\n    margin-bottom: 29px;\n\n    justify-content: space-between;\n\n    .form-item {\n      max-width: 237px;\n      width: 100%;\n    }\n\n    &-wrapper {\n      display: flex;\n      align-items: center;\n      column-gap: 16px;\n      width: 100%;\n      padding-right: 16px;\n    }\n  }\n\n  &-filter {\n    display: flex;\n    align-items: center;\n    margin-bottom: 29px;\n    margin-top: 29px;\n\n    &-search {\n      flex: 1 0 0;\n      margin-bottom: 0;\n    }\n\n    .btn {\n      margin-left: 16px;\n\n      &-outline {\n        padding: 8px 12px 6px;\n        border: 1px solid #CBD2E0;\n        color: var(--primary-600, #7F56D9);\n        font-size: 16px;\n\n        i::before {\n          color: var(--primary-600, #7F56D9);\n        }\n      }\n    }\n  }\n}\n\n.is-disabled {\n  color: #B42318;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 21px */\n  letter-spacing: -0.14px;\n  display: block;\n  padding: 16px 28px 0;\n  margin-bottom: -10px;\n}\n\n.render-form-disabled {\n  .from-builder-title,\n  .form-builder-element-preview {\n    filter: grayscale(100%);\n    pointer-events: none !important;\n  }\n}\n\n.breadcrumbs {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n\n  &-item {\n    color: #2D3648;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 140%;\n    position: relative;\n    margin-right: 48px;\n\n    &:last-child {\n      &::after {\n        display: none;\n      }\n    }\n\n    &::after {\n      content: '';\n      display: block;\n      width: 24px;\n      height: 24px;\n      position: absolute;\n      left: calc(100% + 12px);\n      top: 0;\n      background-image: url(\"../../images/arrow-right.svg\");\n      background-repeat: no-repeat;\n      background-position: center center;\n    }\n  }\n}\n\n.react-tabs {\n  width: 100%;\n\n  &__tab-panel {\n    padding: 24px 0;\n    display: none;\n\n    &--selected {\n      display: block;\n    }\n  }\n\n  &__tab {\n    padding: 16px 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    text-align: center;\n    color: var(--secondary-eading, #101828);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    flex: 1 0 auto;\n    position: relative;\n    cursor: pointer;\n\n    &-list {\n      display: flex;\n      align-items: center;\n    }\n\n    &::after {\n      content: '';\n      width: 100%;\n      height: 2px;\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%) scale(0);\n      background: var(--wf-base-800, #6941C6);\n      transition: all 0.25s ease;\n    }\n\n    &--selected {\n      color: var(--primary-700, #6941C6);\n      background: transparent;\n\n      &::after {\n        transform: translateX(-50%) scale(1);\n      }\n    }\n  }\n}\n\n.tab__error:before {\n  font-size: 20px;\n  margin-left: 10px;\n  color: var(--tertiary-500, #ef5350) !important;\n}\n\n.no-result {\n  text-align: center;\n  font-size: 18px;\n  padding: 28px 0;\n}\n\n.folder-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 15px;\n}\n\n.notifications {\n  width: 100%;\n  padding: 40px;\n\n  .notifications-title {\n    color: var(--Secondary-eading, #101828);\n    /* H2 */\n    font-family: Inter;\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n    margin-bottom: 40px;\n\n    span {\n      color: var(--Tertiary-500, #D92D20);\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 16px;\n    }\n  }\n\n  .form-control-checkbox {\n    margin-bottom: 0;\n  }\n\n  .table-default .th-checkbox {\n    width: 49px;\n  }\n\n  .table-default .th {\n    //padding: 12px;\n    vertical-align: middle;\n  }\n\n  .td:last-child {\n    text-align: right;\n  }\n\n  .table-default {\n    .tr:hover {\n      .td {\n        a {\n          opacity: 1;\n        }\n      }\n    }\n\n    .tr.tr-disabled {\n      .th {\n        border-bottom: var(--outline, 1px) solid var(--Gray-200, #EAECF0);\n        background: var(--Gray-50, #F9FAFB);\n        opacity: 0.5;\n        pointer-events: none;\n        filter: grayscale(100%);\n      }\n    }\n\n    .tr.tr-is-read {\n      .td {\n        border-bottom: var(--outline, 1px) solid var(--Gray-200, #EAECF0);\n        opacity: var(--outline, 1);\n        background: var(--Secondary-surface, #F9FAFB);\n        color: var(--Secondary-Text, #667085);\n        /* Input Label */\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 16px;\n      }\n    }\n\n    .th {\n      color: var(--Secondary-eading, #101828);\n      /* Input Label */\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 16px;\n    }\n\n    .td {\n      color: var(--Secondary-eading, #101828);\n      /* Input Label */\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 16px;\n\n      a {\n        color: var(--Primary-600, #7F56D9);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px; /* 171.429% */\n        text-decoration-line: underline;\n        opacity: 0;\n        white-space: nowrap;\n      }\n    }\n  }\n\n\n  .th-actions {\n    width: 253px;\n    padding: 12px !important;\n\n    .btn {\n      display: inline-flex;\n      align-items: center;\n    }\n  }\n}\n\n.header-right {\n  display: flex;\n\n  &__main {\n    display: inline-flex;\n    align-items: center;\n  }\n}\n\n.btn.btn-notification {\n  padding: 10px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 16px;\n  position: relative;\n\n  .counter {\n    position: absolute;\n    top: 2px;\n    left: 20px;\n    background: var(--Tertiary-500, #D92D20);\n    border-radius: 50px;\n    color: #FFF;\n    font-family: Inter;\n    font-size: 9px;\n    font-style: normal;\n    font-weight: 900;\n    line-height: 10px;\n    min-width: 17px;\n    min-height: 17px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &.btn-notification-active {\n    border-radius: 8px;\n    border: 1px solid var(--Primary-300, #D6BBFB);\n    background: var(--Primary-100, #F4EBFF);\n    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n\n    svg {\n      path {\n        stroke: #7F56D9;\n      }\n    }\n  }\n\n  svg {\n    path {\n      stroke: #98A2B3;\n    }\n  }\n}",".login-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n\n  &-wrapper {\n    max-width: 450px;\n    width: 100%;\n    padding-top: 40px;\n  }\n\n  .login-padding {\n    padding-top: 143px;\n  }\n\n  .form-title {\n    margin-bottom: 32px;\n    h2 {\n      color: var(--secondary-eading, #101828);\n      font-size: 25px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 150%;\n      margin-bottom: 12px;\n      text-align: center;\n    }\n\n    p {\n      color: var(--secondary-text, #667085);\n      text-align: center;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 21px;\n      margin-bottom: 0;\n    }\n  }\n  .btn.btn-full {\n    padding: 17px;\n  }\n\n  .info {\n    color: var(--secondary-on-surface, #98A2B3);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n\n  .login-bottom {\n    border-top: 1px solid #EAECF0;\n    margin-top: 32px;\n    padding-top: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    &.login-bottom-center {\n      justify-content: center;\n    }\n\n    p {\n      color: var(--secondary-text, #667085);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      margin-bottom: 0;\n    }\n\n    a {\n      color: var(--primary-700, #6941C6);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px;\n      text-decoration: none;\n    }\n  }\n  a {\n    color: var(--primary-700, #6941C6);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    text-decoration: none;\n  }\n\n  .link-forgot {\n    text-align: right;\n    margin-left: auto;\n    display: table;\n    margin-bottom: 24px;\n  }\n\n  .form-control-item-login {\n    position: relative;\n  }\n\n  .back-to {\n    display: flex;\n    align-items: center;\n\n    svg {\n      margin-right: 10px;\n    }\n  }\n\n  .show-password {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n  }\n\n  .icon-login {\n    position: absolute;\n    top: 10px;\n    left: 15px;\n  }\n\n  .form-control {\n    padding: 12px 45px\n  }\n  .form-control-default {\n    padding: 12px 16px;\n  }\n\n}",".table-default {\n  .th {\n    color: var(--secondary-eading, #101828);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    text-align: left;\n    background: #F9FAFB;\n    padding: 12px;\n    display: table-cell;\n    border-bottom: 1px solid var(--divider, #EAECF0);\n\n    &.th-center {\n      text-align: center;\n    }\n\n    &.th-big {\n      width: 100%;\n    }\n\n    & .th-total {\n      margin-left: 7px;\n      color: var(--primary-600, #7F56D9);\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 18px;\n    }\n\n    &:first-child {\n      border-radius: 8px 0 0 0;\n    }\n\n    &:last-child {\n      border-radius: 0 8px 0 0;\n    }\n  }\n\n  .td {\n    padding: 16px 24px;\n    border-bottom: 1px solid var(--divider, #EAECF0);\n    display: table-cell;\n    color: var(--secondary-text, #667085);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.16px;\n    vertical-align: middle;\n\n\n    @media screen and (min-width: 1300px) {\n      &.td-action {\n        min-width: 500px;\n      }\n      &.td-name {\n        width: 270px;\n      }\n\n      &.td-facility {\n        width: 270px;\n      }\n    }\n    @media screen and (max-width: 1300px) {\n      &.td-action {\n        min-width: 250px;\n      }\n\n      &.td-name {\n        min-width: 150px;\n      }\n\n      &.td-facility {\n        min-width: 150px;\n      }\n    }\n\n    &.td-center {\n      text-align: center;\n    }\n    &.td-actions {\n      .d-flex {\n        justify-content: flex-end;\n      }\n\n      .btn-icon {\n        width: 40px;\n        height: 40px;\n        display: inline-flex;\n        justify-content: center;\n        align-content: center;\n        transition: all 0.25s ease;\n        opacity: 0;\n\n        i::before {\n          color: #667085;\n        }\n      }\n    }\n\n    &.td-center {\n      text-align: center;\n    }\n\n    &.td-big {\n      width: 30%;\n    }\n\n    strong {\n      color: var(--secondary-dark, #101828);\n      font-weight: 500;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .tr-deactivated {\n    .td {\n      background: var(--secondary-surface, #F9FAFB);\n      color: var(--secondary-base, #CBD2E0);\n\n      strong {\n        color: var(--secondary-text, #667085);\n      }\n    }\n\n  }\n\n  .tr-full {\n    display: block;\n  }\n\n  .table {\n    display: table;\n  }\n\n  .table-wrapper {\n    border: 1px solid var(--divider, #EAECF0);\n    box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.10);\n    border-radius: 8px;\n    background: #FFF;\n  }\n\n  .thead {\n    display: table-header-group;\n  }\n\n  .tbody {\n    display: table-row-group;\n  }\n\n  .tr {\n    display: table-row;\n\n    &.tr-active {\n      .td {\n        background: var(--primary-50, #F9F5FF);\n      }\n    }\n\n    &:hover {\n      .td {\n        background: var(--primary-50, #F9F5FF);\n        &.td-actions {\n          .btn {\n            opacity: 1;\n          }\n        }\n      }\n    }\n\n  }\n\n  .th-checkbox,\n  .td-checkbox {\n    width: 60px;\n    position: relative;\n\n    .form-control-checkbox {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n\n      span {\n        width: 20px;\n        height: 20px;\n        padding: 0;\n      }\n    }\n  }\n\n  .form-control-checkbox {\n    span {\n      display: block;\n\n      &::before {\n        border: 1px solid var(--wf-base-800, #CBD2E0);\n        background: #fff;\n      }\n    }\n\n    input:checked + span::before {\n      border: 1px solid var(--wf-base-800, #2D3648);\n    }\n\n    input:checked + span::after {\n      left: 4px;\n    }\n  }\n}\n\n.table-border {\n  .table {\n    border: 1px solid #CBD2E0;\n    border-radius: 10px;\n  }\n\n  .th {\n    padding: 14px 20px;\n\n    &:first-child {\n      border-radius: 10px 0 0 0;\n    }\n\n    &:last-child {\n      border-radius: 0 10px 0 0;\n    }\n  }\n\n  .tr:last-child {\n    .td {\n      border: 0;\n    }\n  }\n}\n\n.table-responsive {\n  overflow-x: auto;\n  overflow-y: visible;\n  max-width: 100%;\n  padding: 0 0 15px;\n  width: 100%;\n}\n\n.table-full {\n  .table {\n    width: 100%;\n  }\n}",".ReactModal__Overlay {\n  z-index: 999;\n  position: fixed;\n  inset: 0px;\n  padding-top: 90px;\n  padding-bottom: 40px;\n  background: rgba(0, 0, 0, 0.3) !important;\n  overflow-y: auto;\n\n  .modal-default {\n    width: 100%;\n    max-width: 640px;\n    //max-height: calc(100vh - 48px);\n    padding: 32px 32px 0;\n    margin: 0 auto;\n    border-radius: 8px;\n    background: var(--secondary-surface, #f9fafb);\n    position: relative;\n\n    &.modal-no-footer {\n      padding-bottom: 32px;\n    }\n\n    .group {\n      padding: 18px;\n      border-radius: 8px;\n      border-left: 4px solid #f4ebff;\n      background-color: #ffffff;\n      box-shadow: 0px 1px 3px 0px #1018281a;\n\n      &__title {\n        display: inline-flex;\n        gap: 8px;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        align-items: center;\n        color: var(--Secondary-Text, #667085);\n      }\n\n      &__body {\n        margin-top: 16px;\n      }\n    }\n  }\n\n  .modal-sms {\n    max-width: 740px;\n\n    .w-full {\n      display: flex;\n      flex-wrap: wrap;\n      column-gap: 10px;\n    }\n\n    .form-control-item {\n      flex: 0 0 100%;\n      max-width: 100%;\n      width: 100%;\n\n      &.w-50 {\n        @media screen and (min-width: 740px) {\n          flex: 0 0 calc(50% - 10px);\n          max-width: calc(50% - 10px);\n          width: calc(50% - 10px);\n        }\n      }\n    }\n  }\n\n  .modal-alert {\n    max-width: 462px;\n    padding: 32px 32px 0;\n    border-radius: var(--Corner-radius-main, 8px);\n    background: var(--On-Primary, #fff);\n    box-shadow:\n      0 8px 8px -4px rgba(16, 24, 40, 0.03),\n      0px 20px 24px -4px rgba(16, 24, 40, 0.08);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    &.without-footer {\n      padding: 32px;\n    }\n\n    h3 {\n      color: var(--secondary-dark, #101828);\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n      margin-bottom: 8px;\n    }\n\n    p {\n      color: var(--secondary-text, #667085);\n      font-feature-settings: 'calt' off;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%; /* 24px */\n      letter-spacing: -0.16px;\n    }\n\n    .modal-footer {\n      border-top: 0;\n    }\n  }\n\n  .modal-subheader {\n    color: var(--secondary-dark, #101828);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 21px */\n    letter-spacing: -0.14px;\n    margin-bottom: 29px;\n    margin-top: -28px;\n  }\n\n  .modal-header {\n    color: #2d3648;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 140%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 32px;\n\n    .btn.btn-icon {\n      box-shadow: none;\n    }\n  }\n\n  .modal-footer {\n    display: flex;\n    margin-top: 32px;\n    margin-left: -32px;\n    margin-right: -32px;\n    align-items: center;\n    justify-content: space-between;\n    background: var(--on-primary, #fff);\n    border-top: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n    padding: 32px;\n  }\n\n  .icon-icon-x {\n    font-size: 24px;\n  }\n}\n",".modal-export {\n  .library-wrapper {\n    max-height: 450px;\n    overflow-y: auto;\n  }\n\n  .table-wrapper {\n    max-height: 450px;\n    overflow-y: auto;\n  }\n}\n.company-profile {\n  &-header {\n    display: flex;\n    margin-bottom: 32px;\n    justify-content: space-between;\n\n    &-action {\n      display: flex;\n      align-items: center;\n\n      .btn {\n        margin-left: 16px;\n      }\n    }\n  }\n  &-title {\n    color: var(--wf-base-800, #2d3648);\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 130%;\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n\n    .facility-title {\n      color: var(--gray-900, #101828);\n      margin-left: 14px;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n    }\n  }\n\n  .date-add {\n    color: rgba(45, 54, 72, 0.5);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.16px;\n  }\n\n  &-subtitle {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    letter-spacing: -0.16px;\n\n    .text-secondary {\n      color: rgba(45, 54, 72, 0.5);\n    }\n  }\n  &-secondary-text {\n    color: var(--secondary-text, #667085);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin-bottom: 8px;\n  }\n  &-content {\n    display: flex;\n    flex-wrap: wrap;\n    padding-bottom: 32px;\n  }\n\n  .empty-page {\n    margin-top: 0;\n  }\n\n  &-facilities-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n\n    &.company-profile-user-group-grid {\n      grid-row-gap: 0;\n      grid-column-gap: 20px;\n      grid-template-columns: repeat(5, 1fr);\n      grid-template-rows: repeat(10, min-content);\n      grid-auto-flow: column;\n\n      .company-profile-facilities-item {\n        margin-bottom: 20px;\n      }\n    }\n\n    @media screen and (min-width: $breakpoint-xxl) {\n      grid-template-columns: repeat(4, 1fr);\n    }\n\n    @media screen and (max-width: $breakpoint-lg) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media screen and (max-width: $breakpoint-md) {\n      grid-template-columns: repeat(1, 1fr);\n    }\n\n    grid-gap: 20px;\n  }\n\n  &-tab {\n    .company-profile-title {\n      color: var(--wf-base-800, #2d3648);\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 140%;\n      margin-bottom: 24px;\n    }\n  }\n\n  &-facilities-item {\n    border-radius: 10px;\n    border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n    background: var(--on-primary, #fff);\n    //box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.10);\n    padding: 20px;\n\n    .btn {\n      padding: 10px;\n    }\n\n    .title {\n      color: var(--primary-600, #7f56d9);\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n    }\n\n    .sub-title {\n      color: var(--secondary-eading, #101828);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 20px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-right: 10px;\n    }\n\n    .subtitle {\n      color: var(--secondary-on-surface, #98a2b3);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 22px; /* 157.143% */\n      letter-spacing: -0.25px;\n      margin-bottom: 24px;\n    }\n\n    table {\n      td {\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        letter-spacing: -0.14px;\n        padding: 5px 0;\n\n        &:first-child {\n          color: rgba(45, 54, 72, 0.5);\n          padding-right: 20px;\n        }\n\n        &:last-child {\n          color: var(--wf-base-800, #2d3648);\n        }\n      }\n    }\n\n    &-disabled {\n      box-shadow:\n        0 1px 2px 0 rgba(16, 24, 40, 0.06),\n        0 1px 3px 0 rgba(16, 24, 40, 0.1);\n      background: var(--secondary-surface, #f9fafb);\n      border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n\n      .subtitle-deactivated {\n        color: var(--tertiary-600, #b42318);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 22px; /* 157.143% */\n        letter-spacing: -0.25px;\n        margin-bottom: 24px;\n      }\n\n      .title {\n        color: var(--secondary-on-surface, #98a2b3);\n      }\n\n      table td:first-child {\n        color: var(--secondary-on-surface, #98a2b3);\n      }\n\n      table td:last-child {\n        color: var(--secondary-dark, #101828);\n      }\n    }\n  }\n\n  &-person {\n    flex: 0 0 25%;\n    max-width: 25%;\n    width: 25%;\n\n    ul {\n      li {\n        display: flex;\n        align-items: center;\n        margin-bottom: 12px;\n        color: var(--secondary-text, #667085);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n        word-break: break-all;\n\n        strong {\n          color: var(--secondary-dark, #101828);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 28px;\n        }\n\n        a {\n          color: var(--primary-700, #6941c6);\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 24px;\n          text-decoration: none;\n        }\n\n        i {\n          opacity: 0.25;\n          font-size: 20px;\n        }\n\n        img {\n          width: 20px;\n          opacity: 0.25;\n        }\n\n        &:first-child {\n          color: var(--text-black-100, #202024);\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 22px; /* 137.5% */\n          letter-spacing: -0.25px;\n        }\n      }\n    }\n  }\n\n  &-file {\n    flex: 0 0 50%;\n    max-width: 50%;\n    width: 50%;\n\n    li {\n      margin-right: 16px;\n    }\n\n    .company-profile-file-add {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n      border-radius: 10px;\n      border: 1px dashed #cbd2e0;\n      padding: 10px;\n      color: #2d3648;\n      text-align: center;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 24px; /* 171.429% */\n      letter-spacing: -0.14px;\n      word-wrap: break-word;\n      width: 115px;\n      height: 115px;\n      cursor: pointer;\n      position: relative;\n      z-index: 1;\n\n      input {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 2;\n        opacity: 0;\n      }\n\n      i {\n        font-size: 24px;\n        margin-bottom: 10px;\n      }\n    }\n\n    .company-profile-file-item {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n      border-radius: 10px;\n      border: 1px solid #cbd2e0;\n      padding: 10px 25px;\n      color: #2d3648;\n      text-align: center;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 24px; /* 171.429% */\n      letter-spacing: -0.14px;\n      word-break: break-all;\n      width: 115px;\n      height: 115px;\n\n      i {\n        font-size: 24px;\n        margin-bottom: 10px;\n      }\n    }\n  }\n}\n\n.select-action-form-control {\n  .react-select__menu {\n    min-width: unset !important;\n  }\n}\n\n.user-group-profile-content {\n  display: flex;\n\n  .title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: var(--secondary-text, #667085);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    margin-bottom: 24px;\n\n    span {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .table-responsive {\n    padding-top: 0;\n\n    .icon-remove:before {\n      color: #ffb8b8;\n      cursor: pointer;\n    }\n  }\n\n  .user-group-content-users {\n    flex: 0 0 50%;\n    max-width: 50%;\n    width: 50%;\n    padding-right: 20px;\n  }\n\n  .user-group-content-permissions {\n    flex: 0 0 50%;\n    max-width: 50%;\n    width: 50%;\n    padding-left: 20px;\n\n    .item {\n      border-radius: 10px;\n      border: 1px solid var(--divider, #eaecf0);\n      background: var(--On-Primary, #fff);\n      box-shadow:\n        0 1px 2px 0 rgba(16, 24, 40, 0.06),\n        0 1px 3px 0 rgba(16, 24, 40, 0.1);\n      margin-bottom: 20px;\n      padding: 20px;\n\n      .item-title {\n        color: var(--primary-600, #7f56d9);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n        margin-bottom: 24px;\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        position: relative;\n        padding-right: 80px;\n\n        .dropdown {\n          position: absolute;\n          top: 0;\n          right: 0;\n        }\n      }\n\n      p {\n        color: var(--secondary-text, #667085);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        margin-bottom: 10px;\n      }\n\n      ul {\n        column-gap: 10px;\n        row-gap: 10px;\n      }\n\n      li {\n        color: var(--secondary-dark, #101828);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%; /* 21px */\n        letter-spacing: -0.14px;\n      }\n    }\n  }\n}\n\n.user-profile-header {\n  display: flex;\n  align-items: center;\n\n  .avatar {\n    width: 48px;\n    height: 48px;\n    font-size: 18px;\n    margin-right: 12px;\n  }\n\n  .company-profile-title {\n    margin-bottom: 0;\n    font-size: 24px;\n  }\n\n  .company-profile-subtitle {\n    color: var(--text-grey-50, #85878f);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 26px; /* 162.5% */\n    letter-spacing: -0.13px;\n  }\n}\n\n.export-pdf {\n  padding-left: 178px;\n  padding-top: 26px;\n\n  .export-pdf-action {\n    display: flex;\n    padding-top: 16px;\n  }\n\n  .export-pdf-item {\n    display: flex;\n    margin-bottom: 16px;\n\n    .form-item {\n      margin-bottom: 16px;\n\n      .d-flex {\n        width: 100%;\n      }\n\n      .form-item-mail {\n        max-width: calc(100% - 34px);\n        width: 100%;\n      }\n\n      .btn-icon {\n        margin-left: 18px;\n\n        i:before {\n          color: rgba(180, 35, 24, 1);\n        }\n      }\n    }\n\n    .export-pdf-item-inputs {\n      max-width: 380px;\n      width: 100%;\n      position: relative;\n\n      &.export-pdf-item-inputs-checkbox {\n        display: flex;\n        align-items: center;\n\n        .form-error {\n          position: absolute;\n          top: calc(100% - 24px);\n          left: 0;\n        }\n\n        .form-control-checkbox {\n          margin-right: 76px;\n\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n      }\n    }\n\n    .export-pdf-item-label {\n      max-width: 471px;\n      width: 100%;\n      margin-right: 24px;\n\n      h3 {\n        color: var(--Secondary-eading, #101828);\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        margin-bottom: 12px;\n      }\n\n      p {\n        color: var(--Secondary-Text, #667085);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 21px;\n      }\n    }\n  }\n}\n\n.user-profile-tab {\n  .react-tabs__tab-panel {\n    padding: 30px 0;\n  }\n\n  .library {\n    padding: 0;\n  }\n\n  .company-profile-title {\n    color: var(--secondary-text, #667085);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    letter-spacing: -0.16px;\n  }\n\n  .user-profile-tab-content {\n    display: flex;\n    flex-wrap: wrap;\n    border-bottom: 1px solid #cbd2e0;\n    padding-bottom: 30px;\n    margin-bottom: 30px;\n\n    &-auto {\n      column-gap: 80px;\n    }\n\n    &:last-child {\n      border-bottom: 0;\n      margin-bottom: 0;\n    }\n  }\n\n  .user-profile-tab-user-group {\n    flex: 0 0 50%;\n    max-width: 50%;\n    width: 50%;\n    display: flex;\n\n    & > div {\n      padding-right: 20px;\n\n      &:first-child {\n        min-width: 120px;\n      }\n    }\n\n    .title {\n      color: rgba(45, 54, 72, 0.5);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%; /* 21px */\n      letter-spacing: -0.14px;\n      margin-bottom: 8px;\n    }\n\n    p {\n      margin-bottom: 8px;\n    }\n\n    .show-more {\n      color: var(--primary-600, #7f56d9);\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px;\n    }\n  }\n\n  .user-profile-tab-item {\n    flex: 0 0 25%;\n    max-width: 25%;\n    width: 25%;\n    padding-right: 15px;\n\n    &.user-profile-tab-item-auto {\n      flex: 0 0 auto;\n      max-width: 100%;\n      width: auto;\n    }\n\n    .title {\n      color: rgba(45, 54, 72, 0.5);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%; /* 21px */\n      letter-spacing: -0.14px;\n      margin-bottom: 8px;\n    }\n\n    p {\n      color: var(--secondary-dark, #101828);\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n      margin-bottom: 8px;\n      min-height: 20px;\n      word-break: break-word;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n.empty-page {\n  text-align: center;\n  margin-top: 60px;\n  &-title {\n    color: var(--secondary-dark, #101828);\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    margin-bottom: 8px;\n  }\n  &-subtitle {\n    color: var(--secondary-text, #667085);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 21px */\n    letter-spacing: -0.14px;\n    max-width: 538px;\n    margin: 0 auto 60px;\n  }\n}\n\n.page-wrapper.page-wrapper-deactivated {\n  background: var(--secondary-surface, #f9fafb);\n\n  .company-profile-title {\n    color: var(--secondary-on-surface, #98a2b3);\n  }\n\n  .date-add-deactivated {\n    color: var(--tertiary-600, #b42318);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 21px */\n    letter-spacing: -0.14px;\n    margin-left: 15px;\n  }\n\n  .form-control,\n  .form-control-file,\n  .company-profile-tab .btn {\n    pointer-events: none !important;\n  }\n}\n\n.empty-table {\n  text-align: center;\n  height: 138px;\n  display: table-row;\n  position: relative;\n\n  & > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 138px;\n    width: 100%;\n    padding: 40px;\n  }\n\n  p {\n    margin-bottom: 8px;\n    color: var(--secondary-text, #667085);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 21px */\n    letter-spacing: -0.14px;\n    text-align: center;\n\n    strong {\n      color: var(--secondary-dark, #101828);\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n    }\n  }\n}\n\n.empty-action {\n  box-shadow:\n    0 1px 2px 0 rgba(16, 24, 40, 0.06),\n    0 1px 3px 0 rgba(16, 24, 40, 0.1);\n  border: 1px solid var(--divider, #eaecf0);\n  border-radius: 8px;\n  height: 186px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n\n  p {\n    margin-bottom: 8px;\n    color: var(--secondary-text, #667085);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 21px */\n    letter-spacing: -0.14px;\n    text-align: center;\n\n    strong {\n      color: var(--secondary-dark, #101828);\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n    }\n  }\n}\n\n.special {\n  color: var(--primary-600, #7f56d9);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  margin-left: 20px;\n  line-height: 150%;\n  border-radius: 56px;\n  background: var(--primary-50, #f9f5ff);\n  padding: 4px 12px;\n}\n\n.company-profile-empty {\n  border-radius: 10px;\n  border: 1px solid var(--divider, #eaecf0);\n  background: var(--On-Primary, #fff);\n  box-shadow:\n    0 1px 2px 0 rgba(16, 24, 40, 0.06),\n    0 1px 3px 0 rgba(16, 24, 40, 0.1);\n  padding: 45px 20px;\n\n  h3 {\n    color: var(--secondary-eading, #101828);\n    text-align: center;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    max-width: 350px;\n    margin: 0 auto 12px;\n  }\n\n  p {\n    color: var(--secondary-text, #667085);\n    text-align: center;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 21px;\n    margin: 0 auto;\n    max-width: 350px;\n  }\n}\n",".react-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 12px 164px;\n\n  .previous,\n  .next {\n    position: absolute;\n    left: 24px;\n    top: 50%;\n    transform: translateY(-50%);\n\n    a {\n      border-radius: 8px;\n      border: 1px solid var(--divider, #EAECF0);\n      background: var(--on-primary, #FFF);\n      box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n      padding: 9px 14px;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 20px;\n      color: #101828;\n      cursor: pointer;\n    }\n\n    &.disabled a {\n      pointer-events: none;\n      opacity: 0.5;\n    }\n  }\n\n  .next {\n    right: 24px;\n    left: auto;\n  }\n\n  li:not(.previous):not(.next) {\n    a {\n      width: 40px;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #667085;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 20px;\n      border-radius: 8px;\n      cursor: pointer;\n    }\n\n    &.selected a {\n      color: #7F56D9;\n      background: var(--primary-50, #F9F5FF);\n    }\n\n    &.active a {\n      color: #7F56D9;\n      background: var(--primary-50, #F9F5FF);\n    }\n  }\n}",".dropdown {\n  position: relative;\n\n  .dropdown-menu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    border-radius: var(--corner-radius-main, 8px);\n    background: var(--on-primary, #FFF);\n    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.10);\n    padding: 16px;\n    min-width: 116px;\n    z-index: 99;\n  }\n\n  li {\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n",".react-datepicker-popper .react-datepicker {\n  border-radius: var(--Corner-radius-main, 8px);\n  background: var(--On-Primary, #fff);\n  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);\n  border: 0;\n  padding: 12px;\n\n  .react-datepicker__navigation--previous {\n    right: 56px;\n    left: auto;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 20px;\n  }\n\n  .react-datepicker__header {\n    padding: 0;\n    background-color: #fff;\n    border-bottom: 0;\n    margin: 0;\n\n    .react-datepicker__current-month {\n      text-align: left;\n      padding: 14px 16px;\n      color: var(--secondary-eading, #101828);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px; /* 142.857% */\n      letter-spacing: 0.1px;\n    }\n  }\n\n  .react-datepicker__triangle {\n    display: none;\n  }\n\n  .react-datepicker__day--today,\n  .react-datepicker__day--keyboard-selected.react-datepicker__day--today {\n    background: var(--Primary-100, #f4ebff);\n  }\n  .react-datepicker__day--keyboard-selected {\n    background: transparent;\n  }\n\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow,\n  .react-datepicker__navigation-icon::before {\n    border-color: #101828;\n    border-width: 2px 2px 0 0;\n    top: 10px;\n    border-radius: 0 0 0 2px;\n  }\n\n  .react-datepicker__navigation {\n    top: 15px;\n  }\n\n  .react-datepicker__day-name {\n    width: 48px;\n    height: 48px;\n    margin: 0;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .react-datepicker__day {\n    width: 48px;\n    height: 48px;\n    margin: 0;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 100%;\n    color: var(--secondary-eading, #101828);\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px; /* 150% */\n    letter-spacing: 0.5px;\n    border: 1px solid transparent;\n\n    &.react-datepicker__day--disabled {\n      pointer-events: none;\n      opacity: 0.5;\n    }\n\n    &.react-datepicker__day--selected,\n    &.react-datepicker__day--in-range {\n      color: #7f56d9;\n      border: 1px solid #7f56d9;\n      background: transparent;\n    }\n\n    &:hover,\n    &.react-datepicker__day--in-selecting-range {\n      color: var(--On-Primary, #fff);\n      background: var(--primary-600, #7f56d9);\n    }\n  }\n\n  .react-datepicker__month {\n    margin: 10px 0 0;\n  }\n}\n\n.react-datepicker-wrapper {\n  .react-datepicker__close-icon {\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    right: 12px;\n    top: 10px;\n    z-index: 3;\n\n    &::after {\n      background: url('../../images/x-circle.svg') no-repeat center center;\n      z-index: -1;\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.react-datepicker-popper {\n  z-index: 99 !important;\n}\n\n.time-select {\n  margin: 0 -15px;\n  .form-item {\n    width: 50%;\n    padding: 0 15px;\n  }\n}\n\n.form-item-time {\n  .react-datepicker__tab-loop {\n    position: relative;\n  }\n\n  .react-datepicker-popper {\n    width: 100%;\n\n    .react-datepicker {\n      width: 100%;\n      padding: 0;\n    }\n\n    .react-datepicker__time-container {\n      width: 100%;\n\n      .react-datepicker__time .react-datepicker__time-box {\n        width: 100%;\n        border-radius: 0 0 6px 6px;\n        padding: 5px 0;\n\n        ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n          width: 100%;\n          position: relative;\n          background: var(--primary-50, #fff);\n          color: var(--secondary-dark, #101828);\n          font-feature-settings: 'calt' off;\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 150%;\n          padding-left: 50px;\n          height: 44px;\n          margin-bottom: 0;\n\n          &:hover {\n            background: var(--primary-50, #f9f5ff);\n          }\n\n          &::before {\n            content: '';\n            position: absolute;\n            left: 15px;\n            top: 9px;\n            width: 20px;\n            height: 20px;\n            border-radius: 100%;\n            border: 1px solid var(--secondary-base, #cbd2e0);\n            background: var(--On-Primary, #fff);\n          }\n\n          &.react-datepicker__time-list-item--selected {\n            color: var(--secondary-dark, #101828);\n\n            &::before {\n              border: 1px solid var(--primary-600, #7f56d9);\n            }\n\n            &::after {\n              content: '';\n              border-radius: 100%;\n              width: 14px;\n              height: 14px;\n              position: absolute;\n              left: 19px;\n              top: 13px;\n              background: #7f56d9;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.multi-date-picker {\n  .rmdp-container {\n    width: 100%;\n    position: relative;\n  }\n\n  .rmdp-ep-arrow {\n    display: none;\n  }\n\n  .rmdp-day,\n  .rmdp-week-day {\n    width: 48px;\n    height: 48px;\n    margin: 0;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 100%;\n    color: var(--secondary-eading, #101828);\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px; /* 150% */\n    letter-spacing: 0.5px;\n    border: 1px solid transparent;\n  }\n\n  .rmdp-arrow {\n    border: solid #7f56d9;\n    border-width: 0 2px 2px 0;\n    width: 10px;\n    height: 10px;\n    margin-top: -3px;\n  }\n\n  .rmdp-header-values span {\n    color: var(--secondary-eading, #101828);\n    text-align: center;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px; /* 142.857% */\n    letter-spacing: 0.1px;\n  }\n\n  .rmdp-arrow-container:hover .rmdp-arrow {\n    border: solid #7f56d9;\n    border-width: 0 2px 2px 0;\n  }\n\n  .rmdp-left i {\n    margin-top: 7px;\n    margin-left: 1px;\n  }\n\n  .rmdp-right i {\n    margin-top: 7px;\n    margin-right: 2px;\n  }\n\n  .rmdp-arrow-container:hover {\n    background-color: transparent;\n    box-shadow: none;\n  }\n\n  .rmdp-day.rmdp-selected span:not(.highlight) {\n    color: #fff;\n    border: 1px solid #7f56d9;\n    background: #7f56d9;\n  }\n\n  .rmdp-day:not(.rmdp-disabled, .rmdp-day-hidden) span:hover {\n    border: 1px solid #7f56d9;\n    background: #7f56d9;\n  }\n\n  .rmdp-day.rmdp-today span {\n    color: var(--secondary-eading, #101828);\n    background: var(--Primary-100, #f4ebff);\n  }\n\n  .rmdp-header-value {\n    margin: 0;\n  }\n\n  .rmdp-input {\n    border-radius: 6px;\n    border: 1px solid var(--wf-base-400, #cbd2e0);\n    background: var(--wf-base-white, #fff);\n    height: 44px;\n    padding: 12px 12px 12px 16px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    letter-spacing: -0.14px;\n    color: #2d3648;\n    width: 100%;\n\n    &::placeholder {\n      color: #98a2b3;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%; /* 24px */\n      letter-spacing: -0.16px;\n      opacity: 0.5;\n    }\n  }\n\n  &.disabled-change-month {\n    .rmdp-header {\n      display: none;\n    }\n\n    .rmdp-day-picker {\n      .rmdp-week:first-child {\n        display: none !important;\n      }\n    }\n  }\n}\n\n.form-item-time.form-item-time-short\n  .react-datepicker-popper\n  .react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item {\n  &:nth-child(1),\n  &:nth-child(2),\n  &:nth-child(3),\n  &:nth-child(4),\n  &:nth-child(5),\n  &:nth-child(6),\n  &:nth-child(8),\n  &:nth-child(10),\n  &:nth-child(12),\n  &:nth-child(14),\n  &:nth-child(16),\n  &:nth-child(18),\n  &:nth-child(20) {\n    display: none !important;\n  }\n}\n\n.multi-date-picker .clear-datepicker {\n  position: relative;\n\n  .rmdp-input {\n    padding: 12px 53px 12px 16px;\n  }\n\n  .clear {\n    position: absolute;\n    top: 11px;\n    right: 3px;\n    background: transparent;\n    border: 0;\n    z-index: 2;\n    opacity: 0.5;\n  }\n}\n","$m-02: #7F56D9;\n$m-02--dark-01: #03772c;\n$m-02--light-01: #9ad67a;\n$m-02--light-02: #c0eba8;\n\n$neu-07: #666a76;\n\n.loader {\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0, 0.90);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999999;\n\n  &__content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  &__item {\n    width: 140px;\n    height: 12px;\n    display: flex;\n    background-color: white;\n    border-radius: 0;\n    position: relative;\n    overflow: hidden;\n    box-shadow: inset 0 0 0 2px $m-02,\n    0 3px 9px -2px rgba(0, 48, 135, 0.4);\n    z-index: 1;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      background-color: $m-02;\n      border-radius: inherit;\n      animation: loading 3s cubic-bezier(0.57, 0.48, 0.21, 1.23) infinite;\n      @keyframes loading {\n        0% {\n          width: 16px;\n          left: 0;\n        }\n        25% {\n          width: 100%;\n          left: 0;\n        }\n        50% {\n          width: 16px;\n          left: calc(100% - 16px);\n        }\n        75% {\n          width: 100%;\n          left: 0;\n        }\n        100% {\n          width: 16px;\n          left: 0;\n        }\n      }\n    }\n  }\n\n  &__text {\n    margin-top: 24px;\n    font-size: 16px;\n    line-height: 26px;\n    letter-spacing: 0.2px;\n    color: $neu-07;\n    animation: text 3s cubic-bezier(0.57, 0.48, 0.21, 1.23) infinite;\n    @keyframes text {\n      0% {\n        opacity: 0.1;\n      }\n\n      50% {\n        opacity: 1;\n      }\n\n      100% {\n        opacity: 0.1;\n      }\n    }\n  }\n}\n",".old-home-page {\n  min-height: 100vh;\n  padding: 25px 16px;\n\n  @media screen and (min-width: 992px) {\n    padding: 17px 65px 65px;\n  }\n\n  .home-wrapper {\n    margin: 0 auto;\n    max-width: 1789px;\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    @media screen and (max-width: 700px) {\n      justify-content: center;\n    }\n  }\n\n  .home-contact {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    column-gap: 57px;\n\n    @media screen and (max-width: 700px) {\n      order: 2;\n      display: block;\n\n      a {\n        display: block;\n        margin-bottom: 12px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    a {\n      color: #01051f;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px;\n      text-decoration: none;\n    }\n  }\n\n  .home-logo {\n    display: flex;\n    align-items: center;\n\n    img {\n      max-height: 40px;\n    }\n  }\n\n  .home-content {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n    margin-top: 12px;\n    border-radius: 45px;\n    background: url('../../images/home-bg.png') no-repeat bottom center;\n    text-align: center;\n    min-height: calc(100vh - 200px);\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    background-size: cover;\n\n    @media screen and (max-width: 700px) {\n      margin-top: 25px;\n      margin-bottom: 25px;\n      padding: 116px 0;\n    }\n\n    @media screen and (min-width: 768px) {\n      min-height: calc(100vh - 103px);\n      padding: 116px 0;\n    }\n\n    @media screen and (min-width: 992px) {\n      padding-top: 225px;\n      display: block;\n      min-height: calc(100vh - 130px);\n    }\n\n    h1 {\n      color: #fff;\n      font-family: Inter;\n      font-size: 30px;\n      font-style: normal;\n      font-weight: 800;\n      line-height: 110%; /* 41.8px */\n      text-transform: capitalize;\n      margin: 0;\n\n      @media screen and (max-width: 700px) {\n        font-size: 24px;\n        max-width: 300px;\n      }\n\n      @media screen and (min-width: 992px) {\n        font-size: 38px;\n      }\n    }\n\n    p {\n      color: #fff;\n      font-family: Inter;\n      font-size: 27px;\n      font-style: italic;\n      font-weight: 200;\n      line-height: 120%; /* 38.4px */\n      letter-spacing: -0.32px;\n      text-transform: uppercase;\n      margin: 8px 0;\n\n      @media screen and (max-width: 700px) {\n        font-size: 18px;\n      }\n\n      @media screen and (min-width: 992px) {\n        font-size: 32px;\n      }\n    }\n\n    h2 {\n      color: #fff;\n      font-family: Inter;\n      font-size: 30px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 120%; /* 45.6px */\n      letter-spacing: -0.38px;\n      text-transform: capitalize;\n      margin-bottom: 40px;\n\n      @media screen and (max-width: 700px) {\n        font-size: 16px;\n        max-width: 201px;\n      }\n\n      @media screen and (min-width: 992px) {\n        font-size: 38px;\n      }\n    }\n\n    .btn {\n      color: #16038f;\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px;\n      border-radius: var(--Corner-radius-main, 8px);\n      background: #fff;\n      box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n      min-width: 201px;\n      border: 0;\n      display: inline-block;\n    }\n  }\n}\n",".init-form-tab-content {\n  .form-builder-element-preview {\n    &.with-aside-settings {\n      width: calc(100% + 80px);\n      max-width: initial;\n\n      &:hover {\n        .init-form-aside-buttons {\n          display: flex;\n        }\n      }\n\n      .element-wrapper,\n      .link-element-wrapper {\n        position: relative;\n\n        .element-inner {\n          width: calc(100% - 80px);\n        }\n      }\n    }\n  }\n}\n\n.checkbox-element-settings-modal {\n  .form-control-item {\n    display: flex;\n    gap: 16px;\n    margin-top: 16px;\n    align-items: center;\n  }\n}\n\n.init-form-aside-buttons {\n  top: 50%;\n  left: calc(100% - 48px);\n  //display: flex;\n  display: none;\n  gap: 8px;\n  flex-direction: column;\n  position: absolute;\n  transform: translateY(-50%);\n  z-index: 1;\n\n  .btn-settings {\n    width: 38px;\n    height: 38px;\n    display: inline-flex;\n    font-size: 20px;\n    align-items: center;\n    justify-content: center;\n    background-color: #fff;\n    border: 1px solid var(--secondary-input-outline, #DADEE4);\n    cursor: pointer;\n\n    .icon-settings {\n      font-size: 20px;\n      color: var(--wf-base-600, #717D96);\n    }\n\n    &.btn-remove {\n      border: 1px solid var(--secondary-input-outline, #FDA29B);\n    }\n  }\n}",".tasks-wrapper {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr)); // Prevent columns from expanding beyond the grid setup\n  grid-gap: 20px;\n  max-width: 100%; // Constrain the grid to 100% width of its container\n\n  @media screen and (min-width: $breakpoint-xxl) {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  @media screen and (max-width: $breakpoint-lg) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  @media screen and (max-width: $breakpoint-md) {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n}\n",".library-sub-title-index-mobile,\n.library-title-index-mobile,\n.btn-mobile,\n.mobile-button,\n.tabs-mobile,\n.library-title-mobile {\n  display: none;\n}\n\n.sigCanvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.sigCanvas-wrapper {\n  position: relative;\n  height: 150px;\n}\n\n.btn-mobile {\n  display: none !important;\n}\n\n.send-form-wrapper-mobile {\n  display: none;\n}\n\n@media (max-width: 650px) {\n  .ReactModal__Overlay .modal-default.modal-number {\n    max-width: 300px;\n  }\n}\n\n.mobile {\n  .send-form-wrapper-mobile {\n    margin-top: 35px;\n    padding: 0 24px;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .library-item .library-item-text {\n    font-size: 16px;\n  }\n\n  .btn-notification {\n    display: none;\n  }\n\n  .mobile-button {\n    display: block;\n  }\n\n  .sidebar-menu {\n    display: none;\n  }\n\n  .form-builder-wrapper main.send-page {\n    padding: 0;\n    background: #fff;\n  }\n\n  .send-form-wrapper {\n    display: none;\n  }\n\n  .render-form {\n    border-radius: 0;\n    border: 0;\n    padding-bottom: 80px;\n    box-shadow: none;\n\n    &__copy-group {\n      padding-bottom: 24px;\n\n      &__actions {\n        display: flex;\n        justify-content: flex-end;\n      }\n\n      &__remove-btn {\n        width: auto;\n        margin-top: 24px;\n        margin-left: 24px;\n        margin-right: 24px;\n        padding-left: 8px;\n        padding-right: 8px;\n        transform: none;\n        position: static;\n        .label {\n          display: initial;\n          margin-left: 6px;\n        }\n      }\n    }\n  }\n\n  .btn-mobile {\n    display: block !important;\n  }\n\n  .send-page {\n    .form-control-actions .btn:not(.btn-mobile) {\n      display: none;\n    }\n  }\n\n  // .from-builder-title h1 {\n  //   white-space: nowrap;\n  //   text-overflow: ellipsis;\n  //   overflow: hidden;\n  // }\n\n  .library {\n    padding: 0 24px 24px;\n  }\n\n  .form-builder-wrapper main.send-page .render-form,\n  .form-builder-wrapper main.send-page > div {\n    max-width: 100%;\n  }\n\n  .form-builder-wrapper main.send-page .form-control-actions {\n    position: fixed;\n    left: 0;\n    width: 100%;\n    padding: 16px 24px;\n    justify-content: space-between;\n  }\n\n  .from-builder-title {\n    padding: 16px 24px;\n  }\n\n  .form-builder-wrapper main.form-builder-wrapper-settings {\n    padding-left: 0;\n\n    .mobile-init {\n      .render-form {\n        min-height: calc(100vh - 146px);\n        padding-top: 24px;\n        //margin-top: 68px;\n      }\n\n      .form-view-actions {\n        display: flex;\n        justify-content: space-between;\n\n        .btn.btn-outline {\n          display: inline-flex !important;\n          align-items: center;\n        }\n      }\n\n      .form-builder-aside-left {\n        display: none;\n      }\n\n      .init-form-tab-content {\n        padding: 0;\n      }\n\n      .form-control-actions {\n        display: none;\n      }\n\n      .form-view-wrapper {\n        width: 100%;\n      }\n    }\n  }\n\n  //.library-available-to-me {\n  //  .forms {\n  //    .library-item {\n  //      pointer-events: none;\n  //    }\n  //  }\n  //}\n\n  .library-item-disabled-mobile {\n    filter: grayscale(100%);\n    pointer-events: none;\n  }\n\n  .tabs-mobile {\n    display: flex;\n  }\n\n  .form-builder-wrapper main.default-layout {\n    padding-left: 0;\n  }\n\n  .react-tabs__tab-list {\n    display: none;\n  }\n\n  .header-left {\n    display: none;\n  }\n\n  .header-right {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .user-menu-wrapper {\n    pointer-events: none;\n  }\n\n  .breadcrumbs {\n    display: none;\n  }\n\n  .library-title {\n    display: none;\n  }\n\n  .library-filter {\n    margin-top: 0;\n\n    .btn.btn-outline {\n      height: 44px;\n    }\n\n    .btn.btn-outline.btn-down {\n      transform: translateY(0px);\n    }\n  }\n\n  .library-item {\n    &:not(.list-item) {\n      margin: 0;\n      @media screen and (min-width: 540px) {\n        max-width: calc(50% - 8px);\n        flex: 0 0 calc(50% - 8px);\n      }\n      @media screen and (min-width: 1000px) {\n        flex: 0 0 calc(33.3333% - 11px);\n        max-width: calc(33.3333% - 11px);\n      }\n    }\n\n    img {\n      -webkit-touch-callout: none; /* Safari iOS */\n      user-select: none;\n    }\n\n    &.submissions {\n      display: none;\n    }\n\n    &.drafts {\n      display: none;\n    }\n  }\n\n  .library-item .library-item-button {\n    display: none;\n  }\n\n  .library-filter {\n    .btn:not(.btn-down) {\n      display: none;\n    }\n  }\n\n  .library-wrapper {\n    gap: 16px;\n    margin: 0;\n  }\n\n  .library-title-index-mobile {\n    color: var(--Secondary-eading, #101828);\n    font-family: Inter;\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n    margin-bottom: 16px;\n    margin-top: 16px;\n    display: block;\n  }\n\n  .library-sub-title-index-mobile {\n    display: block;\n    color: var(--Secondary-Text, #667085);\n    /* button text */\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    margin-top: 16px;\n  }\n\n  .library-title-mobile {\n    color: var(--Secondary-eading, #101828);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n    margin-bottom: 24px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .tabs-mobile-item {\n    flex: 1 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--Secondary-eading, #101828);\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    padding: 16px 0;\n    position: relative;\n    margin-bottom: 24px;\n\n    &::before {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 100%;\n      left: 0;\n      width: 100%;\n      height: 2px;\n      background: #6941c6;\n      transform: scale(0);\n    }\n\n    &.active {\n      color: var(--Primary-700, #6941c6);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px;\n\n      &::before {\n        transform: scale(1);\n      }\n    }\n  }\n\n  .login-page {\n    padding: 100px 24px;\n  }\n\n  .modal-default {\n    .login-page {\n      padding: 0;\n    }\n\n    .login-page-wrapper {\n      padding-top: 40px;\n    }\n  }\n\n  .login-page-wrapper {\n    padding-top: 0;\n  }\n\n  .sigCanvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .sigCanvas-wrapper {\n    position: relative;\n    width: 270px;\n    height: 150px;\n  }\n\n  .header-wrapper-login {\n    display: none;\n  }\n\n  @media (max-width: 750px) {\n    .form-control-radio-wrapper,\n    .form-control-checkbox-wrapper {\n      display: block;\n    }\n\n    .form-grid-item {\n      margin-bottom: 32px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    .form-builder-element-preview {\n      padding: 16px 24px;\n    }\n\n    .form-grid-full-name {\n      display: block;\n    }\n\n    .form-control-medium,\n    .react-ios-time-picker-input-medium,\n    .form-label-medium .form-label,\n    .init-page .render-form .form-builder-element-preview-wrapper .form-control-radio {\n      width: 100% !important;\n    }\n  }\n\n  // .render-form {\n  //   padding-top: 80px;\n  // }\n\n  .from-builder-title {\n    padding-right: 60px;\n    border-bottom: 1px solid #eaecf0;\n    border-radius: 0;\n    position: relative;\n    top: 0;\n    width: 100%;\n    background: #fff;\n    z-index: 9;\n\n    .btn-icon {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 24px;\n    }\n  }\n\n  @media screen and (max-width: 575px) {\n    .library-item {\n      flex: 0 0 100%;\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n\n  .init-form-action {\n    display: none;\n  }\n\n  // .form-view-wrapper {\n  //   margin-top: 47px;\n  // }\n}\n\n.tablet,\n.mobile {\n  .form-builder-wrapper {\n    overflow: unset;\n  }\n\n  .header-container {\n    justify-content: space-between !important;\n  }\n\n  .react-tabs {\n    display: block !important;\n\n    &__tab-list {\n      display: flex !important;\n    }\n  }\n\n  .page-wrapper.cna-assignments,\n  .page-wrapper.default-tasks {\n    padding-top: 0;\n  }\n\n  .page-wrapper.default-tasks {\n    .library-filter {\n      margin-top: 29px;\n    }\n\n    .open-add-task-modal-btn {\n      display: inline-flex;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
